import type { Brand } from '@seek/audience-zones';
import type { CountryCodeIso2 } from '@seek/scalars';
import type { LanguageCodeIso } from '@seek/scalars';
import type { Zone } from '@seek/audience-zones';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A string encoded in Base64URL */
  Base64Url: { input: string; output: string; }
  /** A string that corresponds to one of the company brands like seek, jora etc */
  Brand: { input: Brand; output: Brand; }
  /** A string that corresponds to company id */
  CompanyId: { input: any; output: any; }
  /** A string that corresponds to a country code from the [alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) set of country codes defined in the [ISO 3166 standard](https://en.wikipedia.org/wiki/ISO_3166). Example: `AU`. */
  CountryCodeIso2: { input: CountryCodeIso2; output: CountryCodeIso2; }
  /** A string that corresponds to an alphabetic currency code defined in the [ISO 4217 standard](https://en.wikipedia.org/wiki/ISO_4217). Example: `AUD`. */
  CurrencyCodeIso: { input: string; output: string; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: Date; output: Date; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string; }
  /** A string representing an email address. Emails are validated against this [regex](https://github.com/SEEK-Jobs/validators-js/blob/master/src/validators/emailFormat/emailFormat.ts#L1). Example: `test@example.com`. */
  Email: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, any> | string | number | boolean; output: Record<string, any> | string | number | boolean; }
  /** A string that corresponds to a job search query. */
  JobSearchQueryString: { input: string; output: string; }
  /** A string that corresponds to a language code defined in the [ISO 639-1 standard](https://en.wikipedia.org/wiki/ISO_639-1). Example: `en`. */
  LanguageCodeIso: { input: LanguageCodeIso; output: LanguageCodeIso; }
  /** ISO-639-1 language codes and ISO-3166-1-alpha-2 country codes, separated by '-' */
  Locale: { input: string; output: string; }
  /** The `PositiveInt` scalar type represents non-fractional unsigned whole numeric values with a value greater than 0. */
  PositiveInt: { input: number; output: number; }
  /** A string that represents a profile visibility level. Valid values are: "Public", "Standard", "Limited", "Hidden". */
  ProfileVisibilityLevel: { input: string; output: string; }
  RecommendedJobsWorkArrangementOption: { input: any; output: any; }
  RecommendedJobsWorkTypeOption: { input: any; output: any; }
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: { input: number; output: number; }
  /** Used to determine which smarter search cluster (URL) to use, valid values: default, ph-launch, end-state-launch */
  SmarterSearchCluster: { input: string; output: string; }
  /** A string that corresponds to an IANA timezone ID defined in the [IANA Time Zone Database](https://www.iana.org/time-zones). Example: `Australia/Melbourne`. */
  Timezone: { input: string; output: string; }
  /** A string representing a UUID. UUIDs are validated against this [regex](https://github.com/SEEK-Jobs/validators-js/blob/master/src/validators/uuid/isUuid.ts#L9). *Note:* The validation regex used does *not* conform to the UUID specification defined in [RFC 4122](https://tools.ietf.org/html/rfc4122), it is intentionally broader. Example: `f81d4fae-7dec-11d0-a765-00a0c91e6bf6`. */
  UUID: { input: string; output: string; }
  /** A string that corresponds to a SEEK zone defined in [RFC034](https://github.com/SEEK-Jobs/rfc/blob/master/RFC034-Audience-Zone-Identifiers.md). */
  Zone: { input: Zone; output: Zone; }
};

export type AccountBlockedError = I18nAccountError & {
  message: Scalars['String']['output'];
  code: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};


export type AccountBlockedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type AccountStatus = {
  hirer: AccountStatusType;
  candidate: AccountStatusType;
  realmHint: Scalars['String']['output'];
};

export enum AccountStatusType {
  Found = 'found',
  NotFound = 'notFound'
}

export type AccountValidationError = I18nAccountError & {
  message: Scalars['String']['output'];
  code: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  details: Array<I18nAccountFieldError>;
};


export type AccountValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type Actor = {
  /** The Auth0 user id of the actor, eg 'samlp|seek-okta-global|tkilvington@seek.com.au'. */
  id: Scalars['String']['output'];
  /** Email address of the actor. */
  email: Scalars['String']['output'];
};

export type AddSeekMaxCertificateToSeekPassError = {
  message: Scalars['String']['output'];
};


export type AddSeekMaxCertificateToSeekPassErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type AddSeekMaxCertificateToSeekPassFailure = {
  errors: Array<AddSeekMaxCertificateToSeekPassError>;
};

export type AddSeekMaxCertificateToSeekPassInput = {
  id: Scalars['ID']['input'];
};

export type AddSeekMaxCertificateToSeekPassPayload = AddSeekMaxCertificateToSeekPassSuccess | AddSeekMaxCertificateToSeekPassFailure;

export type AddSeekMaxCertificateToSeekPassSuccess = {
  redirectUri: Scalars['String']['output'];
};

export type Advertiser = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  isVerified: Maybe<Scalars['Boolean']['output']>;
  registrationDate: Maybe<SeekDateTime>;
};


export type AdvertiserNameArgs = {
  locale?: Scalars['Locale']['input'];
};

export type AdvertiserS = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum AlertType {
  Promote = 'Promote',
  Info = 'Info'
}

export type AnswerForQuestionInput = {
  id: InputMaybe<Scalars['String']['input']>;
  uri: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type ApacSavedSearch = {
  id: Scalars['ID']['output'];
  /** Display count for saved search (max 99+) */
  countLabel: Scalars['String']['output'];
  newToYouCountLabel: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  modifiedDate: Maybe<SeekDateTime>;
  createdDate: SeekDateTime;
  lastExecutionDate: Maybe<SeekDateTime>;
  subscribeToNewJobs: Scalars['Boolean']['output'];
  query: SavedSearchApacQuery;
};


export type ApacSavedSearchCountLabelArgs = {
  cluster: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
};


export type ApacSavedSearchNameArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type ApacSavedSearchQueryArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type ApacSavedSearchConnection = {
  pageInfo: PageInfo;
  edges: Array<ApacSavedSearchEdge>;
};

export type ApacSavedSearchEdge = {
  node: ApacSavedSearch;
  cursor: Scalars['String']['output'];
};

export type ApplicantCount = JobInsight & {
  count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  countLabel: Maybe<Scalars['String']['output']>;
  volumeLabel: Maybe<Scalars['String']['output']>;
};


export type ApplicantCountMessageArgs = {
  locale: Scalars['Locale']['input'];
};


export type ApplicantCountCountLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type ApplicantCountVolumeLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicantsWithCoverLetterPercentage = JobInsight & {
  percentage: Scalars['Float']['output'];
  message: Scalars['String']['output'];
};


export type ApplicantsWithCoverLetterPercentageMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicantsWithResumePercentage = JobInsight & {
  percentage: Scalars['Float']['output'];
  message: Scalars['String']['output'];
};


export type ApplicantsWithResumePercentageMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicationChannel = {
  label: Maybe<Scalars['String']['output']>;
};


export type ApplicationChannelLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicationContextInput = {
  /** client generated */
  key: Scalars['UUID']['input'];
  /** application bundleId */
  namespace: InputMaybe<Scalars['String']['input']>;
  version: InputMaybe<Scalars['String']['input']>;
  build: InputMaybe<Scalars['String']['input']>;
  channel: InputMaybe<Platform>;
};

export type ApplicationDocuments = {
  lastAppliedResumeIdPrefill: Maybe<Scalars['String']['output']>;
  selectionCriteriaRequired: Scalars['Boolean']['output'];
  lastWrittenCoverLetter: Maybe<LastWrittenCoverLetter>;
};

export type ApplicationInsightsStatistic = {
  message: Scalars['String']['output'];
};


export type ApplicationInsightsStatisticMessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type ApplicationProfile = {
  name: Maybe<Scalars['String']['output']>;
};

export type ApplicationRestricted = ApplicationChannel & {
  label: Scalars['String']['output'];
};


export type ApplicationRestrictedLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type AppliedForRoleCount = ApplicationInsightsStatistic & {
  count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};


export type AppliedForRoleCountMessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type AppliedJob = {
  id: Scalars['String']['output'];
  /**
   * UNSTABLE! description: proposed standard description for an AppliedJob.
   * e.g. 'Visited employer’s application site' (for link-out)
   */
  label: Maybe<Scalars['String']['output']>;
  hasAppliedWithResume: Scalars['Boolean']['output'];
  hasAppliedWithCoverLetter: Scalars['Boolean']['output'];
  appliedAt: SeekDateTime;
  createdAt: SeekDateTime;
  isExternal: Scalars['Boolean']['output'];
  isPreferredApplicationEligible: Scalars['Boolean']['output'];
  isPreferredApplication: Scalars['Boolean']['output'];
  preferredApplicationMarkedAt: Maybe<SeekDateTime>;
  isActive: Scalars['Boolean']['output'];
  notes: Maybe<Scalars['String']['output']>;
  downloadLinks: Maybe<AppliedJobDownloadLinks>;
  documents: Maybe<AppliedJobDocuments>;
  job: Job;
  events: Array<AppliedJobEvent>;
  applicationInsights: Array<ApplicationInsightsStatistic>;
  applicationRequestId: Scalars['String']['output'];
};


export type AppliedJobLabelArgs = {
  locale: Scalars['Locale']['input'];
  length: AppliedJobLabelLength;
};

export type AppliedJobConnection = {
  pageInfo: PageInfo;
  edges: Array<AppliedJobEdge>;
};

export type AppliedJobDocuments = {
  resume: Maybe<ResumeAppliedJobDocument>;
  coverLetter: Maybe<CoverLetterAppliedJobDocument>;
};

export type AppliedJobDownloadLinks = {
  resume: Maybe<Scalars['String']['output']>;
  coverLetter: Maybe<Scalars['String']['output']>;
};

export type AppliedJobEdge = {
  node: AppliedJob;
  cursor: Scalars['String']['output'];
};

export type AppliedJobEvent = {
  status: AppliedJobStatus;
  timestamp: SeekDateTime;
};

export enum AppliedJobLabelLength {
  Short = 'SHORT',
  Long = 'LONG'
}

export type AppliedJobSortByInput = {
  applicationDate: InputMaybe<Sort>;
  companyName: InputMaybe<Sort>;
  jobTitle: InputMaybe<Sort>;
};

export enum AppliedJobStatus {
  Applied = 'Applied',
  Viewed = 'Viewed',
  NotSuitable = 'NotSuitable'
}

export type AppliedWithCoverLetterPercentage = ApplicationInsightsStatistic & {
  percentage: Scalars['Float']['output'];
  message: Scalars['String']['output'];
};


export type AppliedWithCoverLetterPercentageMessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type AppliedWithResumePercentage = ApplicationInsightsStatistic & {
  percentage: Scalars['Float']['output'];
  message: Scalars['String']['output'];
};


export type AppliedWithResumePercentageMessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type Approachability = {
  approachable: Scalars['Boolean']['output'];
};

export type ApproxModuleSocialData = {
  /** UNSTABLE! */
  likeCount: Maybe<SocialMetric>;
  /** UNSTABLE! */
  commentCount: Maybe<SocialMetric>;
};

export type AttachmentMetadata = {
  fileName: Maybe<Scalars['String']['output']>;
  virusScanStatus: VirusScanStatus;
  contentType: Maybe<Scalars['String']['output']>;
};

export enum AttachmentType {
  CoverLetter = 'CoverLetter',
  SelectionCriteria = 'SelectionCriteria'
}

export enum AttributionSource {
  Home = 'HOME',
  JobDetails = 'JOB_DETAILS',
  ApplySuccess = 'APPLY_SUCCESS',
  ApplyLinkoutSuccess = 'APPLY_LINKOUT_SUCCESS',
  Recommendations = 'RECOMMENDATIONS',
  AppliedJobs = 'APPLIED_JOBS',
  LoggedOutHome = 'LOGGED_OUT_HOME',
  CompetitivePlacement = 'COMPETITIVE_PLACEMENT',
  LoggedOutCompetitivePlacement = 'LOGGED_OUT_COMPETITIVE_PLACEMENT'
}

export type Availability = {
  id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export type AvailabilityOption = {
  /** Unique ID used to identify a specific availability option */
  id: Scalars['Int']['output'];
  /** Human readable string used when the user is selecting an availability option. */
  description: Scalars['String']['output'];
};

export type Award = {
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type BadgeDetails = {
  displayText: Scalars['String']['output'];
  /** The type of the badge. Used for styling and tracking i.e "NEW", "VIEWED", etc. */
  badge: Scalars['String']['output'];
};

export type Banner = {
  id: Maybe<Scalars['String']['output']>;
  analytics: Maybe<Scalars['JSON']['output']>;
  template: Maybe<BannerTemplate>;
};

export type BannerHeading = {
  text: Maybe<Scalars['String']['output']>;
  style: Maybe<BannerStyle>;
};

export type BannerImage = {
  url: Maybe<Scalars['String']['output']>;
  urlDark: Maybe<Scalars['String']['output']>;
};

export type BannerItems = {
  id: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  href: Maybe<Scalars['String']['output']>;
};

export type BannerLink = {
  text: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  style: Maybe<BannerStyle>;
};

export enum BannerPlacement {
  MobileHome = 'MOBILE_HOME',
  SerpFooterLinks = 'SERP_FOOTER_LINKS'
}

export type BannerStyle = {
  color: Maybe<Scalars['String']['output']>;
  colorDark: Maybe<Scalars['String']['output']>;
  backgroundColor: Maybe<Scalars['String']['output']>;
  backgroundColorDark: Maybe<Scalars['String']['output']>;
};

export type BannerTemplate = {
  id: Maybe<Scalars['String']['output']>;
  image: Maybe<BannerImage>;
  link: Maybe<BannerLink>;
  heading: Maybe<BannerHeading>;
  style: Maybe<BannerStyle>;
  items: Array<BannerItems>;
};

export type BaseCredential = {
  verification: CredentialVerification;
  credentialInfo: Array<CredentialInfo>;
  manageVerificationUrl: Scalars['String']['output'];
  deleteVerificationUrl: Scalars['String']['output'];
  expiryStatus: Maybe<CredentialExpiryStatus>;
};

export type BaseVerifiableCredential = {
  label: Scalars['String']['output'];
};

export type BasicBranding = {
  brandId: Maybe<Scalars['String']['output']>;
  logo: Maybe<Scalars['String']['output']>;
  cover: Maybe<Scalars['String']['output']>;
};

export type Branding = {
  logo: Maybe<Scalars['String']['output']>;
  cover: Maybe<Cover>;
};

export type BrandingCjs = {
  sourceId: Scalars['ID']['output'];
};

export type CjsSource = {
  isAutoincluded: Maybe<Scalars['Boolean']['output']>;
};

export enum Company_Group {
  Industry = 'INDUSTRY'
}

export enum Company_Sort_By {
  ReviewsCount = 'REVIEWS_COUNT'
}

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type Candidate = {
  /** UNSTABLE! */
  apacSavedSearchesConnection: ApacSavedSearchConnection;
  apacSavedSearches: Maybe<Array<ApacSavedSearch>>;
  appliedJobs: AppliedJobConnection;
  searchAppliedJobs: Array<SearchAppliedJobPartial>;
  appliedJob: Maybe<AppliedJob>;
  /** @deprecated Candidates have received sufficeint notice of migration since Unification completed */
  appliedJobsMigrationMessage: Maybe<Scalars['String']['output']>;
  /** Candidate's approachability */
  approachability: Approachability;
  attachmentMetadata: Maybe<AttachmentMetadata>;
  /**
   * Candidate's work notice period length
   * @deprecated Use availability instead
   */
  noticePeriod: Maybe<NoticePeriod>;
  availability: Maybe<Availability>;
  /** Unique candidate ID in numeric format */
  id: Scalars['Int']['output'];
  /**
   * Unique candidate ID.
   * Note: This is a temporary field. We cannot change `id` to string format
   * right now because of dependency on long tail apps.
   */
  _id: Scalars['ID']['output'];
  /** Unique tracking (candidate) ID in UUID format */
  trackingId: Scalars['ID']['output'];
  /**
   * External Id (candidate)
   * Note: This is a temporary field used to identify the candidate within APAC (Asia) Domain
   */
  externalId: Maybe<Scalars['ID']['output']>;
  emailAddress: Scalars['Email']['output'];
  /** @deprecated Use viewer.trackingId */
  emailCorrelationId: Scalars['String']['output'];
  candidateJobMatchAllocation: Maybe<CandidateJobMatchAllocation>;
  /** UNSTABLE! */
  candidateJobPreferences: Maybe<Array<Maybe<CandidateJobPreferencesGroup>>>;
  /**
   * Candidate context that can be persisted in cookies
   * @deprecated This field will always return null
   */
  userCookie: Maybe<UserCookie>;
  /** Career Objectives for candidate */
  careerObjectives: Maybe<CareerObjectives>;
  /** Current location for this candidate */
  currentLocation2: Maybe<Location2>;
  /** Identity of the currently authenticated user. */
  identity: Identity;
  /** Candidate's language proficiencies */
  languageProficiencies: Array<LanguageProficiency>;
  /** Licences */
  licences: Array<Licence>;
  notificationCTPPreferenceGroups: Maybe<Array<NotificationCtpPreferenceGroup>>;
  /**
   * *Note*: The default values for the parameters to this query are `"AU"`
   * and `"en"` respectively, *not* `false` as they in the playground.
   */
  personalDetails: PersonalDetails;
  onboardingComplete: Maybe<Scalars['Boolean']['output']>;
  /** Preferred classification for this candidate */
  preferredClassification: Maybe<Classification>;
  /** All preferred locations for this candidate */
  preferredLocations2: Array<Location2>;
  /** EXPERIMENTAL! */
  preferredRoleTitles: Maybe<Array<OntologyStructuredData>>;
  /**
   * The insights of profile interactions for this candidate
   * @deprecated Use profileInsights2
   */
  profileInsights: Maybe<ProfileInsights>;
  profileInsights2: Maybe<ProfileInsights2>;
  /** All reference checks associated with this candidate. It expects audience zone as argument to enable references based on market. */
  referenceChecks: Maybe<Array<ReferenceCheck>>;
  profileSuggestions: Maybe<Array<ProfileSuggestion>>;
  /** The verified and verifiable data for this candidate */
  profileVerifications: Maybe<ProfileVerifications>;
  /**
   * Profile Visibility for candidate
   * @deprecated Use viewer.profileVisibility2
   */
  profileVisibility: Maybe<ProfileVisibility>;
  /** Profile Visibility for candidate */
  profileVisibility2: Maybe<ProfileVisibilityOption>;
  /** Public profile settings */
  publicProfile: Maybe<PublicProfile>;
  /** Determines whether an authenticated user is associated with a candidate record. */
  isAccountProvisioned: Maybe<Scalars['Boolean']['output']>;
  /** All qualifications for this candidate */
  qualifications: Array<Qualification>;
  /** A specific qualification for this candidate */
  qualification: Maybe<Qualification>;
  /** Group candidate recommendations under one type */
  recommendations: Maybe<Recommendations>;
  /** A specific resume for this candidate */
  resume: Maybe<Resume>;
  /** All resumes for this candidate */
  resumes: Array<Resume>;
  /** Rights to work for candidate */
  rightsToWork: Array<RightToWork>;
  /**
   * Rights to work alert type for candidate
   * @deprecated No longer required
   */
  rightsToWorkAlert: RightsToWorkAlert;
  /** All roles for this candidate */
  roles: Array<Role>;
  /** Specific role for candidate */
  role: Maybe<Role>;
  salaryNudge: Maybe<CandidateSalaryNudge>;
  /**
   * Salary preferences for candidate. Description fields will be returned in the language
   * specified via the `languageCode` parameter.
   */
  salaryPreferences2: Array<SalaryPreference2>;
  savedJobs: SavedJobConnection;
  searchSavedJobs: Array<SearchSavedJobPartial>;
  /**
   * Profile completeness score. The `zone` parameter restricts the tips returned so they are only relevant to the
   * brand associated with the zone provided.
   */
  score: ProfileScore;
  /**
   * Displays data that a candidate has chosen to share via a public url
   * @deprecated This functionality is retired
   */
  shareableProfile: ShareableProfile;
  /**
   * Shareable Profile Settings
   * @deprecated This functionality is retired
   */
  shareableProfileSettings: ShareableProfileSettings;
  /**
   * All skills for this candidate
   * @deprecated Use `viewer.skills2` instead
   */
  skills: Array<Skill>;
  /** All skills for this candidate */
  skills2: Maybe<Array<Skill>>;
  /**
   * All suggested skills for this candidate
   * @deprecated Use `viewer.suggestedSkills2` instead
   */
  suggestedSkills: Array<Skill>;
  suggestedSkills2: Maybe<Array<Skill>>;
  /** Unconfirmed data for given context */
  unconfirmedDataForContext: UnconfirmedData;
  verificationNudges: Array<VerificationNudge>;
  /** @deprecated Please use viewer.profileVerifications instead */
  verifications: Maybe<Verifications>;
  /** The verified identity data for this candidate */
  verifiedIdentity: Maybe<VerifiedIdentity>;
  /** Candidate's work types */
  workTypes: Array<WorkType>;
  /**
   * Candidate's years of experience
   * @deprecated Its no longer being used in production after unification. Will be removed in future releases.
   */
  yearsOfExperience: Maybe<YearsOfExperience>;
  /** Temporary document download link for a given resource id (Type could be a Resume, Cover Letter, or Selection Criteria) */
  documentDownloadLink: Maybe<DocumentDownloadLink>;
  /** Form data for clients to upload documents(documents type could be a Resume, Cover Letter, or Selection Criteria) */
  documentUploadFormData: Maybe<DocumentUploadFormData>;
};


export type CandidateApacSavedSearchesConnectionArgs = {
  first: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
};


export type CandidateAppliedJobsArgs = {
  first: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  sortBy: InputMaybe<AppliedJobSortByInput>;
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type CandidateSearchAppliedJobsArgs = {
  jobIds: Array<Scalars['String']['input']>;
};


export type CandidateAppliedJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type CandidateAppliedJobsMigrationMessageArgs = {
  zone: Scalars['Zone']['input'];
  locale: Scalars['Locale']['input'];
};


export type CandidateAttachmentMetadataArgs = {
  blobUrl: Scalars['String']['input'];
};


export type CandidateAvailabilityArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type CandidateCurrentLocation2Args = {
  zone: Scalars['Zone']['input'];
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateLicencesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
};


export type CandidateNotificationCtpPreferenceGroupsArgs = {
  zone: Scalars['Zone']['input'];
  onlyProductionOption?: Scalars['Boolean']['input'];
};


export type CandidatePersonalDetailsArgs = {
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidatePreferredClassificationArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidatePreferredLocations2Args = {
  zone: Scalars['Zone']['input'];
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateProfileInsightsArgs = {
  zone: Scalars['Zone']['input'];
};


export type CandidateProfileInsights2Args = {
  zone: Scalars['Zone']['input'];
};


export type CandidateProfileSuggestionsArgs = {
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type CandidateProfileVerificationsArgs = {
  zone: Scalars['Zone']['input'];
  locale: Scalars['Locale']['input'];
};


export type CandidateProfileVisibilityArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateProfileVisibility2Args = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type CandidateQualificationsArgs = {
  includeVerified?: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<ConfirmedStatus>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
  isUnifiedSite?: InputMaybe<Scalars['Boolean']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
};


export type CandidateQualificationArgs = {
  id: Scalars['UUID']['input'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: Scalars['Zone']['input'];
  isUnifiedSite?: InputMaybe<Scalars['Boolean']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
};


export type CandidateResumeArgs = {
  id: Scalars['UUID']['input'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateResumesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateRightsToWorkArgs = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
  isUnifiedSite?: InputMaybe<Scalars['Boolean']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
};


export type CandidateRightsToWorkAlertArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
};


export type CandidateRolesArgs = {
  status: InputMaybe<ConfirmedStatus>;
};


export type CandidateRoleArgs = {
  id: Scalars['UUID']['input'];
};


export type CandidateSalaryNudgeArgs = {
  zone: Scalars['String']['input'];
};


export type CandidateSalaryPreferences2Args = {
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateSavedJobsArgs = {
  first: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
};


export type CandidateSearchSavedJobsArgs = {
  jobIds: Array<Scalars['String']['input']>;
};


export type CandidateScoreArgs = {
  zone?: InputMaybe<Scalars['Zone']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  isUnifiedSite: InputMaybe<Scalars['Boolean']['input']>;
};


export type CandidateShareableProfileArgs = {
  profileSlug: Scalars['String']['input'];
};


export type CandidateShareableProfileSettingsArgs = {
  zone?: InputMaybe<Scalars['Zone']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateSuggestedSkillsArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};


export type CandidateSuggestedSkills2Args = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};


export type CandidateUnconfirmedDataForContextArgs = {
  contextId: Scalars['String']['input'];
  contextType: InputMaybe<UnconfirmedContextType>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateVerificationNudgesArgs = {
  jobId: Scalars['ID']['input'];
  selectedAnswerUris: Array<Scalars['String']['input']>;
  platform: Platform;
  source: SourceExperience;
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type CandidateVerificationsArgs = {
  testGroup: InputMaybe<VerificationsTestVariant>;
};


export type CandidateVerifiedIdentityArgs = {
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  source: SourceExperience;
};


export type CandidateWorkTypesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateYearsOfExperienceArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type CandidateDocumentDownloadLinkArgs = {
  resourceId: Scalars['ID']['input'];
  resourceType: DocumentResourceType;
};


export type CandidateDocumentUploadFormDataArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
};

export type CandidateJobMatch = {
  jobId: Scalars['ID']['output'];
};

export type CandidateJobMatchAllocation = {
  message: Scalars['String']['output'];
};

export type CandidateJobMatchExists = CandidateJobMatch & CreateCandidateJobMatchResponse & {
  jobId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  shouldApply: Scalars['Boolean']['output'];
  shouldApplyMessage: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  summaryList: Array<Scalars['String']['output']>;
  recommendations: Scalars['String']['output'];
  recommendationsList: Array<Scalars['String']['output']>;
  trackingId: Scalars['UUID']['output'];
};

export type CandidateJobMatchInProgress = CandidateJobMatch & CreateCandidateJobMatchResponse & {
  jobId: Scalars['ID']['output'];
  waitForMs: Scalars['Int']['output'];
  trackingId: Scalars['UUID']['output'];
};

export type CandidateJobMatchNotExists = CandidateJobMatch & {
  jobId: Scalars['ID']['output'];
};

export type CandidateJobMatchResultInvalid = CandidateJobMatch & CreateCandidateJobMatchResponse & {
  jobId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  trackingId: Maybe<Scalars['UUID']['output']>;
};


export type CandidateJobMatchResultInvalidMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CandidateJobPreferencesGroup = {
  reason: Scalars['String']['output'];
  label: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<Maybe<CandidateJobPreferencesItem>>>;
};


export type CandidateJobPreferencesGroupLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CandidateJobPreferencesItem = {
  id: Scalars['ID']['output'];
  typeId: Scalars['String']['output'];
  label: Maybe<Scalars['String']['output']>;
};


export type CandidateJobPreferencesItemLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CandidateSalaryNudge = {
  id: Scalars['ID']['output'];
  firstName: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  text: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  callToActions: Array<CandidateSalaryNudgeCallToAction>;
};

export type CandidateSalaryNudgeCallToAction = {
  displayText: Scalars['String']['output'];
  /** The call to action submission operation */
  operation: Scalars['String']['output'];
};

export type CandidateSalaryNudgeFeedbackPayload = {
  nudgeId: Scalars['ID']['output'];
};

export type CareerFeed = {
  /** @deprecated Use serviceToken instead. */
  correlationId: Maybe<Scalars['UUID']['output']>;
  solMetadata: Maybe<Scalars['JSON']['output']>;
  serviceToken: Scalars['UUID']['output'];
  pageInfo: Maybe<CareerFeedPageInfo>;
  edges: Array<Maybe<CareerFeedEdge>>;
  emptyComponentReason: Maybe<CareerFeedEmptyComponentReason>;
};

export enum CareerFeedChannel {
  Home = 'HOME'
}

export type CareerFeedCompanyEvp = CareerFeedNode & {
  id: Scalars['ID']['output'];
  companyId: Scalars['CompanyId']['output'];
  companyReviewsAISummary: Maybe<CompanyReviewsAiSummary>;
  companyProfile: Maybe<CompanyProfileV2>;
  solMetadata: Maybe<Scalars['JSON']['output']>;
  serviceToken: Scalars['UUID']['output'];
};


export type CareerFeedCompanyEvpCompanyReviewsAiSummaryArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export enum CareerFeedComponent {
  Job = 'JOB',
  CompanyEvp = 'COMPANY_EVP',
  MarketInsights = 'MARKET_INSIGHTS'
}

export type CareerFeedEdge = {
  node: Maybe<CareerFeedNode>;
};

export type CareerFeedEmptyComponentReason = {
  reason: Maybe<Scalars['String']['output']>;
};

export type CareerFeedEmptyJobsEmptyComponentReason = CareerFeedEmptyComponentReason & {
  reason: Maybe<Scalars['String']['output']>;
};

export type CareerFeedEmptyJobsWithPreferencesEmptyComponentReason = CareerFeedEmptyComponentReason & {
  reason: Maybe<Scalars['String']['output']>;
};

export type CareerFeedExperimentInput = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type CareerFeedInsights = {
  id: Scalars['String']['output'];
  adVolumeShift: Maybe<CareerFeedInsightsAdVolumeShift>;
  adVolumeData: Maybe<CareerFeedInsightsAdVolumeData>;
  serviceToken: Scalars['String']['output'];
};

export type CareerFeedInsightsAdVolumeData = {
  xAxis: CareerFeedInsightsXAxis;
  yAxis: CareerFeedInsightsYAxis;
  dataPoints: Array<CareerFeedInsightsDataPoint>;
  chartLegend: Maybe<Scalars['String']['output']>;
};


export type CareerFeedInsightsAdVolumeDataChartLegendArgs = {
  locale: Scalars['Locale']['input'];
};

export type CareerFeedInsightsAdVolumeShift = {
  count: Scalars['Int']['output'];
  dayRange: Scalars['Int']['output'];
};

export type CareerFeedInsightsDataPoint = {
  startDate: Scalars['Float']['output'];
  endDate: Maybe<Scalars['Float']['output']>;
  adsPostedCount: Scalars['Int']['output'];
  adsPostedLabel: Scalars['String']['output'];
  startDateLabel: SeekDateTime;
  endDateLabel: Maybe<SeekDateTime>;
};


export type CareerFeedInsightsDataPointAdsPostedLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CareerFeedInsightsDateTick = {
  label: SeekDateTime;
  value: Scalars['Float']['output'];
};

export type CareerFeedInsightsLocationInput = {
  id: Scalars['String']['input'];
};

export type CareerFeedInsightsNumericTick = {
  label: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};


export type CareerFeedInsightsNumericTickLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CareerFeedInsightsRoleInput = {
  uri: Scalars['String']['input'];
};

export type CareerFeedInsightsXAxis = {
  min: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  ticks: Array<CareerFeedInsightsDateTick>;
};

export type CareerFeedInsightsYAxis = {
  min: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  ticks: Array<CareerFeedInsightsNumericTick>;
};

export type CareerFeedJob = CareerFeedNode & {
  id: Scalars['ID']['output'];
  savedJob: Maybe<SavedJob>;
  jobId: Scalars['ID']['output'];
  solMetadata: Maybe<Scalars['JSON']['output']>;
  serviceToken: Scalars['UUID']['output'];
  jobBadges: Maybe<JobBadges>;
  job: Maybe<Job>;
  enrichment: Maybe<Enrichment>;
  workArrangements: Maybe<CareerFeedJobWorkArrangements>;
  feedbackReasons: Maybe<JobPreferencesFeedbackReasons>;
};


export type CareerFeedJobJobBadgesArgs = {
  locale: Scalars['Locale']['input'];
  visitorId: Scalars['UUID']['input'];
  platform: Platform;
  channel: CareerFeedChannel;
};


export type CareerFeedJobWorkArrangementsArgs = {
  channel: CareerFeedChannel;
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
};

export type CareerFeedJobWorkArrangement = {
  type: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};


export type CareerFeedJobWorkArrangementLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CareerFeedJobWorkArrangements = {
  arrangements: Maybe<Array<Maybe<CareerFeedJobWorkArrangement>>>;
  label: Maybe<Scalars['String']['output']>;
};


export type CareerFeedJobWorkArrangementsLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CareerFeedJobsTimeoutEmptyComponentReason = CareerFeedEmptyComponentReason & {
  reason: Maybe<Scalars['String']['output']>;
};

export type CareerFeedNode = {
  id: Scalars['ID']['output'];
};

export type CareerFeedPageInfo = {
  cursor: Maybe<Scalars['UUID']['output']>;
};

export type CareerFeedPersonalMarketInsights = CareerFeedNode & {
  id: Scalars['ID']['output'];
  role: Maybe<OntologyRole>;
  location: Maybe<SeekLocation>;
};

export type CareerObjectives = {
  personalStatement: Scalars['String']['output'];
};

export type CategoryInfo = {
  label: Scalars['String']['output'];
};


export type CategoryInfoLabelArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type ChangeEmailAddressFailure = {
  error: I18nAccountError;
};

export type ChangeEmailAddressInput = {
  newEmailAddress: Scalars['String']['input'];
  password: InputMaybe<Scalars['String']['input']>;
  isBGroup: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChangeEmailAddressPayload = ChangeEmailAddressSuccess | ChangeEmailAddressFailure;

export type ChangeEmailAddressSuccess = {
  ref: Scalars['UUID']['output'];
};

export type ChangeEmailStartFailure = {
  error: I18nAccountError;
};

export type ChangeEmailStartInput = {
  newEmailAddress: Scalars['Email']['input'];
};

export type ChangeEmailStartPayload = ChangeEmailStartSuccess | ChangeEmailStartFailure;

export type ChangeEmailStartSuccess = {
  ref: Scalars['UUID']['output'];
};

export type ChangeEmailVerifyFailure = {
  error: I18nAccountError;
};

export type ChangeEmailVerifyInput = {
  newEmailAddress: Scalars['Email']['input'];
  brand: InputMaybe<Scalars['String']['input']>;
  country: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<Scalars['String']['input']>;
  verificationCode: InputMaybe<Scalars['String']['input']>;
};

export type ChangeEmailVerifyPayload = ChangeEmailVerifySuccess | ChangeEmailVerifyFailure;

export type ChangeEmailVerifySuccess = {
  ref: Scalars['UUID']['output'];
};

export type ChangePasswordFailure = {
  error: Maybe<I18nAccountError>;
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ChangePasswordPayload = ChangePasswordSuccess | ChangePasswordFailure;

export type ChangePasswordSuccess = {
  ref: Scalars['UUID']['output'];
};

export type ChildClassification = {
  id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};


export type ChildClassificationDescriptionArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type Classification = {
  id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  subClassification: SubClassification;
};

export type ClassificationInfo = {
  label: Scalars['String']['output'];
};


export type ClassificationInfoLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ClassificationInput = {
  id: Scalars['Int']['input'];
  subClassification: SubClassificationInput;
};

export type ClassificationOptions = {
  id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  subClassifications: Array<SubClassification>;
};

export type CommunityGuideline = {
  url: Scalars['String']['output'];
};


export type CommunityGuidelineUrlArgs = {
  zone?: Scalars['Zone']['input'];
  locale?: Scalars['Locale']['input'];
};

export type CompanyDetails = {
  id: Scalars['CompanyId']['output'];
  companyReviewsAISummary: Maybe<CompanyReviewsAiSummary>;
  companySalaryRange: Maybe<CompanyProfileSalaryRanges>;
  companyReviewLocations: Maybe<Array<Maybe<CompanyReviewLocation>>>;
  companyProfile: Maybe<CompanyProfileV2>;
  companyReviews: Maybe<CompanyReviewsV2>;
};


export type CompanyDetailsCompanyReviewsAiSummaryArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type CompanyDetailsCompanyReviewLocationsArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
  sort: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyDetailsCompanyProfileArgs = {
  draft: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyDetailsCompanyReviewsArgs = {
  zone: Scalars['Zone']['input'];
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Scalars['String']['input']>;
  locationId: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyGroupByInput = {
  group: Company_Group;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CompanyNameSlug = {
  companySlug: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CompanyProfile = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** @deprecated Beta badge is not needed anymore */
  isBeta: Maybe<Scalars['Boolean']['output']>;
  companyNameSlug: Scalars['String']['output'];
  /** @deprecated All company pages are company profiles now */
  isCompanyProfile: Scalars['Boolean']['output'];
  /** @deprecated All company pages should display reviews */
  shouldDisplayReviews: Scalars['Boolean']['output'];
  /** @deprecated All company pages should display reviews */
  areReviewsEnabled: Scalars['Boolean']['output'];
  branding: Maybe<Branding>;
  overview: Maybe<Overview>;
  missionStatement: Maybe<MissionStatement>;
  featured: Maybe<Featured>;
  awards: Array<Award>;
  cultureAndValues: Maybe<CultureAndValues>;
  reviewsSummary: Maybe<ReviewsSummary>;
  /** @deprecated Use CompanyReviews query instead */
  reviews: Reviews;
  customStatement: Maybe<CustomStatement>;
  perksAndBenefits: Array<PerkAndBenefit>;
  tracking: CompanyProfileTracking;
  profileUrl: Maybe<Scalars['String']['output']>;
  reviewsUrl: Maybe<Scalars['String']['output']>;
};


export type CompanyProfileReviewsArgs = {
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyProfileAwards = {
  imageUrl: Scalars['String']['output'];
  year: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CompanyProfileBranding = {
  brandId: Maybe<Scalars['String']['output']>;
  logo: Maybe<Scalars['String']['output']>;
  cover: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileCultureAndValues = {
  title: Scalars['String']['output'];
  description: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  values: Maybe<Array<Maybe<CompanyProfileValues>>>;
};

export type CompanyProfileCustomStatement = {
  title: Maybe<Scalars['String']['output']>;
  description: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CompanyProfileData = {
  name: Maybe<Scalars['String']['output']>;
  overview: Maybe<CompanyProfileOverviewV2>;
  customStatement: Maybe<CompanyProfileCustomStatement>;
  missionStatement: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  featured: Maybe<CompanyProfileFeatured>;
  awards: Maybe<Array<Maybe<CompanyProfileAwards>>>;
  cultureAndValues: Maybe<CompanyProfileCultureAndValues>;
  perksAndBenefits: Maybe<Array<Maybe<CompanyProfilePerksAndBenefits>>>;
  gallery: Maybe<Array<Maybe<CompanyProfileGallery>>>;
  branding: Maybe<CompanyProfileBranding>;
  canonicalUrl: Maybe<Scalars['String']['output']>;
  isClaimed: Scalars['Boolean']['output'];
};

export type CompanyProfileFeatured = {
  title: Maybe<Scalars['String']['output']>;
  description: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  imageUrl: Maybe<Scalars['String']['output']>;
  videoUrl: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileGallery = {
  title: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['Int']['output']>;
  linkUrl: Scalars['String']['output'];
};

export type CompanyProfileOverallRating = {
  rating: Maybe<Scalars['Float']['output']>;
  count: Maybe<Scalars['Int']['output']>;
};

export type CompanyProfileOverview = {
  website: Maybe<CompanyProfileWebsite>;
  size: Maybe<Scalars['String']['output']>;
  industry: Maybe<Scalars['String']['output']>;
  primaryLocation: Maybe<Scalars['String']['output']>;
  specialities: Maybe<Array<Scalars['String']['output']>>;
  description: Maybe<Array<Scalars['String']['output']>>;
};

export type CompanyProfileOverviewV2 = {
  website: Maybe<CompanyProfileWebsiteV2>;
  size: Maybe<Scalars['String']['output']>;
  industry: Maybe<Scalars['String']['output']>;
  primaryLocation: Maybe<Scalars['String']['output']>;
  specialities: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  traditionalLand: Maybe<Scalars['String']['output']>;
  traditionalPlace: Maybe<Scalars['String']['output']>;
};

export type CompanyProfilePerksAndBenefits = {
  title: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileReviewsSummary = {
  rating: Maybe<Scalars['Float']['output']>;
  count: Maybe<Scalars['Int']['output']>;
};

export type CompanyProfileSalaryRanges = {
  lastUpdatedAt: SeekDateTime;
  salaryRangeByRoles: Array<Maybe<SalaryRangeByRoles>>;
};

export type CompanyProfileSortRating = {
  rating: Maybe<Scalars['Float']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileTracking = {
  isCompanyProfile: Scalars['Boolean']['output'];
};

export type CompanyProfileV2 = {
  zone: Maybe<Scalars['Zone']['output']>;
  organisationId: Maybe<Scalars['String']['output']>;
  data: Maybe<CompanyProfileData>;
  companyReviewRating: Maybe<CompanyReviewCompanyReviewRating>;
};

export type CompanyProfileValues = {
  title: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type CompanyProfileWebsite = {
  url: Scalars['String']['output'];
  displayName: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileWebsiteV2 = {
  url: Scalars['String']['output'];
  displayName: Maybe<Scalars['String']['output']>;
};

export type CompanyReviewAiSummaryContent = {
  positiveAndChallengesSummary: Maybe<Scalars['String']['output']>;
  positiveTheme: Maybe<Array<Maybe<CompanyReviewAiSummaryTheme>>>;
  challengesTheme: Maybe<Array<Maybe<CompanyReviewAiSummaryTheme>>>;
};

export type CompanyReviewAiSummaryTheme = {
  theme: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
};

export type CompanyReviewCompanyReviewRating = {
  company: Maybe<CompanyReviewRating>;
  perksAndBenefits: Maybe<CompanyReviewRating>;
  careerOpportunity: Maybe<CompanyReviewRating>;
  diversity: Maybe<CompanyReviewRating>;
  executiveManagement: Maybe<CompanyReviewRating>;
  workLifeBalance: Maybe<CompanyReviewRating>;
  workEnvironment: Maybe<CompanyReviewRating>;
  companyRating1Star: Maybe<CompanyReviewRating>;
  companyRating2Star: Maybe<CompanyReviewRating>;
  companyRating3Star: Maybe<CompanyReviewRating>;
  companyRating4Star: Maybe<CompanyReviewRating>;
  companyRating5Star: Maybe<CompanyReviewRating>;
  companyRecommended: Maybe<CompanyReviewRating>;
  salaryPoor: Maybe<CompanyReviewRating>;
  salaryFair: Maybe<CompanyReviewRating>;
  salaryGenerous: Maybe<CompanyReviewRating>;
};

export type CompanyReviewLocation = {
  relativeUrl: Scalars['String']['output'];
  contextualName: Scalars['String']['output'];
};

export type CompanyReviewRating = {
  rating: Maybe<Scalars['Float']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
  count: Maybe<Scalars['Int']['output']>;
};

export type CompanyReviewReply = {
  text: Scalars['String']['output'];
  createdAt: SeekDateTime;
  from: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CompanyReviewV2 = {
  overallRating: Scalars['Float']['output'];
  ratings: Array<CompanyReviewV2RatingItem>;
  id: Scalars['ID']['output'];
  createdAt: Maybe<SeekDateTime>;
  companyId: Scalars['String']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  employmentStatus: Maybe<Scalars['String']['output']>;
  workLocation: Maybe<Scalars['String']['output']>;
  salarySummary: Scalars['String']['output'];
  recommended: CompanyReviewV2Recommended;
  title: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['String']['output'];
  pros: Maybe<Scalars['String']['output']>;
  cons: Maybe<Scalars['String']['output']>;
  overallExperienceDetails: Maybe<Scalars['String']['output']>;
  upvotes: Maybe<CompanyReviewV2UpVotes>;
  reply: Maybe<CompanyReviewV2Reply>;
  hasBeenFlagged: Maybe<Scalars['Boolean']['output']>;
};


export type CompanyReviewV2EmploymentStatusArgs = {
  locale?: Scalars['Locale']['input'];
};


export type CompanyReviewV2SalarySummaryArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyReviewV2RatingItem = {
  description: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};


export type CompanyReviewV2RatingItemDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyReviewV2Recommended = {
  description: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};


export type CompanyReviewV2RecommendedDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyReviewV2Reply = {
  text: Scalars['String']['output'];
  createdAt: SeekDateTime;
  from: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CompanyReviewV2UpVotes = {
  count: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  userIds: Maybe<Array<Scalars['String']['output']>>;
};


export type CompanyReviewV2UpVotesDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyReviews = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  reviewCount: Scalars['Int']['output'];
  reviewsUrl: Scalars['String']['output'];
};

export type CompanyReviewsAiSummary = {
  reviewsCount: Maybe<Scalars['Int']['output']>;
  reviewsDateFrom: Maybe<Scalars['String']['output']>;
  reviewsDateTo: Maybe<Scalars['String']['output']>;
  aISummaryContent: Maybe<CompanyReviewAiSummaryContent>;
};

export type CompanyReviewsV2 = {
  data: Array<CompanyReviewV2>;
  paging: CompanyReviewsV2Paging;
};

export type CompanyReviewsV2Paging = {
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CompanySize = {
  description: Scalars['String']['output'];
};


export type CompanySizeDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyTag = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


export type CompanyTagKeyArgs = {
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CompletionDate = MonthYear | Year;

export type ConfirmQualificationInput = {
  id: Scalars['UUID']['input'];
  name: OntologyStructuredDataInput;
  institute: OntologyStructuredDataInput;
  completed: Scalars['Boolean']['input'];
  completionYear: InputMaybe<Scalars['Int']['input']>;
  expectedCompletionDate: InputMaybe<MonthYearInput>;
  highlights: InputMaybe<Scalars['String']['input']>;
  tracking: InputMaybe<TrackingInfoInput>;
};

export type ConfirmQualificationPayload = {
  /** @deprecated Use viewer.qualifications */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type ConfirmRoleInput = {
  id: Scalars['UUID']['input'];
  title: OntologyStructuredDataInput;
  seniority: InputMaybe<OntologyStructuredDataInput>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  to: InputMaybe<MonthYearInput>;
  /** Required for JobsDB only */
  function: InputMaybe<RoleFunctionInput>;
  /** Required for JobsDB only */
  industry: InputMaybe<RoleIndustryInput>;
  achievements: InputMaybe<Scalars['String']['input']>;
  tracking: InputMaybe<TrackingInfoInput>;
};

export type ConfirmRolePayload = {
  /** @deprecated Use viewer.roles */
  role: Role;
  viewer: Maybe<Candidate>;
};

export enum ConfirmedStatus {
  Unconfirmed = 'unconfirmed',
  Confirmed = 'confirmed'
}

export type ConsentTransactionDetails = {
  /** The name of the hirer requesting consent */
  hirerName: Scalars['String']['output'];
  /** The name of the partner requesting consent */
  partnerName: Scalars['String']['output'];
  /** The partner redirectUri in the event of a consent rejection or error */
  redirectUri: Scalars['String']['output'];
};

export type ConsentTransactionDetailsInput = {
  transactionId: Scalars['UUID']['input'];
};

export type ContactMatches = {
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Country = {
  id: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type CountryCallingCode = {
  /** Unique ID used to identify a specific country calling code */
  id: Scalars['ID']['output'];
  /** Country calling code prefixed with a `+`, e.g. `+61` */
  countryCallingCode: Scalars['String']['output'];
  /**
   * Human-readable description of the country calling code; contains the country
   * associated with the code as well as the code itself, e.g. `Australia (+61)`.
   */
  description: Scalars['String']['output'];
};

export type CountryCallingCodeInput = {
  /** Unique ID corresponding to a `CountryCallingCode` */
  id: Scalars['ID']['input'];
};

export enum CountryCode {
  Au = 'au',
  Nz = 'nz',
  Sg = 'sg'
}

export type CountryInformation = {
  /** The country's ISO 3166-1 alpha-2 country code */
  countryCode: Scalars['CountryCodeIso2']['output'];
  /** The country's name */
  name: Scalars['String']['output'];
};

export type Cover = {
  url: Scalars['String']['output'];
  aspectRatio: Maybe<Scalars['Float']['output']>;
};

export type CoverLetterAppliedJobDocument = {
  blobUrl: Scalars['String']['output'];
  downloadLink: Maybe<Scalars['String']['output']>;
  attachmentMetadata: AttachmentMetadata;
};

export type CoverLetterInput = {
  uri: Scalars['String']['input'];
  writtenText: InputMaybe<Scalars['String']['input']>;
};

export type CreateApacSavedSearchDuplicateError = CreateApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateApacSavedSearchDuplicateErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchError = {
  message: Scalars['String']['output'];
};


export type CreateApacSavedSearchErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchErrorMaxExceeded = CreateApacSavedSearchError & {
  message: Scalars['String']['output'];
  savedSearchLimit: Scalars['Int']['output'];
};


export type CreateApacSavedSearchErrorMaxExceededMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchFailure = {
  error: CreateApacSavedSearchError;
};

export type CreateApacSavedSearchInput = {
  zone: Scalars['Zone']['input'];
  searchQueryString: Scalars['JobSearchQueryString']['input'];
  isUnified: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateApacSavedSearchInvalidLocationError = CreateApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateApacSavedSearchInvalidLocationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchPayload = CreateApacSavedSearchSuccess | CreateApacSavedSearchFailure;

export type CreateApacSavedSearchSuccess = {
  savedSearch: ApacSavedSearch;
};

export type CreateCandidateJobMatchAllocationExhausted = CreateCandidateJobMatchResponse & {
  jobId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  retryAfter: Scalars['Int']['output'];
};


export type CreateCandidateJobMatchAllocationExhaustedMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateCandidateJobMatchJobExpired = CreateCandidateJobMatchResponse & {
  jobId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};


export type CreateCandidateJobMatchJobExpiredMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateCandidateJobMatchNotEligible = CreateCandidateJobMatchResponse & {
  jobId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  qualifiers: Array<Scalars['String']['output']>;
};


export type CreateCandidateJobMatchNotEligibleMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateCandidateJobMatchRequestInput = {
  jobId: Scalars['ID']['input'];
  channel: Scalars['String']['input'];
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
  language: InputMaybe<Scalars['String']['input']>;
};

export type CreateCandidateJobMatchResponse = {
  jobId: Scalars['ID']['output'];
};

export type CreateConsentError = {
  message: Scalars['String']['output'];
};


export type CreateConsentErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateConsentFailure = {
  errors: Array<CreateConsentError>;
};

export type CreateConsentInput = {
  transactionId: Scalars['UUID']['input'];
};

export type CreateConsentPayload = CreateConsentSuccess | CreateConsentFailure;

export type CreateConsentSuccess = {
  redirectUri: Scalars['String']['output'];
};

export type CreateConsentTransactionInvalidError = CreateConsentError & {
  message: Scalars['String']['output'];
};


export type CreateConsentTransactionInvalidErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateLinkoutApplicationInput = {
  jobId: Scalars['ID']['input'];
};

export type CreateLinkoutApplicationPayload = {
  applicationUrl: Scalars['String']['output'];
};

export type CreateSavedJobError = {
  message: Scalars['String']['output'];
};


export type CreateSavedJobErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateSavedJobFailure = {
  errors: Array<CreateSavedJobError>;
};

export type CreateSavedJobInput = {
  id: Scalars['ID']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
  eventCaptureData: InputMaybe<SavedJobEventCaptureDataInput>;
};

export type CreateSavedJobPayload = CreateSavedJobSuccess | CreateSavedJobFailure;

export type CreateSavedJobSuccess = {
  id: Scalars['ID']['output'];
  zone: Maybe<Scalars['Zone']['output']>;
};

export type CreateSavedJobValidationError = CreateSavedJobError & {
  message: Scalars['String']['output'];
};


export type CreateSavedJobValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateSeekMaxCommentBlockedWordsError = CreateSeekMaxCommentError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxCommentBlockedWordsErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxCommentBlockedWordsErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentError = {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxCommentErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxCommentErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentExceedRateLimitError = CreateSeekMaxCommentError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxCommentExceedRateLimitErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxCommentExceedRateLimitErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentFailure = {
  errors: Array<CreateSeekMaxCommentError>;
};

export type CreateSeekMaxCommentInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  threadId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type CreateSeekMaxCommentPayload = CreateSeekMaxCommentSuccess | CreateSeekMaxCommentFailure;

export type CreateSeekMaxCommentSuccess = {
  /** @deprecated Use 'comment.id' instead */
  id: Scalars['ID']['output'];
  comment: SeekMaxComment;
};

export type CreateSeekMaxCommentUserIsBannedError = CreateSeekMaxCommentError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxCommentUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxCommentUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentV2Input = {
  zone: Scalars['Zone']['input'];
  threadId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type CreateSeekMaxModuleBookmarkError = {
  message: Scalars['String']['output'];
};


export type CreateSeekMaxModuleBookmarkErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxModuleBookmarkFailure = {
  errors: Array<CreateSeekMaxModuleBookmarkError>;
};

export type CreateSeekMaxModuleBookmarkPayload = CreateSeekMaxModuleBookmarkSuccess | CreateSeekMaxModuleBookmarkFailure;

export type CreateSeekMaxModuleBookmarkSuccess = {
  id: Scalars['ID']['output'];
};

export type CreateSeekMaxReplyBlockedWordsError = CreateSeekMaxReplyError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxReplyBlockedWordsErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxReplyBlockedWordsErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyError = {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxReplyErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxReplyErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyExceedRateLimitError = CreateSeekMaxReplyError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxReplyExceedRateLimitErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxReplyExceedRateLimitErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyFailure = {
  errors: Array<CreateSeekMaxReplyError>;
};

export type CreateSeekMaxReplyInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  commentId: Scalars['ID']['input'];
  /** @deprecated Not in used */
  threadId: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
};

export type CreateSeekMaxReplyPayload = CreateSeekMaxReplySuccess | CreateSeekMaxReplyFailure;

export type CreateSeekMaxReplySuccess = {
  /** @deprecated Use 'reply.id' instead */
  id: Scalars['ID']['output'];
  reply: SeekMaxReply;
};

export type CreateSeekMaxReplyUserIsBannedError = CreateSeekMaxReplyError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxReplyUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxReplyUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyV2Input = {
  zone: Scalars['Zone']['input'];
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type CreateSeekMaxThreadAttachmentInput = {
  type: SeekMaxAttachmentType;
  filename: Scalars['String']['input'];
};

export type CreateSeekMaxThreadBlockedWordsError = CreateSeekMaxThreadError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxThreadBlockedWordsErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxThreadBlockedWordsErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadError = {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxThreadErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxThreadErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadExceedRateLimitError = CreateSeekMaxThreadError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxThreadExceedRateLimitErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxThreadExceedRateLimitErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadFailure = {
  errors: Array<CreateSeekMaxThreadError>;
};

export type CreateSeekMaxThreadInput = {
  zone: Scalars['Zone']['input'];
  description: Scalars['String']['input'];
  groupNanoId: Scalars['ID']['input'];
  attachments: InputMaybe<Array<CreateSeekMaxThreadAttachmentInput>>;
};

export type CreateSeekMaxThreadPayload = CreateSeekMaxThreadSuccess | CreateSeekMaxThreadFailure;

export type CreateSeekMaxThreadSuccess = {
  thread: SeekMaxThread;
  attachmentsToUpload: Maybe<Array<SeekMaxAttachmentUploadReady>>;
};

export type CreateSeekMaxThreadUserIsBannedError = CreateSeekMaxThreadError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type CreateSeekMaxThreadUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type CreateSeekMaxThreadUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadV2Input = {
  zone: Scalars['Zone']['input'];
  description: Scalars['String']['input'];
  categoryId: Scalars['ID']['input'];
  attachments: InputMaybe<Array<CreateSeekMaxThreadAttachmentInput>>;
};

export type CreateShareableProfileSettingsError = {
  message: Scalars['String']['output'];
};


export type CreateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateShareableProfileSettingsFailure = {
  error: CreateShareableProfileSettingsError;
};

export type CreateShareableProfileSettingsPayload = CreateShareableProfileSettingsSuccess | CreateShareableProfileSettingsFailure;

export type CreateShareableProfileSettingsSuccess = {
  viewer: Maybe<Candidate>;
};

export type CreateUnregisteredApacSavedSearchDuplicateError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateUnregisteredApacSavedSearchDuplicateErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchError = {
  message: Scalars['String']['output'];
};


export type CreateUnregisteredApacSavedSearchErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchErrorMaxExceeded = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String']['output'];
  savedSearchLimit: Scalars['Int']['output'];
};


export type CreateUnregisteredApacSavedSearchErrorMaxExceededMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchInvalidChecksumError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateUnregisteredApacSavedSearchInvalidChecksumErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchInvalidEmailError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateUnregisteredApacSavedSearchInvalidEmailErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchInvalidLocationError = CreateUnregisteredApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type CreateUnregisteredApacSavedSearchInvalidLocationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchWithChecksumFailure = {
  error: CreateUnregisteredApacSavedSearchError;
};

export type CreateUnregisteredApacSavedSearchWithChecksumInput = {
  emailAddress: Scalars['Email']['input'];
  checksum: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
  searchQueryString: Scalars['JobSearchQueryString']['input'];
  isUnified: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateUnregisteredApacSavedSearchWithChecksumPayload = CreateUnregisteredApacSavedSearchWithChecksumSuccess | CreateUnregisteredApacSavedSearchWithChecksumFailure;

export type CreateUnregisteredApacSavedSearchWithChecksumSuccess = {
  id: Scalars['ID']['output'];
};

export enum CredentialExpiryStatus {
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON'
}

export type CredentialInfo = {
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export enum CredentialStatus {
  New = 'New',
  /** @deprecated No longer shown in UI */
  ExpiresSoon = 'ExpiresSoon',
  Expired = 'Expired'
}

export type CredentialVerification = {
  result: Scalars['String']['output'];
};

export type CultureAndValues = {
  title: Scalars['String']['output'];
  description: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  values: Array<CultureValue>;
};

export type CultureValue = {
  title: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type CurrentLocation2Input = {
  id: Scalars['Int']['input'];
};

export type CustomStatement = {
  title: Scalars['String']['output'];
  description: Description;
};

export enum DateTimeContext {
  JobPosted = 'JOB_POSTED',
  SeekmaxPollDurationLeft = 'SEEKMAX_POLL_DURATION_LEFT'
}

export enum DateTimeLength {
  Short = 'SHORT',
  Long = 'LONG'
}

export type DefaultCurrency = {
  code: Scalars['String']['output'];
};

export type DefaultGenerateCoverLetterError = GenerateCoverLetterError & {
  message: Scalars['String']['output'];
};


export type DefaultGenerateCoverLetterErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DefaultGenerateSelectionCriteriaError = GenerateSelectionCriteriaError & {
  message: Scalars['String']['output'];
};


export type DefaultGenerateSelectionCriteriaErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteAccountFailure = {
  error: I18nAccountError;
};

export type DeleteAccountInput = {
  password: InputMaybe<Scalars['String']['input']>;
  isBGroup: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteAccountPayload = DeleteAccountSuccess | DeleteAccountFailure;

export type DeleteAccountSuccess = {
  ref: Scalars['UUID']['output'];
};

export type DeleteApacSavedSearchAbsentError = DeleteApacSavedSearchError & {
  message: Scalars['String']['output'];
};


export type DeleteApacSavedSearchAbsentErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteApacSavedSearchError = {
  message: Scalars['String']['output'];
};


export type DeleteApacSavedSearchErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteApacSavedSearchFailure = {
  errors: Array<DeleteApacSavedSearchError>;
};

export type DeleteApacSavedSearchInput = {
  id: Scalars['ID']['input'];
};

export type DeleteApacSavedSearchPayload = DeleteApacSavedSearchSuccess | DeleteApacSavedSearchFailure;

export type DeleteApacSavedSearchSuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteAppliedJobError = {
  message: Scalars['String']['output'];
};


export type DeleteAppliedJobErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteAppliedJobFailure = {
  errors: Array<DeleteAppliedJobError>;
};

export type DeleteAppliedJobInput = {
  id: Scalars['String']['input'];
};

export type DeleteAppliedJobPayload = DeleteAppliedJobSuccess | DeleteAppliedJobFailure;

export type DeleteAppliedJobSuccess = {
  id: Scalars['String']['output'];
};

export type DeleteAppliedJobValidationError = DeleteAppliedJobError & {
  message: Scalars['String']['output'];
};


export type DeleteAppliedJobValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteJobPreferencesError = {
  message: Scalars['String']['output'];
};


export type DeleteJobPreferencesErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteJobPreferencesFailure = {
  error: DeleteJobPreferencesError;
};

export type DeleteJobPreferencesInput = {
  id: Scalars['ID']['input'];
};

export type DeleteJobPreferencesPayload = DeleteJobPreferencesSuccess | DeleteJobPreferencesFailure;

export type DeleteJobPreferencesSuccess = {
  preferences: Array<Maybe<CandidateJobPreferencesGroup>>;
};

export type DeleteLanguageProficiencyInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteLanguageProficiencyPayload = {
  viewer: Maybe<Candidate>;
};

export type DeleteLicenceInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteLicencePayload = {
  /** @deprecated Use viewer.licences */
  ref: Maybe<Scalars['String']['output']>;
  viewer: Maybe<Candidate>;
};

export type DeleteQualificationInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteQualificationPayload = {
  /** @deprecated Use viewer.qualifications */
  id: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type DeleteResumeInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteResumePayload = {
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type DeleteRoleInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteRolePayload = {
  /** @deprecated Use viewer.roles */
  id: Scalars['UUID']['output'];
  viewer: Maybe<Candidate>;
};

export type DeleteSavedJobError = {
  message: Scalars['String']['output'];
};


export type DeleteSavedJobErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteSavedJobFailure = {
  errors: Array<DeleteSavedJobError>;
};

export type DeleteSavedJobInput = {
  id: Scalars['ID']['input'];
  eventCaptureData: InputMaybe<SavedJobEventCaptureDataInput>;
};

export type DeleteSavedJobPayload = DeleteSavedJobSuccess | DeleteSavedJobFailure;

export type DeleteSavedJobSuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteSavedJobValidationError = DeleteSavedJobError & {
  message: Scalars['String']['output'];
};


export type DeleteSavedJobValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteSeekMaxCommentAlreadyDeletedError = DeleteSeekMaxCommentError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxCommentAlreadyDeletedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxCommentAlreadyDeletedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentError = {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxCommentErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxCommentErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentFailure = {
  errors: Array<DeleteSeekMaxCommentError>;
};

export type DeleteSeekMaxCommentInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteSeekMaxCommentNotExistError = DeleteSeekMaxCommentError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxCommentNotExistErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxCommentNotExistErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentPayload = DeleteSeekMaxCommentSuccess | DeleteSeekMaxCommentFailure;

export type DeleteSeekMaxCommentSuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxCommentUserIsBannedError = DeleteSeekMaxCommentError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxCommentUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxCommentUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxModuleBookmarkError = {
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxModuleBookmarkErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxModuleBookmarkFailure = {
  errors: Array<DeleteSeekMaxModuleBookmarkError>;
};

export type DeleteSeekMaxModuleBookmarkPayload = DeleteSeekMaxModuleBookmarkSuccess | DeleteSeekMaxModuleBookmarkFailure;

export type DeleteSeekMaxModuleBookmarkSuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxReplyAlreadyDeletedError = DeleteSeekMaxReplyError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxReplyAlreadyDeletedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxReplyAlreadyDeletedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyError = {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxReplyErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxReplyErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyFailure = {
  errors: Array<DeleteSeekMaxReplyError>;
};

export type DeleteSeekMaxReplyInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteSeekMaxReplyNotExistError = DeleteSeekMaxReplyError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxReplyNotExistErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxReplyNotExistErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyPayload = DeleteSeekMaxReplySuccess | DeleteSeekMaxReplyFailure;

export type DeleteSeekMaxReplySuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxReplyUserIsBannedError = DeleteSeekMaxReplyError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxReplyUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxReplyUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadAlreadyDeletedError = DeleteSeekMaxThreadError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxThreadAlreadyDeletedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxThreadAlreadyDeletedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadError = {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxThreadErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxThreadErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadFailure = {
  errors: Array<DeleteSeekMaxThreadError>;
};

export type DeleteSeekMaxThreadInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteSeekMaxThreadNotExistError = DeleteSeekMaxThreadError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxThreadNotExistErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxThreadNotExistErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadPayload = DeleteSeekMaxThreadSuccess | DeleteSeekMaxThreadFailure;

export type DeleteSeekMaxThreadSuccess = {
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxThreadUserIsBannedError = DeleteSeekMaxThreadError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type DeleteSeekMaxThreadUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type DeleteSeekMaxThreadUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeletedSeekMaxComment = ISeekMaxComment & {
  id: Scalars['ID']['output'];
  exactSocialData: ExactCommentSocialData;
};

export type DeletedSeekMaxThread = ISeekMaxThread & {
  id: Scalars['ID']['output'];
};

export type Description = {
  paragraphs: Array<Scalars['String']['output']>;
  full: Scalars['String']['output'];
};

export type DeviceContextInput = {
  /** client generated */
  key: Scalars['UUID']['input'];
  manufacturer: InputMaybe<Scalars['String']['input']>;
  model: InputMaybe<Scalars['String']['input']>;
  /** device country is different from brand country */
  country: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  /** IETF BCP 47 Language Tag */
  locale: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<ExperimentDeviceType>;
  os: InputMaybe<ExperimentDeviceOsInput>;
};

export type DocumentDownloadLink = {
  link: Scalars['String']['output'];
};

export enum DocumentResourceType {
  Resume = 'Resume'
}

export type DocumentUploadFormData = {
  link: Scalars['String']['output'];
  key: Scalars['String']['output'];
  formFields: Array<FormField>;
};

export type Duration = {
  /** @deprecated Use labelV2 instead */
  label: Scalars['String']['output'];
  labelV2: Scalars['String']['output'];
  lengthInSeconds: Scalars['Int']['output'];
};


export type DurationLabelV2Args = {
  locale: Scalars['Locale']['input'];
};

export enum DurationContext {
  PublicProfile = 'PUBLIC_PROFILE'
}

export type DurationLeft = {
  label: Scalars['String']['output'];
};


export type DurationLeftLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type EmployeeRecommendation = {
  value: Scalars['Float']['output'];
  rating: Scalars['String']['output'];
  description: Scalars['String']['output'];
};


export type EmployeeRecommendationDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type EmployerS = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Enrichment = {
  summary: Maybe<Array<Scalars['String']['output']>>;
};

export type ExactCommentSocialData = {
  likeCount: SocialMetric;
  replyCount: SocialMetric;
};

export type ExactModuleSocialData = {
  likeCount: SocialMetric;
  commentCount: SocialMetric;
  viewCount: Maybe<SocialMetric>;
};

export type ExactThreadSocialData = {
  likeCount: SocialMetric;
  commentCount: SocialMetric;
  commentAndReplyCount: SocialMetric;
};

export type ExperienceContextInput = {
  /** client generated */
  key: Scalars['UUID']['input'];
  brand: InputMaybe<Scalars['Brand']['input']>;
  country: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  /** IETF BCP 47 Language Tag */
  language: InputMaybe<Scalars['String']['input']>;
  source: InputMaybe<Scalars['String']['input']>;
};

export type ExperimentDeviceOsInput = {
  name: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export enum ExperimentDeviceType {
  Phone = 'PHONE',
  Tablet = 'TABLET'
}

export type FeatureFlag = {
  key: Scalars['String']['output'];
  value: Maybe<Scalars['JSON']['output']>;
};

export type FeatureFlagEvaluation = {
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  value: Maybe<Scalars['JSON']['output']>;
  variation: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  error: Maybe<Scalars['String']['output']>;
  bigSegmentsStatus: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagInput = {
  companyId: InputMaybe<Scalars['String']['input']>;
  advertiserId: InputMaybe<Scalars['String']['input']>;
};

export type Featured = {
  title: Scalars['String']['output'];
  description: Maybe<Description>;
  imageUrl: Maybe<Scalars['String']['output']>;
  videoUrl: Maybe<Scalars['String']['output']>;
};

export type FeedbackError = {
  message: Scalars['String']['output'];
};


export type FeedbackErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type FeedbackFailure = {
  errors: Array<FeedbackError>;
};

export type FeedbackInput = {
  zone: Scalars['Zone']['input'];
  email: Scalars['Email']['input'];
  message: Scalars['String']['input'];
  device: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackLoggedInInput = {
  zone: Scalars['Zone']['input'];
  message: Scalars['String']['input'];
  device: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackMessageMaxLengthError = FeedbackError & {
  message: Scalars['String']['output'];
};


export type FeedbackMessageMaxLengthErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type FeedbackPayload = FeedbackSuccess | FeedbackFailure;

export type FeedbackSuccess = {
  ref: Scalars['UUID']['output'];
};

export type FileMetadata = {
  name: Scalars['String']['output'];
  size: Scalars['String']['output'];
  /** @deprecated Use virusScanStatus. */
  status: FileMetadataStatus;
  virusScanStatus: VirusScanStatus;
  uri: Scalars['String']['output'];
  sensitiveDataInfo: Maybe<SensitiveDataInfo>;
};

export enum FileMetadataStatus {
  Pending = 'Pending',
  Ok = 'OK',
  HasVirus = 'HasVirus',
  Unknown = 'Unknown'
}

export type FormField = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FreeTextQuestion = Question & {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type GfjCompany = {
  url: Maybe<Scalars['String']['output']>;
};


export type GfjCompanyUrlArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type GfjInfo = {
  location: Maybe<GfjLocation>;
  workTypes: Maybe<GfjWorkTypes>;
  company: Maybe<GfjCompany>;
};

export type GfjLocation = {
  countryCode: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  suburb: Maybe<Scalars['String']['output']>;
  postcode: Maybe<Scalars['String']['output']>;
};


export type GfjLocationCountryArgs = {
  locale?: Scalars['Locale']['input'];
};


export type GfjLocationRegionArgs = {
  locale?: Scalars['Locale']['input'];
};


export type GfjLocationStateArgs = {
  locale?: Scalars['Locale']['input'];
};


export type GfjLocationSuburbArgs = {
  locale?: Scalars['Locale']['input'];
};

export type GfjWorkTypes = {
  label: Maybe<Array<Scalars['String']['output']>>;
};

export type GenerateCoverLetterError = {
  message: Scalars['String']['output'];
};


export type GenerateCoverLetterErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type GenerateCoverLetterFailure = {
  errors: Array<GenerateCoverLetterError>;
};

export type GenerateCoverLetterInput = {
  writtenText: Scalars['String']['input'];
};

export type GenerateCoverLetterPayload = GenerateCoverLetterSuccess | GenerateCoverLetterFailure;

export type GenerateCoverLetterSuccess = {
  uri: Scalars['String']['output'];
};

export type GenerateResumeFromProfileInput = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};

export type GenerateResumeFromProfilePayload = {
  resume: Maybe<Resume>;
  viewer: Maybe<Candidate>;
};

export type GenerateSelectionCriteriaError = {
  message: Scalars['String']['output'];
};


export type GenerateSelectionCriteriaErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type GenerateSelectionCriteriaFailure = {
  errors: Array<GenerateSelectionCriteriaError>;
};

export type GenerateSelectionCriteriaInput = {
  writtenText: Scalars['String']['input'];
};

export type GenerateSelectionCriteriaPayload = GenerateSelectionCriteriaSuccess | GenerateSelectionCriteriaFailure;

export type GenerateSelectionCriteriaSuccess = {
  uri: Scalars['String']['output'];
};

export type GroupedCompanies = {
  groupName: Scalars['String']['output'];
  companies: Array<GroupedCompany>;
};

export type GroupedCompany = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type HiddenVisibilityOption = ProfileVisibilityOption & {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
};


export type HiddenVisibilityOptionNameArgs = {
  locale: Scalars['Locale']['input'];
};


export type HiddenVisibilityOptionDescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type HideJobFeedbackReason = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};


export type HideJobFeedbackReasonLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type I18nAccountError = {
  message: Scalars['String']['output'];
  code: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};


export type I18nAccountErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type I18nAccountFieldError = I18nAccountError & {
  message: Scalars['String']['output'];
  code: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  path: Maybe<I18nErrorPath>;
};


export type I18nAccountFieldErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type I18nErrorPath = {
  field: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
};

export type IJobProfileSalaryMatch = {
  label: Scalars['String']['output'];
};


export type IJobProfileSalaryMatchLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type IJobSearchNode = {
  id: Scalars['ID']['output'];
};

export type IOntologyCountry = {
  id: Scalars['String']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IOntologyEducationProvider = {
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  countries: Array<IOntologyCountry>;
  highlights: Array<SuggestionHighlight>;
};

export type IOntologyOrganisation = {
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  countries: Array<IOntologyCountry>;
  highlights: Array<SuggestionHighlight>;
};

export type IOntologyQualification = {
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  /** @deprecated Phasing out of UI */
  type: Array<QualificationLevel>;
  highlights: Array<SuggestionHighlight>;
};

export type IOntologyRoleTitle = {
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  highlights: Array<SuggestionHighlight>;
};

export type IOntologyRoleTitleSeniority = {
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  seniorityId: Maybe<Scalars['String']['output']>;
  matchedRoleTitleVariant: Scalars['String']['output'];
  matchedSeniorityVariant: Maybe<Scalars['String']['output']>;
  highlights: Array<SuggestionHighlight>;
};

export type ISeekMaxAttachmentStatus = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxCategoryGroup = {
  groupId: Scalars['ID']['output'];
};

export type ISeekMaxCertificateAttachmentStatus = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxCertificateSeekPassStatus = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxComment = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxKolGroup = {
  description: Scalars['String']['output'];
};

export type ISeekMaxModerationStatus = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxSearchContent = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxThread = {
  id: Scalars['ID']['output'];
};

export type ITrackSelected = {
  id: Scalars['String']['output'];
  session: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

export type Identity = {
  /** User requesting access to a resource. */
  subject: Subject;
  /** Operator making requests on behalf of user. */
  actor: Maybe<Actor>;
  /**
   * Indicates that the user is CS operator, regardless of whether they're actively impersonating.
   * Either true or undefined.
   */
  allowImpersonation: Maybe<Scalars['Boolean']['output']>;
  /** Indicates that the CS operator has enabled administrator mode. Either true or undefined. */
  showCustomerServiceView: Maybe<Scalars['Boolean']['output']>;
};

export type IdentityVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Job = {
  id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** @deprecated Use classifications instead */
  categories: Maybe<CategoryInfo>;
  classifications: Array<ClassificationInfo>;
  contactMatches: Maybe<Array<ContactMatches>>;
  location: LocationInfo;
  abstract: Scalars['String']['output'];
  salary: Maybe<JobSalary>;
  products: Maybe<JobProducts>;
  createdAt: SeekDateTime;
  updatedAt: SeekDateTime;
  expiresAt: SeekDateTime;
  expiredAt: Maybe<SeekDateTime>;
  listedAt: Maybe<SeekDateTime>;
  isExpired: Scalars['Boolean']['output'];
  advertiser: Advertiser;
  status: Scalars['String']['output'];
  source: Maybe<Scalars['String']['output']>;
  sourceZone: Maybe<Scalars['String']['output']>;
  /**
   * Used together with the Link-out system (Close the Loop system)
   * https://indie-jobapply-linkout-service.cloud.seek.com.au/job/<JOBID>
   * to retrieve the external link and record Candidate's action
   */
  isLinkOut: Scalars['Boolean']['output'];
  isProfileApply: Scalars['Boolean']['output'];
  workTypes: JobWorkTypes;
  shareLink: Maybe<Scalars['String']['output']>;
  tracking: Maybe<JobTracking>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  isVerified: Scalars['Boolean']['output'];
  /** @deprecated Use job-details.isChatEligible instead. Will always return null. */
  isChatEligible: Scalars['Boolean']['output'];
  /** Job URL built with brand based on candidate's zone and selected locale */
  url: Scalars['String']['output'];
};


export type JobContentArgs = {
  platform: InputMaybe<Platform>;
};


export type JobShareLinkArgs = {
  zone: Scalars['Zone']['input'];
  platform: Platform;
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type JobUrlArgs = {
  zone: Scalars['Zone']['input'];
  locale: Scalars['Locale']['input'];
};

export type JobApplicantsBadge = {
  label: Maybe<Scalars['String']['output']>;
};

export type JobApplicationArea = {
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type JobApplicationClassification = {
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  subClassification: Maybe<JobApplicationSubClassification>;
};

export type JobApplicationInsights = {
  title: Scalars['String']['output'];
  description: Scalars['String']['output'];
  applicationTipsType: JobApplicationInsightsEnum;
  date: SeekDateTime;
  stats: Array<JobApplicationInsightsStat>;
};


export type JobApplicationInsightsTitleArgs = {
  locale?: Scalars['Locale']['input'];
};


export type JobApplicationInsightsDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export enum JobApplicationInsightsEnum {
  ActivityStatusViewed = 'ACTIVITY_STATUS_VIEWED',
  ActivityStatusNotSuitable = 'ACTIVITY_STATUS_NOT_SUITABLE'
}

export type JobApplicationInsightsStat = {
  stat: Scalars['String']['output'];
  text: Scalars['String']['output'];
};


export type JobApplicationInsightsStatTextArgs = {
  locale?: Scalars['Locale']['input'];
};

export type JobApplicationLocation = {
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type JobApplicationProcess = {
  linkOut: Maybe<Scalars['Boolean']['output']>;
  classification: Maybe<JobApplicationClassification>;
  job: Maybe<Job>;
  documents: ApplicationDocuments;
  questionnaire: Maybe<Questionnaire>;
  profile: Maybe<ApplicationProfile>;
  location: Maybe<JobApplicationLocation>;
  state: Maybe<JobApplicationState>;
  area: Maybe<JobApplicationArea>;
  extractedRoleTitles: Maybe<Array<Scalars['String']['output']>>;
  /** Web apply url used by app legacy clients that may not be able to render the application requirements */
  fallbackUrl: Maybe<Scalars['String']['output']>;
};


export type JobApplicationProcessFallbackUrlArgs = {
  zone: Scalars['Zone']['input'];
};

export type JobApplicationState = {
  id: Maybe<Scalars['ID']['output']>;
};

export type JobApplicationSubClassification = {
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type JobBadges = {
  jobId: Scalars['ID']['output'];
  badges: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  badgeDetails: Maybe<Array<Maybe<BadgeDetails>>>;
};

export type JobCjs = {
  source: Maybe<CjsSource>;
  salary: Maybe<SalaryCjs>;
  product: Maybe<ProductCjs>;
};

export type JobDetails = {
  job: Job;
  /**
   * GFJInfo is used to provide information needed to show job postings on Google for Jobs.
   * This is strictly used for the above and should not be used for any other purpose.
   */
  gfjInfo: Maybe<GfjInfo>;
  /**
   * SEOInfo is used to provide information for SEO initiatives within the JDV.
   * This is strictly used for the above and should not be used for any other purpose.
   */
  seoInfo: Maybe<SeoInfo>;
  /** @deprecated This is the legacy company profile schema, a new resolver will need to be added */
  companyProfile: Maybe<CompanyProfile>;
  learningInsights: Maybe<LearningInsights>;
  companyReviews: Maybe<CompanyReviews>;
  companySearchUrl: Maybe<Scalars['String']['output']>;
  /**
   * Sourcr is a Product used by Seek for matching recruiters email addresses and phone numbers
   * Note: it is not a misspelling
   * @deprecated Use sourcrRecruiter
   */
  sourcr: Maybe<JobDetailsSourcr>;
  sourcrRecruiter: Maybe<SourcrRecruiter>;
  personalised: Maybe<PersonalisedJobDetails>;
  companyTags: Array<CompanyTag>;
  recommendedJobs: Maybe<Array<JobDetailsRecommendedJob>>;
  /** Defines the type of application channel available to the candidate */
  applicationChannel: Maybe<ApplicationChannel>;
  /** Provides a message concerning whether a candidate may apply */
  restrictedApplication: JobDetailsRestrictedApplication;
  /**
   * isChatEligible is experimental and will be deprecated after the APEX chat POC is completed
   * @deprecated Feature retired
   */
  isChatEligible: Maybe<Scalars['Boolean']['output']>;
  workArrangements: Maybe<JobDetailsWorkArrangements>;
  /** The insights of job details */
  insights: Maybe<Array<Maybe<JobInsight>>>;
};


export type JobDetailsCompanyProfileArgs = {
  zone: Scalars['Zone']['input'];
};


export type JobDetailsLearningInsightsArgs = {
  platform: Platform;
  zone: Scalars['Zone']['input'];
  locale?: Scalars['Locale']['input'];
};


export type JobDetailsCompanyReviewsArgs = {
  zone: Scalars['Zone']['input'];
};


export type JobDetailsCompanySearchUrlArgs = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type JobDetailsRecommendedJobsArgs = {
  zone: Scalars['Zone']['input'];
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
};


export type JobDetailsApplicationChannelArgs = {
  zone: Scalars['Zone']['input'];
};


export type JobDetailsRestrictedApplicationArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
};


export type JobDetailsWorkArrangementsArgs = {
  channel: Scalars['String']['input'];
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
};

export type JobDetailsRecommendedJob = {
  job: Maybe<Job>;
  solMetadata: Maybe<Scalars['JSON']['output']>;
};

export type JobDetailsRestrictedApplication = {
  label: Maybe<Scalars['String']['output']>;
};


export type JobDetailsRestrictedApplicationLabelArgs = {
  locale: Scalars['Locale']['input'];
};

/**
 * Sourcr is a Product used by Seek for matching recruiters email addresses and phone numbers
 * Note: it is not a misspelling
 */
export type JobDetailsSourcr = {
  link: Scalars['String']['output'];
  image: Scalars['String']['output'];
  imageMobile: Scalars['String']['output'];
};

export type JobDetailsTrackingInput = {
  sessionId: Scalars['String']['input'];
  channel: Scalars['String']['input'];
  jobDetailsViewedCorrelationId: Scalars['String']['input'];
};

export type JobDetailsWorkArrangement = {
  type: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};


export type JobDetailsWorkArrangementLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobDetailsWorkArrangements = {
  arrangements: Maybe<Array<Maybe<JobDetailsWorkArrangement>>>;
  label: Maybe<Scalars['String']['output']>;
};


export type JobDetailsWorkArrangementsLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobDisplayTag = {
  label: Scalars['String']['output'];
};


export type JobDisplayTagLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobHistoryDateInput = {
  year: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
};

export type JobHistoryInput = {
  from: JobHistoryDateInput;
  to: InputMaybe<JobHistoryDateInput>;
};

export type JobInput = {
  title: InputMaybe<Scalars['String']['input']>;
  roleTitleId: InputMaybe<Scalars['String']['input']>;
  workType: InputMaybe<Scalars['String']['input']>;
  isJobTitleAnonymised: InputMaybe<Scalars['Boolean']['input']>;
  location: JobLocationEntityInput;
  history: InputMaybe<JobHistoryInput>;
};

export type JobInsight = {
  message: Scalars['String']['output'];
};


export type JobInsightMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobLocationEntityInput = {
  locationId: InputMaybe<Scalars['Int']['input']>;
  fullLocation: InputMaybe<Scalars['String']['input']>;
};

export type JobNudge = {
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type JobPreferencesCompanyFeedbackReason = JobPreferencesFeedbackReason & {
  reason: Scalars['String']['output'];
  label: Scalars['String']['output'];
  displayText: Maybe<Scalars['String']['output']>;
  saveJobPreferencesArgs: Maybe<SaveJobPreferencesArgs>;
};


export type JobPreferencesCompanyFeedbackReasonLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type JobPreferencesCompanyFeedbackReasonDisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesEmploymentTypeFeedbackReason = JobPreferencesFeedbackReason & {
  reason: Scalars['String']['output'];
  label: Scalars['String']['output'];
  displayText: Maybe<Scalars['String']['output']>;
  saveJobPreferencesArgs: Maybe<SaveJobPreferencesArgs>;
};


export type JobPreferencesEmploymentTypeFeedbackReasonLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type JobPreferencesEmploymentTypeFeedbackReasonDisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesFeedbackReason = {
  reason: Scalars['String']['output'];
  label: Scalars['String']['output'];
  displayText: Maybe<Scalars['String']['output']>;
  saveJobPreferencesArgs: Maybe<SaveJobPreferencesArgs>;
};


export type JobPreferencesFeedbackReasonLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type JobPreferencesFeedbackReasonDisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesFeedbackReasons = {
  reasons: Maybe<Array<Maybe<JobPreferencesFeedbackReason>>>;
};

export type JobPreferencesLocationFeedbackReason = JobPreferencesFeedbackReason & {
  reason: Scalars['String']['output'];
  label: Scalars['String']['output'];
  displayText: Maybe<Scalars['String']['output']>;
  saveJobPreferencesArgs: Maybe<SaveJobPreferencesArgs>;
};


export type JobPreferencesLocationFeedbackReasonLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type JobPreferencesLocationFeedbackReasonDisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesRoleTitleFeedbackReason = JobPreferencesFeedbackReason & {
  reason: Scalars['String']['output'];
  label: Scalars['String']['output'];
  displayText: Maybe<Scalars['String']['output']>;
  saveJobPreferencesArgs: Maybe<SaveJobPreferencesArgs>;
};


export type JobPreferencesRoleTitleFeedbackReasonLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type JobPreferencesRoleTitleFeedbackReasonDisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobProductBranding = {
  id: Scalars['ID']['output'];
  logo: JobProductBrandingImage;
  cover: Maybe<JobProductBrandingImage>;
};


export type JobProductBrandingCoverArgs = {
  isThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobProductBrandingImage = {
  url: Scalars['String']['output'];
  aspectRatio: Maybe<Scalars['Float']['output']>;
};

export type JobProducts = {
  video: Maybe<VideoProduct>;
  bullets: Maybe<Array<Scalars['String']['output']>>;
  branding: Maybe<JobProductBranding>;
  questionnaire: Maybe<JobQuestionnaire>;
  displayTags: Array<JobDisplayTag>;
};

export type JobProfileMissingSalaryPreference = IJobProfileSalaryMatch & {
  label: Scalars['String']['output'];
};


export type JobProfileMissingSalaryPreferenceLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobProfileSalaryMatch = IJobProfileSalaryMatch & {
  label: Scalars['String']['output'];
  salaryPreference: SalaryPreference2;
};


export type JobProfileSalaryMatchLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type JobProfileSalaryMatchSalaryPreferenceArgs = {
  locale: Scalars['Locale']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type JobProfileSalaryNoMatch = IJobProfileSalaryMatch & {
  label: Scalars['String']['output'];
};


export type JobProfileSalaryNoMatchLabelArgs = {
  locale: Scalars['Locale']['input'];
};

/**
 * This is a simplified read-only questionnaire
 * which informs Candidates the questions they will
 * likely need to answer as part of the Application process
 */
export type JobQuestionnaire = {
  id: Scalars['ID']['output'];
  questions: Array<Scalars['String']['output']>;
};

export type JobS = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  abstract: Scalars['String']['output'];
  adDisplay: Scalars['String']['output'];
  createdAt: SeekDateTime;
  employer: Maybe<EmployerS>;
  salary: SalaryS;
  location: Maybe<LocationS>;
  advertiser: Maybe<AdvertiserS>;
  categoryIds: Maybe<Array<Scalars['ID']['output']>>;
  cjs: Maybe<JobCjs>;
};

export type JobSalary = {
  label: Scalars['String']['output'];
  currencyLabel: Maybe<Scalars['String']['output']>;
};


export type JobSalaryCurrencyLabelArgs = {
  zone: Scalars['Zone']['input'];
};

export type JobSearchAssist = {
  pills: Maybe<JobSearchAssistPills>;
};

export type JobSearchAssistPill = {
  label: Scalars['String']['output'];
  keywords: Scalars['String']['output'];
  stateToken: Scalars['Base64Url']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type JobSearchAssistPills = {
  token: Scalars['Base64Url']['output'];
  data: Maybe<Array<JobSearchAssistPill>>;
};

export type JobSearchCanonical = {
  keyword: Maybe<Scalars['String']['output']>;
  locations: Maybe<Array<JobSearchCanonicalLocation>>;
};

export type JobSearchCanonicalLocation = {
  id: Scalars['ID']['output'];
  countryCode: Maybe<Scalars['String']['output']>;
  displayName: Maybe<JobSearchCanonicalLocationDisplayName>;
};

export type JobSearchCanonicalLocationDisplayName = {
  lang: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type JobSearchFacet = {
  id: Scalars['ID']['output'];
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type JobSearchFacets = {
  advertiser: Maybe<Array<Maybe<JobSearchLocalisedFacet>>>;
  distinctTitle: Maybe<Array<Maybe<JobSearchFacet>>>;
  category: Maybe<Array<Maybe<JobSearchLocalisedFacet>>>;
  createdAt: Maybe<Array<Maybe<JobSearchFacet>>>;
  employer: Maybe<Array<Maybe<JobSearchFacet>>>;
  location: Maybe<Array<Maybe<JobSearchLocalisedFacet>>>;
  salaryMax: Maybe<Array<Maybe<JobSearchFacet>>>;
  salaryMin: Maybe<Array<Maybe<JobSearchFacet>>>;
  title: Maybe<Array<Maybe<JobSearchFacet>>>;
  workArrangement: Maybe<Array<Maybe<JobSearchLocalisedFacet>>>;
  workType: Maybe<Array<Maybe<JobSearchLocalisedFacet>>>;
};

export enum JobSearchIntent {
  Search = 'SEARCH',
  Count = 'COUNT',
  Company = 'COMPANY',
  Related = 'RELATED',
  Facet = 'FACET',
  Other = 'OTHER'
}

export type JobSearchJobEdge = IJobSearchNode & {
  id: Scalars['ID']['output'];
  node: JobS;
};

export enum JobSearchListItems {
  Nudges = 'NUDGES'
}

export type JobSearchLocalisedFacet = {
  id: Scalars['ID']['output'];
  count: Scalars['Int']['output'];
  label: JobSearchLocalisedText;
};

export type JobSearchLocalisedText = {
  lang: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type JobSearchLocationQueryParamLabel = {
  id: Scalars['ID']['output'];
  label: Maybe<JobSearchLocalisedText>;
  contextualName: Maybe<JobSearchLocalisedText>;
  kind: Maybe<Scalars['String']['output']>;
};

export type JobSearchNudgeEdge = IJobSearchNode & {
  id: Scalars['ID']['output'];
  node: JobNudge;
};

export type JobSearchPageInfo = {
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  resultCount: Scalars['Int']['output'];
  totalJobs: Scalars['Int']['output'];
};

export type JobSearchQueryMeter = {
  entities: Maybe<Array<JobSearchQueryMeterEntity>>;
  searchStrength: JobSearchQueryMeterSearchStrength;
};

export type JobSearchQueryMeterEntity = {
  label: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
};


export type JobSearchQueryMeterEntityDescriptionArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobSearchQueryMeterSearchStrength = {
  label: Maybe<Scalars['String']['output']>;
  rating: Scalars['Int']['output'];
};

export type JobSearchQueryParamLabels = {
  keywords: Maybe<Scalars['String']['output']>;
  locations: Maybe<Array<Maybe<JobSearchLocationQueryParamLabel>>>;
};

export type JobSearchQueryParametersInput = {
  keywords: InputMaybe<Scalars['String']['input']>;
  locationText: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<Scalars['Int']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  seekTest: InputMaybe<Scalars['Boolean']['input']>;
  source: JobSearchSource;
  intent: JobSearchIntent;
  siteKey: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  include: InputMaybe<Array<SmarterSearchInclude>>;
};

export type JobSearchRelatedSearch = {
  keywords: Maybe<Scalars['String']['output']>;
  totalJobs: Maybe<Scalars['Int']['output']>;
};

export type JobSearchResult = {
  /**
   * UNSTABLE! A list of jobs, and optionally any other type of items specified in the listTypes input parameter.
   * This is where the tension point of weaving other data into the search results pops up.
   * Postively, putting listTypes here signifies something is going on.
   * Calling it jobs though?? Maybe call it edges to be really clear, its the edge/node pattern.
   */
  jobs: Maybe<Array<IJobSearchNode>>;
  page: Maybe<JobSearchPageInfo>;
  canonical: Maybe<JobSearchCanonical>;
  suggestions: Maybe<JobSearchSuggestions>;
  facets: Maybe<JobSearchFacets>;
  queryParamLabels: Maybe<JobSearchQueryParamLabels>;
};


export type JobSearchResultJobsArgs = {
  listTypes: Array<JobSearchListItems>;
};

export enum JobSearchSource {
  FrontEnd = 'FRONT_END',
  Seo = 'SEO',
  Company = 'COMPANY',
  Related = 'RELATED',
  Saved = 'SAVED',
  Recent = 'RECENT',
  Reviews = 'REVIEWS',
  Quick = 'QUICK',
  Other = 'OTHER'
}

export type JobSearchSuggestions = {
  relatedSearches: Maybe<Array<JobSearchRelatedSearch>>;
};

/** Parameters for job search v5 API query recommendations. */
export type JobSearchV5ApiParameters = {
  type: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type JobTag = {
  type: Scalars['String']['output'];
  label: Maybe<Scalars['String']['output']>;
};


export type JobTagLabelArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type JobTracking = {
  isScreenAssigned: Maybe<Scalars['Boolean']['output']>;
  hasRoleRequirements: Maybe<Scalars['Boolean']['output']>;
  isPrivateAdvertiser: Maybe<Scalars['Boolean']['output']>;
  isRightToWorkRequired: Maybe<Scalars['Boolean']['output']>;
  locationInfo: Maybe<JobTrackingLocationInfo>;
  classificationInfo: Maybe<JobTrackingClassificationInfo>;
  adProductType: Maybe<Scalars['String']['output']>;
  workTypeIds: Maybe<Scalars['String']['output']>;
  postedTime: Maybe<Scalars['String']['output']>;
};

export type JobTrackingClassificationInfo = {
  classificationId: Maybe<Scalars['String']['output']>;
  classification: Maybe<Scalars['String']['output']>;
  subClassificationId: Maybe<Scalars['String']['output']>;
  subClassification: Maybe<Scalars['String']['output']>;
};

export type JobTrackingLocationInfo = {
  locationIds: Maybe<Array<Scalars['String']['output']>>;
  location: Maybe<Scalars['String']['output']>;
  area: Maybe<Scalars['String']['output']>;
};

export type JobWorkTypes = {
  label: Scalars['String']['output'];
};


export type JobWorkTypesLabelArgs = {
  locale?: Scalars['Locale']['input'];
};

export type KeyValue = {
  key: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type KeyValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type KeywordSuggestion = {
  text: Scalars['String']['output'];
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights: Array<SuggestionHighlight>;
};

/** KeywordSuggestionGroup is a collection of pre-defined suggestions e.g. Recent */
export type KeywordSuggestionGroup = {
  type: SuggestionGroupType;
  label: Scalars['String']['output'];
  suggestions: Array<KeywordSuggestion>;
};

export type KeywordSuggestionType = KeywordSuggestionGroup | KeywordSuggestion;

export enum LanguageCode {
  En = 'en',
  Id = 'id',
  Ms = 'ms',
  Th = 'th',
  Tl = 'tl',
  Vi = 'vi'
}

export type LanguageProficiency = {
  id: Scalars['UUID']['output'];
  name: OntologyStructuredData;
};

export type LastAnswer = {
  id: Scalars['String']['output'];
  uri: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type LastWrittenCoverLetter = {
  content: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LearningInsights = {
  content: Scalars['String']['output'];
  action: Maybe<LearningInsightsAction>;
  analytics: Maybe<Scalars['JSON']['output']>;
};

export type LearningInsightsAction = {
  url: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Licence = {
  id: Scalars['UUID']['output'];
  credential: Maybe<BaseCredential>;
  description: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer shown in UI. Use expiryStatus instead */
  expiryDate: Maybe<MonthYear>;
  formattedDate: Maybe<Scalars['String']['output']>;
  issueDate: Maybe<MonthYear>;
  issuingOrganisation: Maybe<Scalars['String']['output']>;
  name: OntologyStructuredData;
  noExpiryDate: Scalars['Boolean']['output'];
  status: Maybe<LicenceStatus>;
  verificationUrl: Maybe<Scalars['String']['output']>;
  verificationMessage: Maybe<Scalars['String']['output']>;
  credentialType: Maybe<Scalars['String']['output']>;
  isVerified: Scalars['Boolean']['output'];
};

export enum LicenceStatus {
  New = 'New',
  /** @deprecated No longer shown in UI */
  ExpiresSoon = 'ExpiresSoon',
  Expired = 'Expired'
}

export type LicenceVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
  /** Translated string used to prompt verification of a licence, e.g. "Verify your Driver's Licence" */
  verificationMessage: Maybe<Scalars['String']['output']>;
  /** String representing the entity type provided by Ontology for tracking purposes, e.g. 'Drivers Licence' */
  trackingEntityName: Maybe<Scalars['String']['output']>;
  expiryStatus: Maybe<CredentialExpiryStatus>;
};

export type LimitedVisibilityOption = ProfileVisibilityOption & {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
};


export type LimitedVisibilityOptionNameArgs = {
  locale: Scalars['Locale']['input'];
};


export type LimitedVisibilityOptionDescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type LinkoutChannel = ApplicationChannel & {
  label: Maybe<Scalars['String']['output']>;
};


export type LinkoutChannelLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type LiteProfileUpdateInput = {
  aboutYouName: Scalars['String']['input'];
  aboutYouEmail: Scalars['String']['input'];
  organisationName: Scalars['String']['input'];
  brandId: InputMaybe<Scalars['String']['input']>;
  accountPrimaryContact: Scalars['String']['input'];
};

export type LiteProfileUpdateNotificationPayload = {
  success: Scalars['Boolean']['output'];
};

export type Location2 = {
  id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  countryCode: Scalars['CountryCodeIso2']['output'];
  kind: Scalars['String']['output'];
  isDeprecated: Maybe<Scalars['Boolean']['output']>;
};

export type LocationDisplayName = {
  lang: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type LocationInfo = {
  label: Scalars['String']['output'];
};


export type LocationInfoLabelArgs = {
  language: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
  type: InputMaybe<LocationLabelType>;
};

export enum LocationLabelType {
  Short = 'SHORT',
  Long = 'LONG'
}

export type LocationRadiusOption = {
  shortLabel: Scalars['String']['output'];
  longLabel: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};


export type LocationRadiusOptionShortLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type LocationRadiusOptionLongLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type LocationS = {
  id: Scalars['ID']['output'];
  countryCode: Maybe<Scalars['String']['output']>;
  displayName: Maybe<LocationDisplayName>;
};

export type LocationSuggestion = {
  id: Scalars['String']['output'];
  partnerId: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights: Array<SuggestionHighlight>;
  isGranular: Scalars['Boolean']['output'];
  defaultDistanceKms: Maybe<Scalars['Float']['output']>;
};

/** LocationSuggestionGroup is a collection of pre-defined suggestions e.g. Recent or Suggested Area */
export type LocationSuggestionGroup = {
  type: SuggestionGroupType;
  label: Scalars['String']['output'];
  suggestions: Array<LocationSuggestion>;
};

export type LocationSuggestionType = LocationSuggestionGroup | LocationSuggestion;

export type LoggedOutRecommendedGlobalJob = {
  solMetadata: Scalars['JSON']['output'];
  job: Maybe<Job>;
};

export type LoggedOutRecommendedGlobalJobs = {
  globalJobs: Maybe<Array<Maybe<LoggedOutRecommendedGlobalJob>>>;
  solMetadata: Maybe<Scalars['JSON']['output']>;
};

export type MkLocationSuggestion = {
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  countryCode: Scalars['CountryCodeIso2']['output'];
};

export type MkLocationTrackSelectedResponse = {
  id: Scalars['Int']['output'];
};

export type MarkAsPreferredApplicationDuplicateError = MarkAsPreferredApplicationError & {
  message: Scalars['String']['output'];
};


export type MarkAsPreferredApplicationDuplicateErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationError = {
  message: Scalars['String']['output'];
};


export type MarkAsPreferredApplicationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationFailure = {
  errors: Array<MarkAsPreferredApplicationError>;
};

export type MarkAsPreferredApplicationInput = {
  applicationRequestId: Scalars['ID']['input'];
};

export type MarkAsPreferredApplicationNotEligibleJobError = MarkAsPreferredApplicationError & {
  message: Scalars['String']['output'];
};


export type MarkAsPreferredApplicationNotEligibleJobErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationNotEnoughCreditError = MarkAsPreferredApplicationError & {
  message: Scalars['String']['output'];
};


export type MarkAsPreferredApplicationNotEnoughCreditErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationPayload = MarkAsPreferredApplicationSuccess | MarkAsPreferredApplicationFailure;

export type MarkAsPreferredApplicationSuccess = {
  credit: PriorityApplyCandidateCredit;
};

export type MarqueeCompanyProfile = {
  /** primary key: Company ID */
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  /** foreign key: Ontology Organisation ID */
  organizationId: Maybe<Scalars['ID']['output']>;
  logo: Maybe<Scalars['String']['output']>;
  reviews: Maybe<CompanyProfileReviewsSummary>;
  url: Maybe<Scalars['String']['output']>;
  companyNameSlug: Maybe<Scalars['String']['output']>;
  jobCount: Maybe<Scalars['Int']['output']>;
  serviceToken: Scalars['UUID']['output'];
};

export type MatchedQualities = {
  matched: Maybe<Array<Maybe<Skill>>>;
  inferred: Maybe<Array<Maybe<Skill>>>;
  unmatched: Maybe<Array<Maybe<Skill>>>;
};

export type MatchedSkills = {
  matchedQualitiesRequestToken: Maybe<Scalars['String']['output']>;
  matched: Maybe<Array<Maybe<Quality>>>;
  inferred: Maybe<Array<Maybe<Quality>>>;
  unmatched: Maybe<Array<Maybe<Quality>>>;
};

export type MissionStatement = {
  description: Description;
};

export type MobileNotiError = {
  message: Scalars['String']['output'];
};


export type MobileNotiErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MobileNotiFailure = {
  errors: Array<MobileNotiError>;
};

export type MobileNotiServiceUnavailableError = MobileNotiError & {
  message: Scalars['String']['output'];
};


export type MobileNotiServiceUnavailableErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MobileNotiUnknownError = MobileNotiError & {
  message: Scalars['String']['output'];
};


export type MobileNotiUnknownErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type MobilePlatformNoti = {
  name: Scalars['String']['input'];
  service: Scalars['String']['input'];
  client: Scalars['String']['input'];
};

export type MonthYear = {
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type MonthYearInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type MostRecentRoleInput = {
  company: Scalars['String']['input'];
  title: Scalars['String']['input'];
  started: MonthYearInput;
  finished: InputMaybe<MonthYearInput>;
};

export type MultipleChoiceQuestion = Question & {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  options: Array<QuestionOption>;
  lastAnswers: Maybe<Array<LastAnswer>>;
};

export type Mutation = {
  changeEmailAddress: Maybe<ChangeEmailAddressPayload>;
  changePassword: Maybe<ChangePasswordPayload>;
  deleteAccount: Maybe<DeleteAccountPayload>;
  sendLoginCallbackEvent: Maybe<SendLoginCallbackEventPayload>;
  changeEmailStart: Maybe<ChangeEmailStartPayload>;
  changeEmailVerify: Maybe<ChangeEmailVerifyPayload>;
  createApacSavedSearch: CreateApacSavedSearchPayload;
  deleteApacSavedSearch: DeleteApacSavedSearchPayload;
  subscribeApacSavedEmailAlert: SubscribeApacSavedEmailAlertPayload;
  unsubscribeApacSavedSearchByCode: UnsubscribeApacSavedSearchByCodePayload;
  resubscribeApacSavedSearchByCode: ResubscribeApacSavedSearchByCodePayload;
  createUnregisteredApacSavedSearchWithChecksum: CreateUnregisteredApacSavedSearchWithChecksumPayload;
  setAppliedJobNotes: SetAppliedJobNotesPayload;
  deleteAppliedJob: DeleteAppliedJobPayload;
  /** Create a consent for a given transactionId */
  createConsent: CreateConsentPayload;
  /** Reject consent for a given transactionId */
  rejectConsent: RejectConsentPayload;
  updateApproachability: UpdateApproachabilityPayload;
  /** This mutation is utilised to complete the uploading process. */
  processUploadedAttachment: Maybe<ProcessUploadedAttachmentPayload>;
  /** @deprecated Use updateAvailability instead */
  updateNoticePeriod: Maybe<UpdateNoticePeriodPayload>;
  updateAvailability: Maybe<UpdateNoticePeriodPayload>;
  /** UNSTABLE! */
  saveJobPreferences: Maybe<SaveJobPreferencesPayload>;
  /** UNSTABLE! */
  deleteJobPreferences: Maybe<DeleteJobPreferencesPayload>;
  updateMarketInsightsPreferences: Maybe<UpdateMarketInsightsPreferencesPayload>;
  updateCareerObjectives: Maybe<UpdateCareerObjectivesPayload>;
  /** @deprecated This does nothing. This will be removed in the future. */
  liteProfileUpdateNotification: Maybe<LiteProfileUpdateNotificationPayload>;
  postCompanyProfileReviewUpvotes: Maybe<PostCompanyProfileReviewUpvotesPayload>;
  postCompanyProfileReviewFlag: Maybe<PostCompanyProfileReviewFlagPayload>;
  postCompanyReview: PostCompanyReviewPayload;
  postCompanyReviewExperiment2: Maybe<PostCompanyReviewExperiment2Payload>;
  updateCurrentLocation2: UpdateCurrentLocation2Payload;
  feedback: Maybe<FeedbackPayload>;
  feedbackLoggedIn: Maybe<FeedbackPayload>;
  submitApplication: SubmitApplicationPayload;
  generateCoverLetter: GenerateCoverLetterPayload;
  generateSelectionCriteria: GenerateSelectionCriteriaPayload;
  trackJobApplicationStarted: TrackJobApplicationStartedPayload;
  markAsPreferredApplication: Maybe<MarkAsPreferredApplicationPayload>;
  createLinkoutApplication: Maybe<CreateLinkoutApplicationPayload>;
  trackJobDetailsViewed: TrackJobDetailsViewedPayload;
  trackSearchResultSelected: TrackSearchResultSelectedPayload;
  /** UNSTABLE! */
  createCandidateJobMatchRequest: Maybe<CreateCandidateJobMatchResponse>;
  updateLanguageProficiency: UpdateLanguageProficiencyPayload;
  deleteLanguageProficiency: DeleteLanguageProficiencyPayload;
  updateLicence: UpdateLicencePayload;
  deleteLicence: DeleteLicencePayload;
  updateVerifiedLicence: UpdateVerifiedLicencePayload;
  mkTrackLocationSuggestionSelection: MkLocationTrackSelectedResponse;
  subscribeMobileNotifications: SubscribeMobileNotiPayload;
  unsubscribeMobileNotifications: UnsubscribeMobileNotiPayload;
  updateNotificationCtpSubscriptionWithToken: Maybe<UpdateNotificationCtpSubscriptionWithTokenPayload>;
  updateNotificationCtpPreferences: Maybe<UpdateNotificationCtpPreferencesPayload>;
  updatePersonalDetails: Maybe<UpdatePersonalDetailsPayload>;
  updatePreferredClassification: UpdatePreferredClassificationPayload;
  updatePreferredLocations2: UpdatePreferredLocations2Payload;
  /** EXPERIMENTAL! */
  updatePreferredRoleTitles: Maybe<UpdatePreferredRoleTitlesPayload>;
  updateProfileVisibility: UpdateProfileVisibilityPayload;
  updateProfileVisibility2: UpdateProfileVisibility2Payload;
  provisionAccount: Maybe<ProvisionAccountPayload>;
  updateQualification: Maybe<UpdateQualificationPayload>;
  deleteQualification: Maybe<DeleteQualificationPayload>;
  confirmQualification: ConfirmQualificationPayload;
  updateVerifiedQualification: UpdateVerifiedQualificationPayload;
  reportJob: ReportJobPayload;
  reportProfile: ReportProfilePayload;
  /** Delete the specified from a candidates profile */
  deleteResume: Maybe<DeleteResumePayload>;
  /**
   * This mutation will generate a resume from the candidates profile. The generated
   * resume will be stored in the profile.
   */
  generateResumeFromProfile: Maybe<GenerateResumeFromProfilePayload>;
  /** Set the default resume for a candidate. */
  setDefaultResume: Maybe<SetDefaultResumePayload>;
  /**
   * This mutation is utilised to complete the uploading process. Plus, it also triggers the parsing for this resume
   * via the contextId passed by clients, and it is only used for uploading parsing.
   */
  processUploadedResume: Maybe<ProcessUploadedResumeResult>;
  /**
   * This mutation is only used for selected|scheduled resume parsing (selecting one of the previously uploaded resumes during
   * job apply process) and default resume parsing (making an uploaded resume the primary|default one on profile page),
   * the contextId set by clients is the key to this parsing.
   */
  requestResumeParsing: Maybe<MutationResult>;
  updateRightsToWork: UpdateRightsToWorkPayload;
  updateRole: Maybe<UpdateRolePayload>;
  deleteRole: Maybe<DeleteRolePayload>;
  confirmRole: Maybe<ConfirmRolePayload>;
  /** @deprecated Use rejectUnconfirmedData instead */
  rejectRole: Maybe<RejectRolePayload>;
  /** Add feedback for a salary nudge */
  addSalaryNudgeFeedback: CandidateSalaryNudgeFeedbackPayload;
  updateSalaryPreferences: UpdateSalaryPreferencesPayload;
  createSavedJob2: CreateSavedJobPayload;
  deleteSavedJob2: DeleteSavedJobPayload;
  setSavedJobNotes: SetSavedJobNotesPayload;
  _empty: Maybe<Scalars['String']['output']>;
  /** @deprecated This functionality is retired */
  createShareableProfileSettings: CreateShareableProfileSettingsPayload;
  /** @deprecated This functionality is retired */
  updateShareableProfileSettings: UpdateShareableProfileSettingsPayload;
  /** @deprecated This functionality is retired */
  updateShareableProfileViews: UpdateShareableProfileViewsPayload;
  updateSkills: Maybe<UpdateSkillsPayload>;
  submitSourcrPageAnalyticsEvent: Maybe<SubmitSourcrPageAnalyticsEventPayload>;
  submitMessage: Maybe<SubmitSourcrMessagePayload>;
  rejectUnconfirmedData: RejectUnconfirmedDataPayload;
  updatePreferredWorkTypes: Maybe<UpdateWorkTypesPayload>;
  /** @deprecated Its no longer being used in production after unification. Will be removed in future releases. */
  updateYearsOfExperience: UpdateYearsOfExperiencePayload;
  createSeekMaxThread: CreateSeekMaxThreadPayload;
  /** @deprecated Use createSeekMaxThreadModeration instead */
  createSeekMaxThreadV2: CreateSeekMaxThreadPayload;
  createSeekMaxThreadModeration: Maybe<CreateSeekMaxThreadPayload>;
  deleteSeekMaxThread: DeleteSeekMaxThreadPayload;
  reportSeekMaxThread: ReportSeekMaxThreadPayload;
  setSeekMaxThreadLikedStatus: SetSeekMaxThreadLikedStatusPayload;
  setSeekMaxThreadPollStatus: SetSeekMaxThreadPollStatusPayload;
  /** @deprecated Use createSeekMaxCommentModeration instead */
  createSeekMaxComment: CreateSeekMaxCommentPayload;
  createSeekMaxCommentModeration: Maybe<CreateSeekMaxCommentPayload>;
  deleteSeekMaxComment: DeleteSeekMaxCommentPayload;
  reportSeekMaxComment: ReportSeekMaxCommentPayload;
  setSeekMaxCommentLikedStatus: SetSeekMaxCommentLikedStatusPayload;
  /** @deprecated Use createSeekMaxReplyModeration instead */
  createSeekMaxReply: CreateSeekMaxReplyPayload;
  createSeekMaxReplyModeration: Maybe<CreateSeekMaxReplyPayload>;
  deleteSeekMaxReply: DeleteSeekMaxReplyPayload;
  reportSeekMaxReply: ReportSeekMaxReplyPayload;
  setSeekMaxCategoryGroupFollowedStatus: SetSeekMaxCategoryGroupFollowedStatusPayload;
  updateSeekMaxMyThreadsLastViewed: Maybe<UpdateSeekMaxMyThreadsLastViewedPayload>;
  saveSeekMaxKeywordSearch: SaveSeekMaxKeywordSearchPayload;
  createSeekMaxModuleBookmark: CreateSeekMaxModuleBookmarkPayload;
  deleteSeekMaxModuleBookmark: DeleteSeekMaxModuleBookmarkPayload;
  addSeekMaxCertificateToSeekPass: AddSeekMaxCertificateToSeekPassPayload;
  setSeekMaxModuleLikedStatus: SetSeekMaxModuleLikedStatusPayload;
  sendSeekMaxModuleProgress: SeekMaxModuleProgressPayload;
  sendSeekMaxVideoViewedEvent: SeekMaxVideoViewedEventPayload;
  sendSeekMaxModuleClickedEvent: SendSeekMaxModuleClickedEventPayload;
  sendSeekMaxVideoViewedPersonalisationEvent: SeekMaxVideoViewedPersonalisationEventPayload;
  sendSeekMaxModuleClickedPersonalisationEvent: SeekMaxModuleClickedPersonalisationEventPayload;
  /** UNSTABLE! */
  sendSeekMaxThreadViewedPersonalisationEvent: SeekMaxThreadViewedPersonalisationEventPayload;
};


export type MutationChangeEmailAddressArgs = {
  input: ChangeEmailAddressInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationChangeEmailStartArgs = {
  input: ChangeEmailStartInput;
};


export type MutationChangeEmailVerifyArgs = {
  input: ChangeEmailVerifyInput;
};


export type MutationCreateApacSavedSearchArgs = {
  input: CreateApacSavedSearchInput;
};


export type MutationDeleteApacSavedSearchArgs = {
  input: DeleteApacSavedSearchInput;
};


export type MutationSubscribeApacSavedEmailAlertArgs = {
  input: SubscribeApacSavedEmailAlertInput;
};


export type MutationUnsubscribeApacSavedSearchByCodeArgs = {
  input: UnsubscribeApacSavedSearchByCodeInput;
};


export type MutationResubscribeApacSavedSearchByCodeArgs = {
  input: ResubscribeApacSavedSearchByCodeInput;
};


export type MutationCreateUnregisteredApacSavedSearchWithChecksumArgs = {
  input: CreateUnregisteredApacSavedSearchWithChecksumInput;
};


export type MutationSetAppliedJobNotesArgs = {
  input: SetAppliedJobNotesInput;
};


export type MutationDeleteAppliedJobArgs = {
  input: DeleteAppliedJobInput;
};


export type MutationCreateConsentArgs = {
  input: CreateConsentInput;
};


export type MutationRejectConsentArgs = {
  input: RejectConsentInput;
};


export type MutationUpdateApproachabilityArgs = {
  input: UpdateApproachabilityInput;
};


export type MutationProcessUploadedAttachmentArgs = {
  input: ProcessUploadedAttachmentInput;
};


export type MutationUpdateNoticePeriodArgs = {
  input: UpdateNoticePeriodInput;
};


export type MutationUpdateAvailabilityArgs = {
  input: UpdateAvailabilityInput;
};


export type MutationSaveJobPreferencesArgs = {
  input: Array<SaveJobPreferencesInput>;
};


export type MutationDeleteJobPreferencesArgs = {
  input: Array<DeleteJobPreferencesInput>;
};


export type MutationUpdateMarketInsightsPreferencesArgs = {
  input: UpdateMarketInsightsPreferencesInput;
};


export type MutationUpdateCareerObjectivesArgs = {
  input: UpdateCareerObjectivesInput;
};


export type MutationLiteProfileUpdateNotificationArgs = {
  input: LiteProfileUpdateInput;
};


export type MutationPostCompanyProfileReviewUpvotesArgs = {
  input: PostCompanyProfileReviewUpvotesInput;
};


export type MutationPostCompanyProfileReviewFlagArgs = {
  input: PostCompanyProfileReviewFlagInput;
};


export type MutationPostCompanyReviewArgs = {
  input: PostCompanyReviewInput;
};


export type MutationPostCompanyReviewExperiment2Args = {
  input: PostCompanyReviewExperiment2Input;
};


export type MutationUpdateCurrentLocation2Args = {
  input: UpdateCurrentLocation2Input;
};


export type MutationFeedbackArgs = {
  input: FeedbackInput;
};


export type MutationFeedbackLoggedInArgs = {
  input: FeedbackLoggedInInput;
};


export type MutationSubmitApplicationArgs = {
  input: SubmitApplicationInput;
};


export type MutationGenerateCoverLetterArgs = {
  input: GenerateCoverLetterInput;
};


export type MutationGenerateSelectionCriteriaArgs = {
  input: GenerateSelectionCriteriaInput;
};


export type MutationTrackJobApplicationStartedArgs = {
  input: TrackJobApplicationStartedInput;
};


export type MutationMarkAsPreferredApplicationArgs = {
  input: MarkAsPreferredApplicationInput;
};


export type MutationCreateLinkoutApplicationArgs = {
  input: CreateLinkoutApplicationInput;
};


export type MutationTrackJobDetailsViewedArgs = {
  input: TrackJobDetailsViewedInput;
};


export type MutationTrackSearchResultSelectedArgs = {
  input: TrackSearchResultSelectedInput;
};


export type MutationCreateCandidateJobMatchRequestArgs = {
  input: CreateCandidateJobMatchRequestInput;
};


export type MutationUpdateLanguageProficiencyArgs = {
  input: UpdateLanguageProficiencyInput;
};


export type MutationDeleteLanguageProficiencyArgs = {
  input: DeleteLanguageProficiencyInput;
};


export type MutationUpdateLicenceArgs = {
  input: UpdateLicenceInput;
};


export type MutationDeleteLicenceArgs = {
  input: DeleteLicenceInput;
};


export type MutationUpdateVerifiedLicenceArgs = {
  input: UpdateVerifiedLicenceInput;
};


export type MutationMkTrackLocationSuggestionSelectionArgs = {
  id: Scalars['Int']['input'];
  session: Scalars['String']['input'];
};


export type MutationSubscribeMobileNotificationsArgs = {
  input: SubscribeMobileNoti;
};


export type MutationUnsubscribeMobileNotificationsArgs = {
  input: UnsubscribeMobileNoti;
};


export type MutationUpdateNotificationCtpSubscriptionWithTokenArgs = {
  input: NotificationCtpSubscriptionWithTokenInput;
};


export type MutationUpdateNotificationCtpPreferencesArgs = {
  input: UpdateNotificationCtpPreferenceInput;
};


export type MutationUpdatePersonalDetailsArgs = {
  input: UpdatePersonalDetailsInput;
};


export type MutationUpdatePreferredClassificationArgs = {
  input: UpdateClassificationInput;
};


export type MutationUpdatePreferredLocations2Args = {
  input: UpdatePreferredLocations2Input;
};


export type MutationUpdatePreferredRoleTitlesArgs = {
  input: UpdatePreferredRoleTitlesInput;
};


export type MutationUpdateProfileVisibilityArgs = {
  input: UpdateProfileVisibilityInput;
};


export type MutationUpdateProfileVisibility2Args = {
  input: UpdateProfileVisibility2Input;
};


export type MutationProvisionAccountArgs = {
  zone: InputMaybe<Scalars['Zone']['input']>;
};


export type MutationUpdateQualificationArgs = {
  input: UpdateQualificationInput;
};


export type MutationDeleteQualificationArgs = {
  input: DeleteQualificationInput;
};


export type MutationConfirmQualificationArgs = {
  input: ConfirmQualificationInput;
};


export type MutationUpdateVerifiedQualificationArgs = {
  input: UpdateVerifiedQualificationInput;
};


export type MutationReportJobArgs = {
  input: ReportJobInput;
};


export type MutationReportProfileArgs = {
  input: ReportProfileInput;
};


export type MutationDeleteResumeArgs = {
  input: DeleteResumeInput;
};


export type MutationGenerateResumeFromProfileArgs = {
  input?: InputMaybe<GenerateResumeFromProfileInput>;
};


export type MutationSetDefaultResumeArgs = {
  input: SetDefaultResumeInput;
};


export type MutationProcessUploadedResumeArgs = {
  input: ProcessUploadedResumeInput;
};


export type MutationRequestResumeParsingArgs = {
  input: RequestResumeParsingInput;
};


export type MutationUpdateRightsToWorkArgs = {
  input: UpdateRightsToWorkInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};


export type MutationConfirmRoleArgs = {
  input: ConfirmRoleInput;
};


export type MutationRejectRoleArgs = {
  input: RejectRoleInput;
};


export type MutationAddSalaryNudgeFeedbackArgs = {
  nudgeId: Scalars['ID']['input'];
  nudgeOption: Scalars['String']['input'];
  zone: Scalars['String']['input'];
};


export type MutationUpdateSalaryPreferencesArgs = {
  input: UpdateSalaryPreferencesInput;
};


export type MutationCreateSavedJob2Args = {
  input: CreateSavedJobInput;
};


export type MutationDeleteSavedJob2Args = {
  input: DeleteSavedJobInput;
};


export type MutationSetSavedJobNotesArgs = {
  input: SetSavedJobNotesInput;
};


export type MutationUpdateShareableProfileSettingsArgs = {
  input: UpdateShareableProfileSettingsInput;
};


export type MutationUpdateShareableProfileViewsArgs = {
  input: UpdateShareableProfileViewsInput;
};


export type MutationUpdateSkillsArgs = {
  input: UpdateSkillsInput;
};


export type MutationSubmitSourcrPageAnalyticsEventArgs = {
  input: SourcrPageAnalyticsEventInput;
};


export type MutationSubmitMessageArgs = {
  input: SourcrMessageInput;
};


export type MutationRejectUnconfirmedDataArgs = {
  input: RejectUnconfirmedDataInput;
};


export type MutationUpdatePreferredWorkTypesArgs = {
  input: UpdatePreferredWorkTypesInput;
};


export type MutationUpdateYearsOfExperienceArgs = {
  input: UpdateYearsOfExperienceInput;
};


export type MutationCreateSeekMaxThreadArgs = {
  input: CreateSeekMaxThreadInput;
};


export type MutationCreateSeekMaxThreadV2Args = {
  input: CreateSeekMaxThreadV2Input;
};


export type MutationCreateSeekMaxThreadModerationArgs = {
  input: CreateSeekMaxThreadV2Input;
};


export type MutationDeleteSeekMaxThreadArgs = {
  input: DeleteSeekMaxThreadInput;
};


export type MutationReportSeekMaxThreadArgs = {
  input: ReportSeekMaxThreadInput;
};


export type MutationSetSeekMaxThreadLikedStatusArgs = {
  input: SeekMaxLikeInput;
};


export type MutationSetSeekMaxThreadPollStatusArgs = {
  input: SeekMaxThreadPollInput;
};


export type MutationCreateSeekMaxCommentArgs = {
  input: CreateSeekMaxCommentInput;
};


export type MutationCreateSeekMaxCommentModerationArgs = {
  input: CreateSeekMaxCommentV2Input;
};


export type MutationDeleteSeekMaxCommentArgs = {
  input: DeleteSeekMaxCommentInput;
};


export type MutationReportSeekMaxCommentArgs = {
  input: ReportSeekMaxCommentInput;
};


export type MutationSetSeekMaxCommentLikedStatusArgs = {
  input: SeekMaxLikeInput;
};


export type MutationCreateSeekMaxReplyArgs = {
  input: CreateSeekMaxReplyInput;
};


export type MutationCreateSeekMaxReplyModerationArgs = {
  input: CreateSeekMaxReplyV2Input;
};


export type MutationDeleteSeekMaxReplyArgs = {
  input: DeleteSeekMaxReplyInput;
};


export type MutationReportSeekMaxReplyArgs = {
  input: ReportSeekMaxReplyInput;
};


export type MutationSetSeekMaxCategoryGroupFollowedStatusArgs = {
  input: SeekMaxCategoryGroupFollowInput;
};


export type MutationUpdateSeekMaxMyThreadsLastViewedArgs = {
  input: UpdateSeekMaxMyThreadsLastViewedInput;
};


export type MutationSaveSeekMaxKeywordSearchArgs = {
  input: SaveSeekMaxKeywordSearchInput;
};


export type MutationCreateSeekMaxModuleBookmarkArgs = {
  input: SeekMaxModuleBookmarkInput;
};


export type MutationDeleteSeekMaxModuleBookmarkArgs = {
  input: SeekMaxModuleBookmarkInput;
};


export type MutationAddSeekMaxCertificateToSeekPassArgs = {
  input: AddSeekMaxCertificateToSeekPassInput;
};


export type MutationSetSeekMaxModuleLikedStatusArgs = {
  input: SeekMaxModuleLikeInput;
};


export type MutationSendSeekMaxModuleProgressArgs = {
  input: SeekMaxModuleProgressInput;
};


export type MutationSendSeekMaxVideoViewedEventArgs = {
  input: SeekMaxVideoViewedEventInput;
};


export type MutationSendSeekMaxModuleClickedEventArgs = {
  input: SendSeekMaxModuleClickedEventInput;
};


export type MutationSendSeekMaxVideoViewedPersonalisationEventArgs = {
  input: SeekMaxVideoViewedPersonalisationEventInput;
};


export type MutationSendSeekMaxModuleClickedPersonalisationEventArgs = {
  input: SeekMaxModuleClickedPersonalisationEventInput;
};


export type MutationSendSeekMaxThreadViewedPersonalisationEventArgs = {
  input: SeekMaxThreadViewedPersonalisationEventInput;
};

export type MutationResult = {
  ref: Maybe<Scalars['UUID']['output']>;
};

export type Nationality = {
  id: Scalars['ID']['output'];
  description: Scalars['String']['output'];
};

export type NationalityInput = {
  id: Scalars['ID']['input'];
};

export type NextRolePreferredLocation = {
  id: Scalars['String']['output'];
  description: Scalars['String']['output'];
  type: PreferredLocationType;
  parent: Maybe<NextRolePreferredLocation>;
  country: Maybe<Country>;
};

export type NoticePeriod = {
  weeks: Scalars['Int']['output'];
};

export type NotificationCtpCategory = {
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  description: Scalars['String']['output'];
};


export type NotificationCtpCategoryLabelArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};


export type NotificationCtpCategoryDescriptionArgs = {
  locale: Scalars['Locale']['input'];
};

export type NotificationCtpChannel = {
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};


export type NotificationCtpChannelLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type NotificationCtpFrequency = {
  value: Scalars['String']['output'];
  options: Array<NotificationCtpFrequencyOptions>;
};

export type NotificationCtpFrequencyOptions = {
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
};


export type NotificationCtpFrequencyOptionsLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type NotificationCtpFrequencyOptionsDescriptionArgs = {
  locale: Scalars['Locale']['input'];
};

export type NotificationCtpPreference = {
  product: NotificationCtpProduct;
  subscriptions: Array<NotificationCtpSubscription>;
};

export type NotificationCtpPreferenceGroup = {
  category: NotificationCtpCategory;
  preferences: Array<NotificationCtpPreference>;
};

export type NotificationCtpProduct = {
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  description: Scalars['String']['output'];
  action: Maybe<NotificationCtpProductAction>;
};


export type NotificationCtpProductLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type NotificationCtpProductDescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type NotificationCtpProductAction = {
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
};


export type NotificationCtpProductActionLabelArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type NotificationCtpSubscription = {
  id: Scalars['ID']['output'];
  channel: NotificationCtpChannel;
  subscribed: Scalars['Boolean']['output'];
  frequency: Maybe<NotificationCtpFrequency>;
  token: Maybe<Scalars['String']['output']>;
};

export type NotificationChannelInput = {
  channel: NotificationCtpChannelType;
  frequency: InputMaybe<NotificationCtpFrequencyType>;
  subscribe: Scalars['Boolean']['input'];
  reason: NotificationCtpUpdateReasonType;
};

export enum NotificationCtpChannelType {
  Email = 'email',
  Push = 'push'
}

export enum NotificationCtpFrequencyType {
  Daily = 'daily',
  Weekly = 'weekly',
  Dynamic = 'dynamic'
}

export type NotificationCtpPreferenceError = {
  message: Scalars['String']['output'];
  errorCode: Maybe<Scalars['Int']['output']>;
};


export type NotificationCtpPreferenceErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export enum NotificationCtpPreferenceProductType {
  AppAdExpired = 'AppAdExpired',
  AppNotSuitable = 'AppNotSuitable',
  AppViewed = 'AppViewed',
  AppConfirmed = 'AppConfirmed',
  AppliedJobsActivity = 'AppliedJobsActivity',
  VerificationRequests = 'VerificationRequests',
  ReminderToApply = 'ReminderToApply',
  ReOnboarding = 'ReOnboarding',
  Wru = 'WRU',
  NewJob = 'NewJob',
  CareerHubThreadReply = 'CareerHubThreadReply',
  CareerHubReengageExplore = 'CareerHubReengageExplore',
  ImproveJobSearch = 'ImproveJobSearch',
  TopApplicant = 'TopApplicant',
  SearchesToSave = 'SearchesToSave',
  SavedSearch = 'SavedSearch',
  MarketingProfileUpdate = 'MarketingProfileUpdate',
  ProfileActivity = 'ProfileActivity',
  MarketingProductUpdates = 'MarketingProductUpdates',
  MarketingAdviceTips = 'MarketingAdviceTips',
  MarketingPartnerUpdates = 'MarketingPartnerUpdates',
  MarketingNewsletter = 'MarketingNewsletter',
  MarketingSurveyResearch = 'MarketingSurveyResearch'
}

export type NotificationCtpPreferencesInput = {
  id: NotificationCtpPreferenceProductType;
  notificationsChannel: Array<NotificationChannelInput>;
};

export type NotificationCtpSubscriptionWithTokenInput = {
  token: Scalars['String']['input'];
  subscribe: Scalars['Boolean']['input'];
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export enum NotificationCtpUpdateReasonType {
  Unknown = 'unknown',
  Customer = 'customer',
  Tcpd = 'tcpd',
  ClickOps = 'clickOps',
  UpdateWithToken = 'updateWithToken',
  PreferenceUi = 'preferenceUI',
  ImportOld = 'importOld',
  LegalRequirement = 'legalRequirement',
  UnificationLiveSync = 'unificationLiveSync',
  UnificationHistorical = 'unificationHistorical',
  Sunset = 'sunset',
  Sunrise = 'sunrise'
}

export type NumberOfReviews = {
  value: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};


export type NumberOfReviewsDescriptionArgs = {
  locale: Scalars['Locale']['input'];
};

export type OntologyRole = {
  id: Scalars['String']['output'];
  uri: Scalars['String']['output'];
  roleTitle: Scalars['String']['output'];
};


export type OntologyRoleRoleTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type OntologySpecReq = {
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  collectExpiry: Scalars['Boolean']['output'];
  highlights: Array<SuggestionHighlight>;
  verificationUrl: Maybe<Scalars['String']['output']>;
};


export type OntologySpecReqVerificationUrlArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
};

export type OntologyStructuredData = {
  text: Scalars['String']['output'];
  ontologyId: Maybe<Scalars['ID']['output']>;
};

export type OntologyStructuredDataInput = {
  text: Scalars['String']['input'];
  ontologyId: InputMaybe<Scalars['ID']['input']>;
};

export enum OntologyType {
  EducationProviders = 'EDUCATION_PROVIDERS',
  Organisations = 'ORGANISATIONS',
  Roletitles = 'ROLETITLES',
  RoletitlesSeniority = 'ROLETITLES_SENIORITY',
  Qualifications = 'QUALIFICATIONS',
  Specreqs = 'SPECREQS'
}

export enum Option {
  All = 'all',
  Common = 'common'
}

export type OverallRating = {
  value: Scalars['Float']['output'];
  numberOfReviews: NumberOfReviews;
};

export type Overview = {
  website: Maybe<Website>;
  industry: Maybe<Scalars['String']['output']>;
  size: Maybe<CompanySize>;
  primaryLocation: Maybe<Scalars['String']['output']>;
  specialities: Maybe<Scalars['String']['output']>;
  description: Maybe<Description>;
};

export type PageInfo = {
  startCursor: Maybe<Scalars['String']['output']>;
  hasPrevPage: Scalars['Boolean']['output'];
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type ParentClassification = {
  id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  subClassifications: Array<ChildClassification>;
};


export type ParentClassificationDescriptionArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type PendingCredentialGroup = {
  label: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type PerkAndBenefit = {
  title: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type PersonalDetails = {
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** @deprecated Being phased out as part of unification */
  nationality: Maybe<Nationality>;
  /**
   * The candidate's country calling code. The `description` field will be returned in the
   * language specified by the `languageCode` parameter passed to the `personalDetails`
   * field. If this field is `null` then the `defaultCountryCallingCode` value must be
   * used instead. Otherwise, this field must always be used.
   */
  countryCallingCode: Maybe<CountryCallingCode>;
  /**
   * A default country calling code based on the `countryCode` parameter passed to the
   * `personalDetails` field. The `description` field will be returned in the language
   * specified by the `languageCode` parameter passed to the `personalDetails` field.
   * If the `countryCallingCode` field is `null`, then this  field must always be used.
   * Otherwise, the `countryCallingCode` must be used instead.
   */
  defaultCountryCallingCode: CountryCallingCode;
};

export type PersonalisedJobDetails = {
  /** @deprecated Replaced by PersonalisedJobDetails.savedJob */
  isSaved: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by PersonalisedJobDetails.appliedJob */
  appliedDateTime: Maybe<SeekDateTime>;
  appliedJob: Maybe<AppliedJob>;
  savedJob: Maybe<SavedJob>;
  salaryMatch: Maybe<IJobProfileSalaryMatch>;
  /**
   * Top Applicant Badge uses Brand, Locale/translatable text
   * @deprecated Fetching data from Personalisation API, requiring different data than what was being provided
   */
  topApplicantBadge: Maybe<TopApplicantBadge>;
  /** Top Applicant Badge 2: replaces Top Applicant Badge to ensure non-breaking change - adds arguments for the fetch */
  topApplicantBadge2: Maybe<TopApplicantBadge>;
  /** Job Application Insights provides information and context about an applied job */
  applicationInsights: Maybe<JobApplicationInsights>;
  /** @deprecated No longer shown in UI */
  jobApplicantsBadge: Maybe<JobApplicantsBadge>;
  qualities: Maybe<MatchedQualities>;
  /**
   * CAUTION!! This field uses a resolver that does not meet the SPREAD requirements
   * for a Seek Resource API.  Please query separately from the other fields in the
   * PersonaliseJobDetails object.
   */
  matchedSkills: Maybe<MatchedSkills>;
  /** UNSTABLE! */
  candidateJobMatch: Maybe<CandidateJobMatch>;
};


export type PersonalisedJobDetailsTopApplicantBadge2Args = {
  visitorId: Scalars['UUID']['input'];
  platform: Platform;
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type PersonalisedSeekMaxCategoryGroup = {
  followed: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalisedSeekMaxComment = {
  likedV3: Maybe<Scalars['Boolean']['output']>;
};


export type PersonalisedSeekMaxCommentLikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxModule = {
  bookmark: Maybe<SeekMaxModuleBookmark>;
  likedV3: Maybe<Scalars['Boolean']['output']>;
};


export type PersonalisedSeekMaxModuleBookmarkArgs = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
};


export type PersonalisedSeekMaxModuleLikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxModuleProgress = {
  completed: Scalars['Boolean']['output'];
  nextVideoProgress: Maybe<SeekMaxNextVideoProgress>;
};

export type PersonalisedSeekMaxPollOption = {
  votedV3: Maybe<Scalars['Boolean']['output']>;
};


export type PersonalisedSeekMaxPollOptionVotedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxThread = {
  likedV3: Maybe<Scalars['Boolean']['output']>;
};


export type PersonalisedSeekMaxThreadLikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxThreadSearchContent = {
  likedV3: Maybe<Scalars['Boolean']['output']>;
};


export type PersonalisedSeekMaxThreadSearchContentLikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxVideo = {
  progress: SeekMaxVideoProgress;
};


export type PersonalisedSeekMaxVideoProgressArgs = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PostCompanyProfileReviewFlagInput = {
  companyId: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  details: Scalars['String']['input'];
};

export type PostCompanyProfileReviewFlagPayload = {
  success: Scalars['Boolean']['output'];
};

export type PostCompanyProfileReviewUpvotesInput = {
  companyId: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
};

export type PostCompanyProfileReviewUpvotesPayload = {
  success: Scalars['Boolean']['output'];
};

export type PostCompanyReviewCreationError = PostCompanyReviewError & {
  message: Scalars['String']['output'];
};


export type PostCompanyReviewCreationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type PostCompanyReviewError = {
  message: Scalars['String']['output'];
};


export type PostCompanyReviewErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type PostCompanyReviewExperiment2Failure = {
  errors: Array<PostCompanyReviewError>;
};

export type PostCompanyReviewExperiment2Input = {
  reviewId: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  companyId: InputMaybe<Scalars['String']['input']>;
  organisationId: InputMaybe<Scalars['String']['input']>;
  zone: Scalars['Zone']['input'];
  overall: InputMaybe<RatingDescriptionInput>;
  workLifeBalance: InputMaybe<RatingDescriptionInput>;
  perksAndBenefits: InputMaybe<RatingDescriptionInput>;
  salary: InputMaybe<SalaryInput>;
  careerOpportunity: InputMaybe<RatingDescriptionInput>;
  executiveManagement: InputMaybe<RatingDescriptionInput>;
  diversity: InputMaybe<RatingDescriptionInput>;
  workEnvironment: InputMaybe<RatingDescriptionInput>;
  role: InputMaybe<RoleInput>;
};

export type PostCompanyReviewExperiment2Payload = PostCompanyReviewExperiment2Success | PostCompanyReviewExperiment2Failure;

export type PostCompanyReviewExperiment2Success = {
  reviewId: Scalars['String']['output'];
};

export type PostCompanyReviewFailure = {
  errors: Array<PostCompanyReviewError>;
};

export type PostCompanyReviewInput = {
  details: ReviewDetailsInput;
  job: JobInput;
  salary: InputMaybe<SalaryInput>;
  perksAndBenefits: InputMaybe<RatingInput>;
  careerOpportunity: InputMaybe<RatingInput>;
  diversity: InputMaybe<RatingInput>;
  executiveManagement: InputMaybe<RatingInput>;
  workEnvironment: InputMaybe<RatingInput>;
  workLifeBalance: InputMaybe<RatingInput>;
  companyId: Scalars['String']['input'];
  organisationId: InputMaybe<Scalars['String']['input']>;
  languageISO: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
};

export type PostCompanyReviewPayload = PostCompanyReviewSuccess | PostCompanyReviewFailure;

export type PostCompanyReviewSuccess = {
  reviewId: Scalars['String']['output'];
};

export type PreferredLocation2Input = {
  id: Scalars['Int']['input'];
};

export enum PreferredLocationType {
  Area = 'Area',
  Location = 'Location'
}

export type PriorityApplyCandidateCredit = {
  remainingCount: Scalars['Int']['output'];
  totalCredit: Scalars['Int']['output'];
  nextRenewalDate: Maybe<SeekDateTime>;
};

export type PriorityApplyCredit = {
  credit: Maybe<PriorityApplyCandidateCredit>;
  creditConfig: Maybe<PriorityApplyCreditConfig>;
};

export type PriorityApplyCreditConfig = {
  creditValue: Scalars['Int']['output'];
  renewFrequency: Maybe<RenewFrequency>;
};

export type Privacy = {
  personalDetails: Scalars['Boolean']['output'];
  workHistory: Scalars['Boolean']['output'];
  education: Scalars['Boolean']['output'];
  summary: Scalars['Boolean']['output'];
  skills: Scalars['Boolean']['output'];
  languages: Scalars['Boolean']['output'];
  licences: Scalars['Boolean']['output'];
};

export type PrivacyInput = {
  personalDetails: Scalars['Boolean']['input'];
  workHistory: Scalars['Boolean']['input'];
  education: Scalars['Boolean']['input'];
  summary: Scalars['Boolean']['input'];
  skills: Scalars['Boolean']['input'];
  languages: Scalars['Boolean']['input'];
  licences: Scalars['Boolean']['input'];
};

export type PrivacyPolicyQuestion = Question & {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
  options: Array<QuestionOption>;
};

export type ProcessUploadedAttachmentInput = {
  id: Scalars['UUID']['input'];
  attachmentType: AttachmentType;
};

export type ProcessUploadedAttachmentPayload = {
  uri: Scalars['String']['output'];
};

export type ProcessUploadedResumeInput = {
  id: Scalars['UUID']['input'];
  isDefault: InputMaybe<Scalars['Boolean']['input']>;
  parsingContext: InputMaybe<RequestResumeParsingContext>;
  /** @deprecated Only the zone parameter should be passed after all unification releases */
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  origin: InputMaybe<ResumeOriginType>;
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type ProcessUploadedResumeResult = {
  /** @deprecated Please use the resume type with more resume metadata */
  id: Scalars['UUID']['output'];
  resume: Resume;
  viewer: Maybe<Candidate>;
};

export type ProductCjs = {
  branding: Maybe<BrandingCjs>;
  bullets: Maybe<Array<Scalars['String']['output']>>;
};

export type ProfileInsights = {
  searchImpressionCount: Scalars['Int']['output'];
  viewCount: Scalars['Int']['output'];
  activities: Array<ProfileInsightsActivity>;
};

export type ProfileInsights2 = {
  searchImpressionCount: Scalars['Int']['output'];
  viewCount: Scalars['Int']['output'];
  activities: Array<ProfileInsightsActivity2>;
};

export type ProfileInsightsActivity = {
  /** Display label for the source of the activity e.g. Found from an employer search */
  sourceLabel: Scalars['String']['output'];
  /** The relative day(s) since the activity, or date of the activity if more than 29 days ago */
  date: Scalars['String']['output'];
};


export type ProfileInsightsActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type ProfileInsightsActivityDateArgs = {
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};

export type ProfileInsightsActivity2 = {
  /** Display label for the source of the activity e.g. Found from an employer search */
  sourceLabel: Scalars['String']['output'];
  /** The relative day(s) since the activity, or date of the activity if more than 29 days ago */
  date: SeekDateTime;
};


export type ProfileInsightsActivity2SourceLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type ProfileInsightsActivity2DateArgs = {
  locale: Scalars['Locale']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};

export type ProfileInsightsAdvertiser = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProfileInsightsAdvertiser2 = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProfileInsightsJob = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  /** Job URL built with brand based on candidate's zone and selected language */
  url: Scalars['String']['output'];
};


export type ProfileInsightsJobUrlArgs = {
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ProfileInsightsJobSentActivity = ProfileInsightsActivity & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: ProfileInsightsAdvertiser;
  sourceLabel: Scalars['String']['output'];
  date: Scalars['String']['output'];
  /** Job sent from the advertiser to the candidate */
  job: ProfileInsightsJob;
};


export type ProfileInsightsJobSentActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type ProfileInsightsJobSentActivityDateArgs = {
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};

export type ProfileInsightsJobSentActivity2 = ProfileInsightsActivity2 & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: Maybe<ProfileInsightsAdvertiser2>;
  sourceLabel: Scalars['String']['output'];
  date: SeekDateTime;
  /** Job sent from the advertiser to the candidate */
  job: Maybe<Job>;
};


export type ProfileInsightsJobSentActivity2SourceLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type ProfileInsightsJobSentActivity2DateArgs = {
  locale: Scalars['Locale']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};

export type ProfileInsightsMessageSentActivity = ProfileInsightsActivity & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: ProfileInsightsAdvertiser;
  sourceLabel: Scalars['String']['output'];
  date: Scalars['String']['output'];
};


export type ProfileInsightsMessageSentActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type ProfileInsightsMessageSentActivityDateArgs = {
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};

export type ProfileInsightsMessageSentActivity2 = ProfileInsightsActivity2 & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: Maybe<ProfileInsightsAdvertiser2>;
  sourceLabel: Scalars['String']['output'];
  date: SeekDateTime;
};


export type ProfileInsightsMessageSentActivity2SourceLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type ProfileInsightsMessageSentActivity2DateArgs = {
  locale: Scalars['Locale']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};

export type ProfileInsightsResumeDownloadedActivity = ProfileInsightsActivity & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: ProfileInsightsAdvertiser;
  sourceLabel: Scalars['String']['output'];
  date: Scalars['String']['output'];
};


export type ProfileInsightsResumeDownloadedActivitySourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type ProfileInsightsResumeDownloadedActivityDateArgs = {
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};

export type ProfileInsightsResumeDownloadedActivity2 = ProfileInsightsActivity2 & {
  /** The advertiser who interacted with the candidate's profile */
  advertiser: Maybe<ProfileInsightsAdvertiser2>;
  sourceLabel: Scalars['String']['output'];
  date: SeekDateTime;
};


export type ProfileInsightsResumeDownloadedActivity2SourceLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type ProfileInsightsResumeDownloadedActivity2DateArgs = {
  locale: Scalars['Locale']['input'];
  timezone: InputMaybe<Scalars['Timezone']['input']>;
};

export enum ProfileLocationKind {
  Country = 'COUNTRY',
  Region = 'REGION',
  State = 'STATE',
  SeekLocation = 'SEEK_LOCATION',
  SeekArea = 'SEEK_AREA',
  Suburb = 'SUBURB'
}

export type ProfileLocationTrackSelectedResponse = {
  id: Scalars['Int']['output'];
};

export enum ProfileLocationType {
  Home = 'Home',
  Preferred = 'Preferred'
}

export type ProfileScore = {
  /** The sum of all score values from each individual scorer. */
  score: Scalars['Float']['output'];
  /** Overall progress/completeness, value from 0 to 1. */
  progress: Scalars['Float']['output'];
  /** A list of all tips the candidate can action on their profile. */
  tips: Array<ProfileScoreTip>;
};

export type ProfileScoreTip = {
  /** The score amount that can be gained from actioning this tip. */
  score: Scalars['Float']['output'];
  /** The action button label for this tip. */
  label: Scalars['String']['output'];
  /** A description of the value the candidate could get by actioning this tip. */
  description: Scalars['String']['output'];
  /** Parameters used by the profile app to customise the tip action. */
  action: ProfileScoreTipAction;
};

export type ProfileScoreTipAction = {
  /**
   * The specific card to scroll to when the tip is actioned. Valid values are
   * strings from [this array](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/master/src/components/Router/index.ts#L29).
   */
  card: Scalars['String']['output'];
  /**
   * A specific field to focus on within the `card` specified. The field must
   * have a focus ref attached it. Reference the `field-name` associated with
   * the ref. [Example](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/494f567314685156cc3c40bfa212746d14845efa/src/components/Profile/PersonalDetails/EditPersonalDetails/EditPersonalDetails.tsx#L144).
   */
  field: Maybe<Scalars['String']['output']>;
  /**
   * The mode to set the card to when the tip is actioned. Valid values are
   * `read` or `edit`.
   */
  mode: Maybe<Scalars['String']['output']>;
  /**
   * The id of a specific profile item. Can be used if you want an action to
   * target a specific item, e.g. a candidate's most recent career history.
   */
  item: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestLocation = {
  id: Scalars['Int']['output'];
  contextualName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  highlights: Array<SuggestionHighlight>;
  countryCode: Scalars['CountryCodeIso2']['output'];
  kind: Scalars['String']['output'];
};

export type ProfileSuggestLocationGroup = {
  label: Scalars['String']['output'];
  suggestions: Array<ProfileSuggestLocation>;
};

export type ProfileSuggestLocationType = ProfileSuggestLocationGroup | ProfileSuggestLocation;

export type ProfileSuggestion = {
  /** A suggestion message the candidate can improve or action on their profile. */
  message: Scalars['String']['output'];
  /** Action that candidate could take on for this particular suggestion. */
  action: Maybe<ProfileSuggestionAction>;
  /** Event name passed to the tracking system when the suggestion is displayed. */
  trackingNudgeType: Scalars['String']['output'];
};

export type ProfileSuggestionAction = {
  /** The action button label for this suggestion action. */
  label: Scalars['String']['output'];
  /** The context of the action on what is the next step to take after button click. */
  context: Maybe<ProfileSuggestionActionContext>;
  /** Event name passed to the tracking system when the action is clicked. */
  trackingCallToAction: Scalars['String']['output'];
};

export type ProfileSuggestionActionContext = {
  /** The mode to set the section/card to when the suggestion is actioned. Valid values are `read` or `edit`. (Mainly used by web) */
  mode: Maybe<Scalars['String']['output']>;
  /**
   * The specific card to scroll to when the tip is actioned. Valid values are
   * strings from [this array](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/master/src/components/Router/index.ts#L29).
   */
  card: Maybe<Scalars['String']['output']>;
  /**
   * A specific field to focus on within the `section` specified. The field must have a focus ref attached it. Reference the `field-name` associated with
   * the ref. [Example](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/494f567314685156cc3c40bfa212746d14845efa/src/components/Profile/PersonalDetails/EditPersonalDetails/EditPersonalDetails.tsx#L144).
   * (Mainly used by web)
   */
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionAvailabilityActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionCareerHistoryActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  /**
   * The id of a specific profile item. Can be used if you want an action to
   * target a specific item, e.g. a candidate's most recent career history.
   */
  itemId: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionClassificationActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionEducationActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionLanguagesActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionLicencesActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionPersonalDetailsActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionPersonalSummaryActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionProfileVisibilityActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionResumeActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionRightToWorkActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionSalaryActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionSkillsActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionWorkTypeActionContext = ProfileSuggestionActionContext & {
  mode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
};

export type ProfileVerifications = {
  nudge: Maybe<VerificationsNudge2>;
  verified: Maybe<Array<VerifiedCredentialCategory>>;
  verifiable: Maybe<Array<VerifiableCredentialCategory>>;
};


export type ProfileVerificationsNudgeArgs = {
  testGroup: InputMaybe<VerificationsTestVariant>;
  platform: Platform;
  source: SourceExperience;
};


export type ProfileVerificationsVerifiableArgs = {
  platform: Platform;
  source: SourceExperience;
};

export type ProfileVisibility = {
  /** Visibility level of the candidate's profile */
  level: VisibilityLevel;
  /** Human readable string used when showing the candidate's profile visibility in a read-only context */
  description: Scalars['String']['output'];
};

export type ProfileVisibilityOption = {
  /** Unique identifier for the visibility level */
  id: Scalars['String']['output'];
  /** Display name for the visibility level, localised based on provided locale */
  name: Scalars['String']['output'];
  /** Detailed description of what this visibility level means, localised based on provided locale */
  description: Scalars['String']['output'];
};


export type ProfileVisibilityOptionNameArgs = {
  locale: Scalars['Locale']['input'];
};


export type ProfileVisibilityOptionDescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type ProvisionAccountError = {
  message: Scalars['String']['output'];
};


export type ProvisionAccountErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type ProvisionAccountErrorAlreadyProvisioned = ProvisionAccountError & {
  message: Scalars['String']['output'];
};


export type ProvisionAccountErrorAlreadyProvisionedMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type ProvisionAccountErrorAlreadyProvisionedDuplicateGuid = ProvisionAccountError & {
  message: Scalars['String']['output'];
};


export type ProvisionAccountErrorAlreadyProvisionedDuplicateGuidMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type ProvisionAccountFailure = {
  error: ProvisionAccountError;
};

export type ProvisionAccountPayload = ProvisionAccountSuccess | ProvisionAccountFailure;

export type ProvisionAccountSuccess = {
  id: Scalars['ID']['output'];
  isTokenRefreshRequired: Scalars['Boolean']['output'];
};

export type PublicProfile = {
  url: Scalars['String']['output'];
  displayUrl: Scalars['String']['output'];
};


export type PublicProfileUrlArgs = {
  zone: Scalars['Zone']['input'];
  locale: Scalars['Locale']['input'];
  platform: Platform;
};


export type PublicProfileDisplayUrlArgs = {
  zone: Scalars['Zone']['input'];
};

export type PublicProfileCompaniesInput = {
  values: Array<Scalars['String']['input']>;
  matchLatestOnly: Scalars['Boolean']['input'];
};

export type PublicProfileEducation = {
  /** The name of the educational qualification */
  name: Scalars['String']['output'];
};

export type PublicProfileEducationCompletion = {
  label: Maybe<Scalars['String']['output']>;
};


export type PublicProfileEducationCompletionLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type PublicProfileInclusiveWorkDuration = {
  label: Maybe<Scalars['String']['output']>;
};


export type PublicProfileInclusiveWorkDurationLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type PublicProfileLicence = {
  /** The name of the licence */
  name: Scalars['String']['output'];
};

export type PublicProfileLocation = {
  /** The candidate's location label */
  label: Maybe<Scalars['String']['output']>;
};


export type PublicProfileLocationLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type PublicProfileLocationsInput = {
  values: Array<Scalars['String']['input']>;
};

export type PublicProfileRightToWork = {
  /** A localized label describing the country to which the candidate's right to work status applies. */
  countryLabel: Scalars['String']['output'];
  /** A localized label describing the candidate's right to work status for this country. */
  statusLabel: Scalars['String']['output'];
  /** True if the candidate's right to work status for this country has been verified by SEEK Pass. */
  isVerified: Scalars['Boolean']['output'];
};


export type PublicProfileRightToWorkCountryLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type PublicProfileRightToWorkStatusLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type PublicProfileRoleTitlesInput = {
  values: Array<Scalars['String']['input']>;
  matchLatestOnly: Scalars['Boolean']['input'];
};

export type PublicProfileSearchInput = {
  /** The search query used to search for candidate profiles */
  searchQuery: Scalars['String']['input'];
  /** The market used to search for candidate profiles */
  market: Scalars['String']['input'];
  /** The role titles used to filter candidate profile search results */
  roleTitles: InputMaybe<PublicProfileRoleTitlesInput>;
  /** The companies used to filter candidate profile search results */
  companies: InputMaybe<PublicProfileCompaniesInput>;
  /** The locations used to filter candidate profile search results */
  locations: PublicProfileLocationsInput;
  /** The page number requested for search results */
  pageNumber: InputMaybe<Scalars['Int']['input']>;
  /** Number of profile search results per page */
  pageSize: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier for the visitor, used by the backend to log public profile search events for analytics. */
  visitorId: InputMaybe<Scalars['UUID']['input']>;
};

export type PublicProfileSearchResult = {
  /** The candidate profile id */
  slug: Scalars['ID']['output'];
};

export type PublicProfileSearchResultEdge = {
  /** The candidate profile node */
  node: PublicProfileSearchResult;
};

export type PublicProfileSearchResults = {
  /** The exact matching profiles with pagination information */
  exactMatches: Array<PublicProfileSearchResultEdge>;
  /** The partial matching profiles with pagination information */
  partialMatches: Array<PublicProfileSearchResultEdge>;
  /** The pagination information for the search results */
  pageInfo: PublicProfileSearchResultsPageInfo;
  /** Used for tracking to correlate search actions with profile views. */
  serviceToken: Scalars['UUID']['output'];
};

export type PublicProfileSearchResultsPageInfo = {
  /** The total number of exact matching profiles for the search query */
  totalExactMatches: Scalars['Int']['output'];
  /** The total number of partial matching profiles for the search query */
  totalPartialMatches: Scalars['Int']['output'];
  /** The total number of profiles matching the search query */
  totalMatches: Scalars['Int']['output'];
};

export type PublicProfileView = {
  /** The candidate profile id */
  slug: Scalars['ID']['output'];
};

export type PublicProfileViewInput = {
  /** The slug for the candidate profile */
  slug: Scalars['ID']['input'];
};

export type PublicVisibilityOption = ProfileVisibilityOption & {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
};


export type PublicVisibilityOptionNameArgs = {
  locale: Scalars['Locale']['input'];
};


export type PublicVisibilityOptionDescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type Qualification = {
  id: Scalars['UUID']['output'];
  name: OntologyStructuredData;
  institute: OntologyStructuredData;
  /**
   * Required for JobsDB only
   * @deprecated Legacy field
   */
  level2: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  completionDate: Maybe<CompletionDate>;
  /** This field returns a description of the completion for the qualification eg. "In progress", "Finished 2018" */
  formattedCompletion: Scalars['String']['output'];
  highlights: Maybe<Scalars['String']['output']>;
  tracking: Maybe<TrackingInfo>;
  status: Maybe<QualificationStatus>;
  credential: Maybe<BaseCredential>;
  verificationUrl: Maybe<Scalars['String']['output']>;
  isVerified: Scalars['Boolean']['output'];
};

export enum QualificationLevel {
  CompletedYear9To11 = 'CompletedYear9To11',
  CompletedHighSchool = 'CompletedHighSchool',
  CertificateI = 'CertificateI',
  CertificateIi = 'CertificateII',
  CertificateIii = 'CertificateIII',
  CertificateIv = 'CertificateIV',
  Diploma = 'Diploma',
  AdvancedDiploma = 'AdvancedDiploma',
  AssociateDegree = 'AssociateDegree',
  BachelorDegree = 'BachelorDegree',
  BachelorDegreeHonours = 'BachelorDegreeHonours',
  GraduateDiploma = 'GraduateDiploma',
  GraduateCertificate = 'GraduateCertificate',
  MastersDegree = 'MastersDegree',
  DoctoralDegree = 'DoctoralDegree',
  IosLongtailFallback = 'IosLongtailFallback'
}

export enum QualificationStatus {
  New = 'New'
}

export type QualificationVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Quality = {
  ontologyId: Scalars['ID']['output'];
  displayLabel: Scalars['String']['output'];
  shortId: Scalars['UUID']['output'];
};


export type QualityDisplayLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type Query = {
  priorityApplyCredit: Maybe<PriorityApplyCredit>;
  /** The details of a consent transaction for a given transactionId */
  consentTransactionDetails: Maybe<ConsentTransactionDetails>;
  availabilityOptions: Array<AvailabilityOption>;
  banner: Maybe<Banner>;
  viewer: Maybe<Candidate>;
  /** The version of the schema */
  version: Scalars['String']['output'];
  featureFlags: Maybe<Array<FeatureFlagEvaluation>>;
  careerFeed: Maybe<CareerFeed>;
  /** EXPERIMENTAL! Career Feed Insights API for homepage role and location insights. Contact the team at https://seek.enterprise.slack.com/archives/CEBGFFBSP */
  careerFeedInsights: Maybe<CareerFeedInsights>;
  classifications: Array<ParentClassification>;
  companyDetails: Maybe<CompanyDetails>;
  searchCompanyDetails: Maybe<SearchCompanyDetails>;
  marqueeCompanies: Array<MarqueeCompanyProfile>;
  /** @deprecated Please move to companyDetails.companyProfile this is the new home for this data. This will be removed in the future. */
  companyProfile: CompanyProfile;
  companyNameSlug: CompanyNameSlug;
  review: Maybe<Review>;
  companyReviews: Maybe<Reviews>;
  companyProfileReviewUpvotes: Maybe<ReviewUpvotes>;
  /** @deprecated Use Launch Darkly instead. This will be removed in the future. */
  companyProfilesFeatureFlags: Array<FeatureFlag>;
  groupedCompanies: Maybe<Array<Maybe<GroupedCompanies>>>;
  searchCompanyProfilesByName: Array<SearchCompanyProfileResultItem>;
  /** @deprecated Please move to companyDetails.companyProfile.companyReviewRating this is the new home for this data. This will be removed in the future. */
  reviewsRatingSummary: Maybe<ReviewsRatingSummary>;
  /**
   * A list of country codes filtered based on the `option` parameter. The `description`
   * of each list item will be returned in the language specified via the `languageCode`
   * parameter. *Note*: The default value for the `languageCode` parameter is `en`, *not*
   * `false` as it appears in the playground.
   */
  countryCallingCodeOptions: Array<CountryCallingCode>;
  defaultCurrency: DefaultCurrency;
  dummy: Maybe<Scalars['String']['output']>;
  /** @deprecated Field used for testing purposes only */
  echoBase64Url: Maybe<Scalars['Base64Url']['output']>;
  /** @deprecated Testing purpose only */
  cloudsmithTest: Maybe<Scalars['String']['output']>;
  hideJobFeedbackReasons: Maybe<Array<HideJobFeedbackReason>>;
  jobApplicationProcess: Maybe<JobApplicationProcess>;
  jobDetails: Maybe<JobDetails>;
  /** UNSTABLE! */
  jobSearch: Maybe<JobSearchResult>;
  /** UNSTABLE! */
  jobSearchAssist: Maybe<JobSearchAssist>;
  /** UNSTABLE! */
  locationRadiusOptions: Maybe<Array<LocationRadiusOption>>;
  /** UNSTABLE! */
  jobSearchQueryMeter: Maybe<JobSearchQueryMeter>;
  /**
   * UNSTABLE! Returns up to three query recommendations for the candidate.
   * Nullable array to allow degraded responses if the upstream service fails.
   */
  queryRecommendations: Maybe<QueryRecommendationResult>;
  mkLocationSuggestions: Array<MkLocationSuggestion>;
  ontologyEducationProviders: Array<IOntologyEducationProvider>;
  ontologyOrganisations: Array<IOntologyOrganisation>;
  ontologyRoleTitles: Array<IOntologyRoleTitle>;
  ontologyRoleTitlesSeniority: Array<IOntologyRoleTitleSeniority>;
  ontologyQualifications: Array<IOntologyQualification>;
  ontologySpecReqs: Array<OntologySpecReq>;
  ontologyTrackSelected: Maybe<ITrackSelected>;
  preferredClassificationOptions: Array<ClassificationOptions>;
  profileLocationSuggest: Array<ProfileSuggestLocationType>;
  profileLocationTrackSelected: ProfileLocationTrackSelectedResponse;
  /** Profile Visibility options */
  profileVisibilityOptions: Array<ProfileVisibilityOption>;
  publicProfileSearch: Maybe<PublicProfileSearchResults>;
  publicProfileView: Maybe<PublicProfileView>;
  loggedOutRecommendedJobs: Maybe<LoggedOutRecommendedGlobalJobs>;
  resumePrivacyDisclaimers: ResumePrivacyDisclaimers;
  /** A list of right to work options for all countries we collect right to work information in */
  rightToWorkOptions: Array<RightToWorkCountryOptions>;
  roleFunctionOptions: Array<RoleFunctionOption>;
  salaryOptions: Array<SalaryOption>;
  _empty: Maybe<Scalars['String']['output']>;
  searchKeywordsSuggest: SearchKeywordSuggestions;
  searchLocationsSuggest: SearchLocationSuggestions;
  searchFilterData: SearchFilterData;
  searchSalaryRanges: Maybe<Array<SearchSalaryRange>>;
  /**
   * Displays data that a candidate has chosen to share via a public url
   * @deprecated This functionality is retired
   */
  shareableProfile: ShareableProfile;
  sourcr: Maybe<Sourcr>;
  supportedCountries: Array<CountryInformation>;
  accountExists: AccountStatus;
  workTypeOptions: Array<WorkTypeTaxonomyOption>;
  /** @deprecated Use seekMaxThreads instead */
  categorySeekMaxThreads: Maybe<SeekMaxThreadConnectionResults>;
  seekMaxThreads: Maybe<SeekMaxThreadConnectionResults>;
  featuredSeekMaxThreadsV2: Maybe<Array<Maybe<SeekMaxThread>>>;
  featuredSeekMaxThreadsV3: Maybe<SeekMaxThreadConnectionResults>;
  pinnedSeekMaxThreadsV2: Maybe<Array<Maybe<SeekMaxThread>>>;
  moreSeekMaxThreadsV2: Maybe<SeekMaxThreadConnectionResults>;
  seekMaxThreadV2: Maybe<ISeekMaxThread>;
  seekMaxMyThreadsV2: Maybe<SeekMaxThreadConnectionResults>;
  /** @deprecated Use seekMaxThreadModerationStatus instead */
  seekMaxThreadAttachmentStatus: Maybe<ISeekMaxAttachmentStatus>;
  seekMaxThreadModerationStatus: Maybe<ISeekMaxModerationStatus>;
  seekMaxCommentsV2: Maybe<SeekMaxCommentConnectionResults>;
  seekMaxCommentModerationStatus: Maybe<ISeekMaxModerationStatus>;
  seekMaxReplies: SeekMaxReplyResults;
  seekMaxReplyModerationStatus: Maybe<ISeekMaxModerationStatus>;
  seekMaxMyUnreadThreadsCount: Maybe<SeekMaxUnreadThreadsCountResponse>;
  seekMaxCategoryGroup: Maybe<ISeekMaxCategoryGroup>;
  seekMaxCategoryGroups: Maybe<SeekMaxCategoryGroupConnectionResults>;
  searchSeekMaxContentsV2: Maybe<SeekMaxContentSearchResults>;
  seekMaxLandingInfo: SeekMaxLandingInfo;
  seekMaxProfileV2: Maybe<SeekMaxProfile>;
  bookmarkedSeekMaxModules: SeekMaxModuleBookmarkResults;
  seekMaxCertificates: Maybe<SeekMaxCertificateConnectionResults>;
  seekMaxCertificateAttachmentStatus: Maybe<ISeekMaxCertificateAttachmentStatus>;
  seekMaxCertificateSeekPassStatus: Maybe<ISeekMaxCertificateSeekPassStatus>;
  featuredSeekMaxCollection: Maybe<SeekMaxCollection>;
  seekMaxCollections: Array<SeekMaxCollection>;
  /** @deprecated Use recentlyAddedSeekMaxModulesV2 instead */
  recentlyAddedSeekMaxModules: Array<SeekMaxModule>;
  recentlyAddedSeekMaxModulesV2: Maybe<Array<SeekMaxModule>>;
  seekMaxModule: Maybe<SeekMaxModule>;
  seekMaxModulesInProgress: SeekMaxModulesInProgressResults;
  relatedSeekMaxModules: Array<SeekMaxModule>;
  categorySeekMaxModules: Maybe<SeekMaxModuleConnectionResults>;
  recommendedSeekMaxModules: Array<SeekMaxModule>;
  seekMaxFeedModules: Maybe<SeekMaxModuleFeedResults>;
  seekMaxFeedThreads: Maybe<SeekMaxThreadFeedResults>;
  trendingSeekMaxModulesV2: Maybe<SeekMaxTrendingModuleConnectionResults>;
};


export type QueryConsentTransactionDetailsArgs = {
  input: ConsentTransactionDetailsInput;
};


export type QueryAvailabilityOptionsArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type QueryBannerArgs = {
  placement: BannerPlacement;
  country: Scalars['String']['input'];
  visitorId: InputMaybe<Scalars['UUID']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
  locale?: Scalars['Locale']['input'];
  loggedIn: InputMaybe<Scalars['String']['input']>;
  candidateId: InputMaybe<Scalars['String']['input']>;
  roleId: InputMaybe<Scalars['String']['input']>;
  keywords: InputMaybe<Scalars['String']['input']>;
  classification: InputMaybe<Scalars['String']['input']>;
  subclassification: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<Scalars['String']['input']>;
  workType: InputMaybe<Scalars['String']['input']>;
  salaryType: InputMaybe<Scalars['String']['input']>;
  salaryRange: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeatureFlagsArgs = {
  flags: Array<Scalars['String']['input']>;
  visitorContext: InputMaybe<VisitorContextInput>;
  experienceContext: InputMaybe<ExperienceContextInput>;
  applicationContext: InputMaybe<ApplicationContextInput>;
  deviceContext: InputMaybe<DeviceContextInput>;
};


export type QueryCareerFeedArgs = {
  zone: Scalars['Zone']['input'];
  platform: Platform;
  channel: CareerFeedChannel;
  visitorId: Scalars['UUID']['input'];
  components: Array<CareerFeedComponent>;
  candidateChatContext: InputMaybe<RecommendedJobsChatContextInput>;
  experiments: InputMaybe<Array<InputMaybe<CareerFeedExperimentInput>>>;
};


export type QueryCareerFeedInsightsArgs = {
  roleTitleId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryClassificationsArgs = {
  zone: Scalars['Zone']['input'];
};


export type QueryCompanyDetailsArgs = {
  id: Scalars['CompanyId']['input'];
};


export type QuerySearchCompanyDetailsArgs = {
  filter: InputMaybe<SearchCompanyDetailsFilterInput>;
  paging: InputMaybe<SearchCompanyDetailsPagingInput>;
};


export type QueryMarqueeCompaniesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  hideJobs: InputMaybe<Scalars['Boolean']['input']>;
  zone?: Scalars['Zone']['input'];
};


export type QueryCompanyProfileArgs = {
  id: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
  useCachedProfile?: Scalars['Boolean']['input'];
};


export type QueryCompanyNameSlugArgs = {
  companySlug: Scalars['String']['input'];
  zone?: Scalars['Zone']['input'];
  isLegacyUrl?: Scalars['Boolean']['input'];
};


export type QueryReviewArgs = {
  reviewId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryCompanyReviewsArgs = {
  companyId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Scalars['String']['input']>;
  locationId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompanyProfileReviewUpvotesArgs = {
  id: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};


export type QueryCompanyProfilesFeatureFlagsArgs = {
  input: InputMaybe<FeatureFlagInput>;
};


export type QueryGroupedCompaniesArgs = {
  zone: Scalars['Zone']['input'];
  groupBy: CompanyGroupByInput;
  sortBy: InputMaybe<Company_Sort_By>;
  excludedCompanyIds: InputMaybe<Array<Scalars['ID']['input']>>;
  randomSeed: InputMaybe<Scalars['String']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchCompanyProfilesByNameArgs = {
  name: Scalars['String']['input'];
  includeBranding: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
  published: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryReviewsRatingSummaryArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCountryCallingCodeOptionsArgs = {
  option?: InputMaybe<Option>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type QueryDefaultCurrencyArgs = {
  zone: Scalars['Zone']['input'];
};


export type QueryEchoBase64UrlArgs = {
  input: InputMaybe<Scalars['Base64Url']['input']>;
};


export type QueryJobApplicationProcessArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryJobDetailsArgs = {
  id: Scalars['ID']['input'];
  tracking: InputMaybe<JobDetailsTrackingInput>;
};


export type QueryJobSearchArgs = {
  queryParameters: JobSearchQueryParametersInput;
};


export type QueryJobSearchAssistArgs = {
  visitorId: Scalars['UUID']['input'];
  tokens: Array<Scalars['Base64Url']['input']>;
};


export type QueryJobSearchQueryMeterArgs = {
  query: Scalars['String']['input'];
};


export type QueryQueryRecommendationsArgs = {
  siteKey: Scalars['String']['input'];
  locale: Scalars['Locale']['input'];
  solVisitorId: InputMaybe<Scalars['String']['input']>;
  channel: InputMaybe<Scalars['String']['input']>;
};


export type QueryMkLocationSuggestionsArgs = {
  searchText: Scalars['String']['input'];
  count: InputMaybe<Scalars['Int']['input']>;
  session: Scalars['String']['input'];
  kind: Array<Scalars['String']['input']>;
  zone: Scalars['Zone']['input'];
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  countries: InputMaybe<Array<Scalars['CountryCodeIso2']['input']>>;
};


export type QueryOntologyEducationProvidersArgs = {
  query: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  session: Scalars['String']['input'];
};


export type QueryOntologyOrganisationsArgs = {
  query: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  session: Scalars['String']['input'];
};


export type QueryOntologyRoleTitlesArgs = {
  query: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  session: Scalars['String']['input'];
};


export type QueryOntologyRoleTitlesSeniorityArgs = {
  query: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  session: Scalars['String']['input'];
};


export type QueryOntologyQualificationsArgs = {
  query: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  countryCode: InputMaybe<CountryCode>;
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  session: Scalars['String']['input'];
};


export type QueryOntologySpecReqsArgs = {
  query: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  session: Scalars['String']['input'];
  profileField: InputMaybe<SpecReqProfileField>;
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};


export type QueryOntologyTrackSelectedArgs = {
  id: Scalars['String']['input'];
  session: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  ontologyType: OntologyType;
};


export type QueryPreferredClassificationOptionsArgs = {
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type QueryProfileLocationSuggestArgs = {
  query: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  session: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
  locationType: ProfileLocationType;
  languageCode: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  locationKinds: InputMaybe<Array<ProfileLocationKind>>;
};


export type QueryProfileLocationTrackSelectedArgs = {
  id: Scalars['Int']['input'];
  session: Scalars['String']['input'];
};


export type QueryPublicProfileSearchArgs = {
  input: PublicProfileSearchInput;
};


export type QueryPublicProfileViewArgs = {
  input: PublicProfileViewInput;
};


export type QueryLoggedOutRecommendedJobsArgs = {
  jobId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  source: AttributionSource;
  zone: Scalars['Zone']['input'];
  visitorId: Scalars['UUID']['input'];
  platform: Platform;
  cluster: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
};


export type QueryResumePrivacyDisclaimersArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
  isUnifiedSite: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRightToWorkOptionsArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
  isUnified?: InputMaybe<Scalars['Boolean']['input']>;
  platform: InputMaybe<Platform>;
  source: InputMaybe<SourceExperience>;
  filter: InputMaybe<RightToWorkFilterInput>;
};


export type QueryRoleFunctionOptionsArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
  languageCode: LanguageCode;
};


export type QuerySearchKeywordsSuggestArgs = {
  query: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  countryCode2: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  visitorId: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySearchLocationsSuggestArgs = {
  query: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  recentLocation: InputMaybe<Scalars['String']['input']>;
  countryCode: InputMaybe<CountryCode>;
  isUnified: InputMaybe<Scalars['Boolean']['input']>;
  isRemoteEnabled: InputMaybe<Scalars['Boolean']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
  visitorId: InputMaybe<Scalars['UUID']['input']>;
  country: InputMaybe<Scalars['CountryCodeIso2']['input']>;
};


export type QuerySearchSalaryRangesArgs = {
  zone: Scalars['Zone']['input'];
};


export type QueryShareableProfileArgs = {
  profileSlug: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type QuerySupportedCountriesArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type QueryAccountExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryWorkTypeOptionsArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};


export type QueryCategorySeekMaxThreadsArgs = {
  zone: Scalars['Zone']['input'];
  categoryId: Scalars['ID']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QuerySeekMaxThreadsArgs = {
  zone: Scalars['Zone']['input'];
  groupNanoId: Scalars['ID']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
};


export type QueryFeaturedSeekMaxThreadsV2Args = {
  zone: Scalars['Zone']['input'];
  maxSize: Scalars['PositiveInt']['input'];
};


export type QueryFeaturedSeekMaxThreadsV3Args = {
  zone: Scalars['Zone']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
};


export type QueryPinnedSeekMaxThreadsV2Args = {
  zone: Scalars['Zone']['input'];
  maxSize: Scalars['PositiveInt']['input'];
};


export type QueryMoreSeekMaxThreadsV2Args = {
  zone: Scalars['Zone']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
};


export type QuerySeekMaxThreadV2Args = {
  zone: Scalars['Zone']['input'];
  id: Scalars['ID']['input'];
};


export type QuerySeekMaxMyThreadsV2Args = {
  zone: Scalars['Zone']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
};


export type QuerySeekMaxThreadAttachmentStatusArgs = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  id: Scalars['ID']['input'];
};


export type QuerySeekMaxThreadModerationStatusArgs = {
  zone: Scalars['Zone']['input'];
  threadId: Scalars['ID']['input'];
};


export type QuerySeekMaxCommentsV2Args = {
  zone: Scalars['Zone']['input'];
  threadId: Scalars['ID']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QuerySeekMaxCommentModerationStatusArgs = {
  zone: Scalars['Zone']['input'];
  commentId: Scalars['ID']['input'];
};


export type QuerySeekMaxRepliesArgs = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  commentId: Scalars['ID']['input'];
  cursor?: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QuerySeekMaxReplyModerationStatusArgs = {
  zone: Scalars['Zone']['input'];
  replyId: Scalars['ID']['input'];
};


export type QuerySeekMaxMyUnreadThreadsCountArgs = {
  zone: Scalars['Zone']['input'];
};


export type QuerySeekMaxCategoryGroupArgs = {
  zone: Scalars['Zone']['input'];
  locale: InputMaybe<Scalars['Locale']['input']>;
  groupId: Scalars['UUID']['input'];
};


export type QuerySeekMaxCategoryGroupsArgs = {
  zone: Scalars['Zone']['input'];
  locale: InputMaybe<Scalars['Locale']['input']>;
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QuerySearchSeekMaxContentsV2Args = {
  zone: Scalars['Zone']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  contentType: InputMaybe<Scalars['String']['input']>;
  query: InputMaybe<Scalars['String']['input']>;
};


export type QueryBookmarkedSeekMaxModulesArgs = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  pageToken: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
};


export type QuerySeekMaxCertificatesArgs = {
  cursor: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['PositiveInt']['input'];
};


export type QuerySeekMaxCertificateAttachmentStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySeekMaxCertificateSeekPassStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeaturedSeekMaxCollectionArgs = {
  zone: Scalars['Zone']['input'];
  maxCollectionSize: Scalars['Int']['input'];
};


export type QuerySeekMaxCollectionsArgs = {
  zone: Scalars['Zone']['input'];
  maxCollectionSize: Scalars['Int']['input'];
};


export type QueryRecentlyAddedSeekMaxModulesArgs = {
  locale: Scalars['Locale']['input'];
};


export type QueryRecentlyAddedSeekMaxModulesV2Args = {
  zone: Scalars['Zone']['input'];
};


export type QuerySeekMaxModuleArgs = {
  zone: Scalars['Zone']['input'];
  id: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySeekMaxModulesInProgressArgs = {
  locale: Scalars['Locale']['input'];
  pageToken: InputMaybe<Scalars['String']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRelatedSeekMaxModulesArgs = {
  zone: Scalars['Zone']['input'];
  moduleId: Scalars['ID']['input'];
};


export type QueryCategorySeekMaxModulesArgs = {
  zone: Scalars['Zone']['input'];
  categoryCode: Scalars['String']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryRecommendedSeekMaxModulesArgs = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  model: InputMaybe<Scalars['String']['input']>;
};


export type QuerySeekMaxFeedModulesArgs = {
  zone: Scalars['Zone']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
};


export type QuerySeekMaxFeedThreadsArgs = {
  zone: Scalars['Zone']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
};


export type QueryTrendingSeekMaxModulesV2Args = {
  zone: Scalars['Zone']['input'];
  pageSize: Scalars['Int']['input'];
  pageToken: InputMaybe<Scalars['String']['input']>;
};

/** One recommended query with search parameters and human-readable filters. */
export type QueryRecommendation = {
  searchQueryString: Maybe<Scalars['JobSearchQueryString']['output']>;
  parameters: Array<JobSearchV5ApiParameters>;
};


/** One recommended query with search parameters and human-readable filters. */
export type QueryRecommendationSearchQueryStringArgs = {
  siteKey: Scalars['String']['input'];
  locale: Scalars['Locale']['input'];
};


/** One recommended query with search parameters and human-readable filters. */
export type QueryRecommendationParametersArgs = {
  siteKey: Scalars['String']['input'];
  locale: Scalars['Locale']['input'];
};

/** The result wrapper for query recommendations including upstream requestId. */
export type QueryRecommendationResult = {
  requestId: Scalars['String']['output'];
  items: Array<QueryRecommendation>;
};

export type Question = {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type QuestionOption = {
  id: Scalars['String']['output'];
  uri: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type Questionnaire = {
  questions: Array<Question>;
};

export type QuestionnaireAnswerInput = {
  questionId: Scalars['String']['input'];
  answers: Array<AnswerForQuestionInput>;
};

export type RatingDescriptionInput = {
  description: InputMaybe<Scalars['String']['input']>;
  rating: InputMaybe<Scalars['Int']['input']>;
};

export type RatingInput = {
  rating: InputMaybe<Scalars['Int']['input']>;
};

export type RatingItem = {
  description: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  /** @deprecated Use value instead */
  rating: Scalars['Float']['output'];
};


export type RatingItemDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type Recommendations = {
  recommendedGlobalJobs: Maybe<RecommendedGlobalJobs>;
  similarJobsGlobal: Maybe<RecommendedGlobalJobs>;
};


export type RecommendationsRecommendedGlobalJobsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  source: AttributionSource;
  includeSavedJobs: InputMaybe<Scalars['Boolean']['input']>;
  zone: Scalars['Zone']['input'];
  visitorId: Scalars['UUID']['input'];
  platform: Platform;
  cluster: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
  candidateChatContext: InputMaybe<RecommendedJobsChatContextInput>;
};


export type RecommendationsSimilarJobsGlobalArgs = {
  jobId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  source: AttributionSource;
  includeSavedJobs: InputMaybe<Scalars['Boolean']['input']>;
  zone: Scalars['Zone']['input'];
  visitorId: Scalars['UUID']['input'];
  platform: Platform;
  cluster: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
};

export type RecommendedGlobalJob = {
  id: Scalars['ID']['output'];
  solMetadata: Scalars['JSON']['output'];
  isNew: Scalars['Boolean']['output'];
  job: Job;
  isSaved: Scalars['Boolean']['output'];
  tags: Maybe<Array<JobTag>>;
};

export type RecommendedGlobalJobs = {
  globalJobs: Array<RecommendedGlobalJob>;
  solMetadata: Maybe<Scalars['JSON']['output']>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type RecommendedJobsChatContextConfidenceInput = {
  titles: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locations: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationText: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classifications: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salaryFrom: InputMaybe<Scalars['String']['input']>;
  salaryTo: InputMaybe<Scalars['String']['input']>;
  salaryFromAnnualized: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salaryToAnnualized: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workType: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workArrangement: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companies: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skills: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keywords: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RecommendedJobsChatContextInput = {
  keywords: InputMaybe<Scalars['String']['input']>;
  titles: InputMaybe<Array<Scalars['String']['input']>>;
  locationText: InputMaybe<Array<Scalars['String']['input']>>;
  classifications: InputMaybe<Array<Scalars['String']['input']>>;
  salaryFrom: InputMaybe<Scalars['String']['input']>;
  salaryTo: InputMaybe<Scalars['String']['input']>;
  workType: InputMaybe<Array<Scalars['RecommendedJobsWorkTypeOption']['input']>>;
  workArrangement: InputMaybe<Array<Scalars['RecommendedJobsWorkArrangementOption']['input']>>;
  timestamp: InputMaybe<Scalars['String']['input']>;
  locations: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salaryFromAnnualized: InputMaybe<Scalars['Int']['input']>;
  salaryToAnnualized: InputMaybe<Scalars['Int']['input']>;
  companies: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skills: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confidence: InputMaybe<RecommendedJobsChatContextConfidenceInput>;
};

export type Reference = {
  /** The full name of the person providing the reference */
  refereeFullName: Scalars['String']['output'];
  /** The name of the organisation where the candidate and the person providing the reference worked together */
  organisationName: Scalars['String']['output'];
  /** A localized description of the working relationship between the candidate and the person providing the reference (referee). It expects locale as argument to give translated text */
  relationshipText: Scalars['String']['output'];
  /** The date when the candidate started working with the referee */
  fromDate: SeekDateTime;
  /** The date when the candidate stopped working with the referee (if applicable) */
  toDate: Maybe<SeekDateTime>;
  /** The candidate's job title or position during the referenced period */
  candidateRoleTitle: Scalars['String']['output'];
  /** The referee's job title or position during the referenced period */
  refereeRoleTitle: Scalars['String']['output'];
  /** The date when the reference was provided */
  referenceDate: SeekDateTime;
};


export type ReferenceRelationshipTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReferenceCheck = {
  /** Identifier of the reference check */
  id: Scalars['String']['output'];
  /** The list of references included in this reference check */
  references: Array<Reference>;
};

export type ReferenceCheckInput = {
  id: Scalars['String']['input'];
};

export type RejectConsentError = {
  message: Scalars['String']['output'];
};


export type RejectConsentErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type RejectConsentFailure = {
  errors: Array<RejectConsentError>;
};

export type RejectConsentInput = {
  transactionId: Scalars['UUID']['input'];
};

export type RejectConsentPayload = RejectConsentSuccess | RejectConsentFailure;

export type RejectConsentSuccess = {
  redirectUri: Scalars['String']['output'];
};

export type RejectConsentTransactionInvalidError = RejectConsentError & {
  message: Scalars['String']['output'];
};


export type RejectConsentTransactionInvalidErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type RejectRoleInput = {
  id: Scalars['UUID']['input'];
  title: OntologyStructuredDataInput;
  seniority: InputMaybe<OntologyStructuredDataInput>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  to: InputMaybe<MonthYearInput>;
  achievements: InputMaybe<Scalars['String']['input']>;
  tracking: InputMaybe<TrackingInfoInput>;
};

export type RejectRolePayload = {
  /** @deprecated Use viewer.roles */
  id: Scalars['UUID']['output'];
  viewer: Maybe<Candidate>;
};

export type RejectUnconfirmedDataInput = {
  dataType: UnconfirmedDataType;
  id: Scalars['UUID']['input'];
  tracking: InputMaybe<TrackingInfoInput>;
};

export type RejectUnconfirmedDataPayload = {
  /** @deprecated Use viewer.qualifications or viewer.roles */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type RenewFrequency = {
  value: Scalars['Int']['output'];
  unit: RenewalUnit;
};

export enum RenewalUnit {
  Days = 'days',
  Months = 'months'
}

export enum ReportJobCountryCode {
  /** @deprecated Use CountryCodeIso2 */
  Au = 'AU',
  /** @deprecated Use CountryCodeIso2 */
  Nz = 'NZ'
}

export type ReportJobInput = {
  jobId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  comment: InputMaybe<Scalars['String']['input']>;
  email: Scalars['Email']['input'];
  /** @deprecated Use country */
  countryCode: InputMaybe<ReportJobCountryCode>;
  country: InputMaybe<Scalars['CountryCodeIso2']['input']>;
};

export type ReportJobPayload = {
  success: Scalars['Boolean']['output'];
};

export type ReportProfileError = {
  message: Scalars['String']['output'];
};


export type ReportProfileErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type ReportProfileFailure = {
  error: ReportProfileError;
};

export type ReportProfileInput = {
  email: Scalars['Email']['input'];
  reason: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  profileSlug: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type ReportProfilePayload = ReportProfileSuccess | ReportProfileFailure;

export type ReportProfileSuccess = {
  ref: Scalars['UUID']['output'];
};

export type ReportSeekMaxCommentAlreadyReportedError = ReportSeekMaxCommentError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxCommentAlreadyReportedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxCommentAlreadyReportedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentError = {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxCommentErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxCommentErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentFailure = {
  errors: Array<ReportSeekMaxCommentError>;
};

export type ReportSeekMaxCommentInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ReportSeekMaxCommentPayload = ReportSeekMaxCommentSuccess | ReportSeekMaxCommentFailure;

export type ReportSeekMaxCommentPrivilegeError = ReportSeekMaxCommentError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxCommentPrivilegeErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxCommentPrivilegeErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentSuccess = {
  id: Scalars['ID']['output'];
};

export type ReportSeekMaxCommentUserIsBannedError = ReportSeekMaxCommentError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxCommentUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxCommentUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyAlreadyReportedError = ReportSeekMaxReplyError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxReplyAlreadyReportedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxReplyAlreadyReportedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyError = {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxReplyErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxReplyErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyFailure = {
  errors: Array<ReportSeekMaxReplyError>;
};

export type ReportSeekMaxReplyInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ReportSeekMaxReplyPayload = ReportSeekMaxReplySuccess | ReportSeekMaxReplyFailure;

export type ReportSeekMaxReplyPrivilegeError = ReportSeekMaxReplyError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxReplyPrivilegeErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxReplyPrivilegeErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplySuccess = {
  id: Scalars['ID']['output'];
};

export type ReportSeekMaxReplyUserIsBannedError = ReportSeekMaxReplyError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxReplyUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxReplyUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadAlreadyReportedError = ReportSeekMaxThreadError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxThreadAlreadyReportedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxThreadAlreadyReportedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadError = {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxThreadErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxThreadErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadFailure = {
  errors: Array<ReportSeekMaxThreadError>;
};

export type ReportSeekMaxThreadInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ReportSeekMaxThreadPayload = ReportSeekMaxThreadSuccess | ReportSeekMaxThreadFailure;

export type ReportSeekMaxThreadPrivilegeError = ReportSeekMaxThreadError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxThreadPrivilegeErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxThreadPrivilegeErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadSuccess = {
  id: Scalars['ID']['output'];
};

export type ReportSeekMaxThreadUserIsBannedError = ReportSeekMaxThreadError & {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type ReportSeekMaxThreadUserIsBannedErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type ReportSeekMaxThreadUserIsBannedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type RequestResumeParsingContext = {
  id: Scalars['UUID']['input'];
};

export type RequestResumeParsingInput = {
  id: Scalars['UUID']['input'];
  parsingContext: RequestResumeParsingContext;
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type RestrictedPublicProfileDigitalIdentity = {
  /** Whether the candidate has verified identity */
  isVerified: Scalars['Boolean']['output'];
};

export type RestrictedPublicProfileSearchResult = PublicProfileSearchResult & {
  /** The candidate profile id */
  slug: Scalars['ID']['output'];
  /** The candidate profile first name */
  firstName: Scalars['String']['output'];
  /** The candidate profile last name */
  lastName: Scalars['String']['output'];
  /** The candidate profile home location */
  homeLocation: PublicProfileLocation;
  /** The candidate's work history, */
  workHistories: Array<RestrictedPublicProfileWorkHistory>;
  /** Whether the candidate has verified credentials */
  hasVerifiedCredentials: Scalars['Boolean']['output'];
  /** The candidate's verified identity details */
  digitalIdentity: Maybe<RestrictedPublicProfileDigitalIdentity>;
};

export type RestrictedPublicProfileView = PublicProfileView & {
  /** The candidate profile id */
  slug: Scalars['ID']['output'];
  /** The candidate profile first name */
  firstName: Scalars['String']['output'];
  /** The candidate profile last name */
  lastName: Scalars['String']['output'];
  /** The candidate profile home location */
  homeLocation: PublicProfileLocation;
  /** The candidate's work history, */
  workHistories: Array<RestrictedPublicProfileWorkHistory>;
  /** Whether the candidate has verified credentials */
  hasVerifiedCredentials: Scalars['Boolean']['output'];
  /** The candidate's verified identity details */
  digitalIdentity: Maybe<RestrictedPublicProfileDigitalIdentity>;
  /** The candidate's profile GUID, used for tracking and analytics. */
  profileGuid: Scalars['UUID']['output'];
};

export type RestrictedPublicProfileWorkHistory = {
  /** The candidate profile company name */
  companyName: Scalars['String']['output'];
  /** The candidate profile job title */
  roleTitle: Scalars['String']['output'];
};

export type ResubscribeApacSavedSearchByCodeError = {
  message: Scalars['String']['output'];
};


export type ResubscribeApacSavedSearchByCodeErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type ResubscribeApacSavedSearchByCodeFailure = {
  error: ResubscribeApacSavedSearchByCodeError;
};

export type ResubscribeApacSavedSearchByCodeInput = {
  code: Scalars['String']['input'];
};

export type ResubscribeApacSavedSearchByCodePayload = ResubscribeApacSavedSearchByCodeSuccess | ResubscribeApacSavedSearchByCodeFailure;

export type ResubscribeApacSavedSearchByCodeSuccess = {
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type Resume = {
  id: Scalars['UUID']['output'];
  createdDateUtc: Scalars['DateTime']['output'];
  isDefault: Scalars['Boolean']['output'];
  fileMetadata: FileMetadata;
  origin: ResumeOrigin;
  createdDateRelative: Scalars['String']['output'];
};

export type ResumeAppliedJobDocument = {
  blobUrl: Scalars['String']['output'];
  downloadLink: Maybe<Scalars['String']['output']>;
  attachmentMetadata: AttachmentMetadata;
};

export type ResumeInput = {
  uri: Scalars['String']['input'];
  id: InputMaybe<Scalars['ID']['input']>;
  idFromResumeResource: InputMaybe<Scalars['Int']['input']>;
};

export type ResumeOrigin = {
  type: Maybe<ResumeOriginType>;
};

export enum ResumeOriginType {
  Uploaded = 'Uploaded',
  Generated = 'Generated'
}

export type ResumePrivacyDisclaimer = {
  value: Scalars['String']['output'];
  isEmphasized: Scalars['Boolean']['output'];
};

export type ResumePrivacyDisclaimers = {
  shortParagraphs: Array<ResumePrivacyDisclaimer>;
  longParagraphs: Array<ResumePrivacyDisclaimer>;
};

export type Review = {
  overallRating: Scalars['Float']['output'];
  ratings: Array<RatingItem>;
  id: Scalars['ID']['output'];
  createdAt: SeekDateTime;
  companyId: Scalars['String']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  employmentStatus: Maybe<Scalars['String']['output']>;
  workLocation: Maybe<Scalars['String']['output']>;
  salarySummary: Scalars['String']['output'];
  recommended: ReviewRecommended;
  title: Maybe<Scalars['String']['output']>;
  pros: Scalars['String']['output'];
  cons: Scalars['String']['output'];
  upvotes: Maybe<Upvotes>;
  reply: Maybe<CompanyReviewReply>;
};


export type ReviewEmploymentStatusArgs = {
  locale?: Scalars['Locale']['input'];
};


export type ReviewSalarySummaryArgs = {
  locale?: Scalars['Locale']['input'];
};

export type ReviewDetailsInput = {
  overallRating: Scalars['Int']['input'];
  overallExperience: InputMaybe<Scalars['String']['input']>;
  pros: InputMaybe<Scalars['String']['input']>;
  cons: InputMaybe<Scalars['String']['input']>;
  overallExperienceDetails: InputMaybe<Scalars['String']['input']>;
  isCompanyRecommended: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewRecommended = {
  description: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};


export type ReviewRecommendedDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type ReviewUpvotes = {
  upvotes: Array<Scalars['String']['output']>;
};

export type Reviews = {
  data: Array<Review>;
  paging: ReviewsPaging;
};

export type ReviewsPaging = {
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ReviewsRatingSummary = {
  companyId: Scalars['ID']['output'];
  company: Maybe<ReviewsRatingSummaryFull>;
  diversity: Maybe<ReviewsRatingSummaryFull>;
  executiveManagement: Maybe<ReviewsRatingSummaryFull>;
  perksAndBenefits: Maybe<ReviewsRatingSummaryFull>;
  careerOpportunity: Maybe<ReviewsRatingSummaryFull>;
  workEnvironment: Maybe<ReviewsRatingSummaryFull>;
  workLifeBalance: Maybe<ReviewsRatingSummaryFull>;
  companyRating1Star: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating2Star: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating3Star: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating4Star: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating5Star: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRecommended: Maybe<ReviewsRatingSummaryWithoutRating>;
  salaryFair: Maybe<ReviewsRatingSummaryWithoutRating>;
  salaryGenerous: Maybe<ReviewsRatingSummaryWithoutRating>;
  salaryPoor: Maybe<ReviewsRatingSummaryWithoutRating>;
};

export type ReviewsRatingSummaryCountOnly = {
  count: Maybe<Scalars['Int']['output']>;
};

export type ReviewsRatingSummaryFull = {
  count: Maybe<Scalars['Int']['output']>;
  percentage: Maybe<Scalars['Int']['output']>;
  rating: Maybe<Scalars['Float']['output']>;
};

export type ReviewsRatingSummaryWithoutRating = {
  count: Maybe<Scalars['Int']['output']>;
  percentage: Maybe<Scalars['Int']['output']>;
};

export type ReviewsSummary = {
  communityGuideline: CommunityGuideline;
  employeeRecommendation: EmployeeRecommendation;
  overallRating: OverallRating;
  ratings: Array<RatingItem>;
  salaryRating: SalaryRating;
};

export type RightToWork = {
  /** Unique ID that identifies a specific right to work */
  id: Scalars['UUID']['output'];
  /** Information about the country associated with the right to work */
  country: CountryInformation;
  /** Will be `null` if the user has not selected a right to work option. */
  type2: Maybe<RightToWorkType2>;
  /** Will only hold a value if the verification URL should be shown, will be `null` otherwise. */
  verificationUrl: Maybe<Scalars['String']['output']>;
  credential: Maybe<RightToWorkCredential>;
  /** Will be true if it doesn't have ontology data */
  isDeprecated: Maybe<Scalars['Boolean']['output']>;
};

export type RightToWorkCountryOptions = {
  /** A list of right to work options for the associated country code */
  options: Array<RightToWorkOption>;
  /** Information about the country associated with the right to work options */
  country: CountryInformation;
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights: Maybe<Array<SuggestionHighlight>>;
};

export type RightToWorkCredential = {
  fullName: Maybe<Scalars['String']['output']>;
  verification: CredentialVerification;
  visa: Maybe<RightToWorkVisa>;
  status: Maybe<CredentialStatus>;
  expiryFormatted: Scalars['String']['output'];
  manageVerificationUrl: Scalars['String']['output'];
};

export type RightToWorkFilterInput = {
  /** A partial country name to be searched */
  countryNameQuery: InputMaybe<Scalars['String']['input']>;
};

export type RightToWorkOption = {
  /** Unique ID used to identify a specific right to work option */
  id: Scalars['ID']['output'];
  /** Human readable string used when the user is selecting a right to work option. E.g. `Yes`. */
  description: Scalars['String']['output'];
  /** Human readable string used when showing a right to work option in a read-only context. E.g. `Yes, I have the right to work in Australia`. */
  formattedDescription: Scalars['String']['output'];
  /** Certsy verification URL for this right to work option. Will be `null` if selecting this option indicates that you do not have the right to work */
  verificationUrl: Maybe<Scalars['String']['output']>;
};

export type RightToWorkType2 = {
  /** Unique ID associated with a  `RightToWorkOption` */
  id: Scalars['String']['output'];
  /** Human readable string used when the user is selecting a right to work option. E.g. `Yes`. */
  description: Scalars['String']['output'];
  /** Human readable string used when showing a right to work option in a read-only context. E.g. `Yes, I have the right to work in Australia`. */
  formattedDescription: Scalars['String']['output'];
};

export type RightToWorkType2Input = {
  /** ID corresponding to a `RightToWorkOption` */
  id: Scalars['ID']['input'];
};

export type RightToWorkVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RightToWorkVisa = {
  subclass: Maybe<Scalars['String']['output']>;
  detailUrl: Maybe<Scalars['String']['output']>;
  holderType: Maybe<Scalars['String']['output']>;
};

export type RightsToWorkAlert = {
  alert: Maybe<AlertType>;
};

export type Role = {
  id: Scalars['UUID']['output'];
  title: OntologyStructuredData;
  seniority: Maybe<OntologyStructuredData>;
  company: OntologyStructuredData;
  from: MonthYear;
  to: Maybe<MonthYear>;
  /** Required for JobsDB only */
  function: Maybe<RoleFunction>;
  /** Required for JobsDB only */
  industry: Maybe<RoleIndustry>;
  achievements: Maybe<Scalars['String']['output']>;
  tracking: Maybe<TrackingInfo>;
};

export type RoleFunction = {
  id: Scalars['ID']['output'];
  subFunction: RoleSubFunction;
};

export type RoleFunctionInput = {
  id: Scalars['ID']['input'];
  subFunction: RoleSubFunctionInput;
};

export type RoleFunctionOption = {
  id: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  roleSubFunctions: Array<RoleSubFunctionOption>;
};

export type RoleIndustry = {
  id: Scalars['ID']['output'];
};

export type RoleIndustryInput = {
  id: Scalars['ID']['input'];
};

export type RoleInput = {
  genericTitle: InputMaybe<Scalars['String']['input']>;
  isCurrentEmployee: InputMaybe<Scalars['Boolean']['input']>;
  jobTitleId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  workHistory: InputMaybe<JobHistoryInput>;
  workType: Scalars['String']['input'];
};

export type RoleSubFunction = {
  id: Scalars['ID']['output'];
};

export type RoleSubFunctionInput = {
  id: Scalars['ID']['input'];
};

export type RoleSubFunctionOption = {
  id: Scalars['ID']['output'];
  description: Scalars['String']['output'];
};

export type SeoInfo = {
  normalisedRoleTitle: Maybe<Scalars['String']['output']>;
  workType: Maybe<Scalars['String']['output']>;
  classification: Maybe<Array<Scalars['String']['output']>>;
  subClassification: Maybe<Array<Scalars['String']['output']>>;
  where: Maybe<Scalars['String']['output']>;
  broaderLocationName: Maybe<Scalars['String']['output']>;
  normalisedOrganisationName: Maybe<Scalars['String']['output']>;
};


export type SeoInfoWhereArgs = {
  locale?: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};


export type SeoInfoBroaderLocationNameArgs = {
  locale?: Scalars['Locale']['input'];
};

export type SalaryCjs = {
  hideSalary: Maybe<Scalars['Boolean']['output']>;
  maximum: Maybe<Scalars['Int']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  minimum: Maybe<Scalars['Int']['output']>;
  period: Maybe<Scalars['String']['output']>;
};

export type SalaryFrequency = {
  type: Scalars['String']['output'];
  label: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
};


export type SalaryFrequencyLabelArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type SalaryInput = {
  rating: InputMaybe<Scalars['String']['input']>;
  includeBonus: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
  minimum: InputMaybe<Scalars['Int']['input']>;
  maximum: InputMaybe<Scalars['Int']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
};

export type SalaryOption = {
  country: Scalars['String']['output'];
  annually: Array<SalaryRangeOption>;
  hourly: Array<SalaryRangeOption>;
};

export type SalaryPreference2 = {
  /** Unique ID that identifies a specific salary preference */
  id: Scalars['UUID']['output'];
  /**
   * Formatted string to be shown to the user in read-mode. Formatted as:
   * {currency code} {amount} {salary type}. Will be `null` if the
   * preference has no `amount` value.
   */
  description: Maybe<Scalars['String']['output']>;
  /** Information about the country associated with the salary preference */
  country: CountryInformation;
  /** Currency associated with the minimum salary amount */
  currencyCode: Scalars['CurrencyCodeIso']['output'];
  /** Candidate's preferred minimum salary amount for a specific country and salary type */
  amount: Maybe<Scalars['SafeInt']['output']>;
  /** Salary type corresponding to the minimum salary amount */
  salaryType: SalaryType2;
};

export type SalaryPreference2Input = {
  /** Unique ID that identifies a specific salary preference */
  id: Scalars['UUID']['input'];
  /** Country associated with the minimum salary amount */
  countryCode: Scalars['CountryCodeIso2']['input'];
  /** Candidate's preferred minimum salary amount for a specific country and salary type */
  amount: InputMaybe<Scalars['SafeInt']['input']>;
  /** Salary type corresponding to the minimum salary amount */
  salaryType: SalaryType2;
};

export type SalaryRangeByIndustryDetails = {
  label: Scalars['String']['output'];
  jobsCount: Scalars['Int']['output'];
  salaryType: Scalars['String']['output'];
  industryAverageDescription: Scalars['String']['output'];
};


export type SalaryRangeByIndustryDetailsLabelArgs = {
  locale: Scalars['Locale']['input'];
};


export type SalaryRangeByIndustryDetailsIndustryAverageDescriptionArgs = {
  locale: Scalars['Locale']['input'];
};

export type SalaryRangeByRoles = {
  roleTitle: Scalars['String']['output'];
  roleId: Scalars['ID']['output'];
  salaryRangeByCompany: Maybe<SalaryRangeDetails>;
  salaryRangeByIndustry: Maybe<SalaryRangeByIndustryDetails>;
};


export type SalaryRangeByRolesRoleTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type SalaryRangeDetails = {
  label: Scalars['String']['output'];
  jobsCount: Scalars['Int']['output'];
  salaryType: Scalars['String']['output'];
};


export type SalaryRangeDetailsLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type SalaryRangeOption = {
  label: Scalars['String']['output'];
  value: Scalars['SafeInt']['output'];
};

export type SalaryRating = {
  value: Scalars['Float']['output'];
  rating: Scalars['String']['output'];
  description: Scalars['String']['output'];
};


export type SalaryRatingDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type SalaryS = {
  min: Maybe<Scalars['Int']['output']>;
  max: Maybe<Scalars['Int']['output']>;
  period: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
};

export enum SalaryType2 {
  Annual = 'Annual',
  Monthly = 'Monthly',
  Hourly = 'Hourly'
}

export type SaveJobPreferencesArgs = {
  reason: Scalars['String']['output'];
  typeId: Scalars['String']['output'];
};

export type SaveJobPreferencesError = {
  message: Scalars['String']['output'];
};


export type SaveJobPreferencesErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SaveJobPreferencesFailure = {
  error: SaveJobPreferencesError;
};

export type SaveJobPreferencesInput = {
  reason: Scalars['String']['input'];
  typeId: Scalars['String']['input'];
};

export type SaveJobPreferencesPayload = SaveJobPreferencesSuccess | SaveJobPreferencesFailure;

export type SaveJobPreferencesSuccess = {
  preferences: Array<Maybe<CandidateJobPreferencesGroup>>;
};

export type SaveSeekMaxKeywordSearchError = {
  message: Scalars['String']['output'];
};


export type SaveSeekMaxKeywordSearchErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SaveSeekMaxKeywordSearchFailure = {
  errors: Array<SaveSeekMaxKeywordSearchError>;
};

export type SaveSeekMaxKeywordSearchInput = {
  searchedKeyword: Scalars['String']['input'];
};

export type SaveSeekMaxKeywordSearchPayload = SaveSeekMaxKeywordSearchSuccess | SaveSeekMaxKeywordSearchFailure;

export type SaveSeekMaxKeywordSearchSuccess = {
  searchedKeyword: Scalars['String']['output'];
};

export type SavedJob = {
  id: Scalars['ID']['output'];
  createdAt: SeekDateTime;
  notes: Maybe<Scalars['String']['output']>;
  zone: Maybe<Scalars['Zone']['output']>;
  job: Job;
  isActive: Scalars['Boolean']['output'];
  isExternal: Scalars['Boolean']['output'];
};

export type SavedJobConnection = {
  pageInfo: PageInfo;
  edges: Array<SavedJobEdge>;
  total: Scalars['Int']['output'];
};

export type SavedJobEdge = {
  node: SavedJob;
  cursor: Scalars['String']['output'];
};

export type SavedJobEventCaptureDataInput = {
  channel: Scalars['String']['input'];
  view: Scalars['String']['input'];
  serpTracking: InputMaybe<Scalars['String']['input']>;
  eventCaptureSessionId: Scalars['String']['input'];
};

export type SavedSearchApacQuery = {
  searchQueryString: Maybe<Scalars['JobSearchQueryString']['output']>;
  parameters: Array<SavedSearchParameters>;
};

export type SavedSearchParameters = {
  type: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type SearchAppliedJobPartial = {
  jobId: Scalars['String']['output'];
};

export type SearchCompanyDetails = {
  data: Maybe<Array<Maybe<SearchCompanyProfileItem>>>;
  paging: ReviewsPaging;
};

export type SearchCompanyDetailsFilterInput = {
  sortBy: InputMaybe<SearchCompanyProfileSortBy>;
  name: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['Zone']['input']>;
  size: InputMaybe<Scalars['String']['input']>;
  industry: InputMaybe<Scalars['String']['input']>;
  seekLocationId: InputMaybe<Scalars['Int']['input']>;
  seekAreaId: InputMaybe<Scalars['Int']['input']>;
  stateId: InputMaybe<Scalars['Int']['input']>;
  suburbId: InputMaybe<Scalars['Int']['input']>;
  countryId: InputMaybe<Scalars['Int']['input']>;
};

export type SearchCompanyDetailsPagingInput = {
  page: InputMaybe<Scalars['Int']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
};

export type SearchCompanyProfileData = {
  name: Scalars['String']['output'];
  branding: Maybe<BasicBranding>;
  /** @deprecated Not required anymore */
  overview: Maybe<CompanyProfileOverview>;
  published: Maybe<Scalars['Boolean']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  reviewCount: Maybe<Scalars['Int']['output']>;
  reviewRating: Maybe<Scalars['Float']['output']>;
};

export type SearchCompanyProfileItem = {
  companyId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  companyOverview: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  coverUrl: Maybe<Scalars['String']['output']>;
  companySlug: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['String']['output']>;
  sortRating: Maybe<CompanyProfileSortRating>;
  overallRating: Maybe<CompanyProfileOverallRating>;
  industry: Maybe<Scalars['String']['output']>;
  location: Maybe<SearchCompanyProfileLocation>;
  jobCount: Maybe<Scalars['Int']['output']>;
  organisationId: Maybe<Scalars['String']['output']>;
};

export type SearchCompanyProfileLocation = {
  suburb: Maybe<Scalars['String']['output']>;
  area: Maybe<Scalars['String']['output']>;
  location: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
};

export type SearchCompanyProfileResultItem = {
  companyId: Scalars['String']['output'];
  organisationId: Scalars['String']['output'];
  zone: Scalars['String']['output'];
  data: SearchCompanyProfileData;
};

export enum SearchCompanyProfileSortBy {
  OverallRating = 'OVERALL_RATING',
  PerksAndBenefits = 'PERKS_AND_BENEFITS',
  CareerOpportunity = 'CAREER_OPPORTUNITY',
  Diversity = 'DIVERSITY',
  ExecutiveManagement = 'EXECUTIVE_MANAGEMENT',
  WorkEnvironment = 'WORK_ENVIRONMENT',
  WorkLifeBalance = 'WORK_LIFE_BALANCE',
  FirstNation = 'FIRST_NATION'
}

export type SearchFilterData = {
  workArrangementOptions: Array<WorkArrangementOption>;
};

export type SearchKeywordSuggestions = {
  metadata: Maybe<SearchSuggestionsMetadata>;
  suggestions: Array<KeywordSuggestionType>;
};

export type SearchLocationSuggestions = {
  suggestions: Array<LocationSuggestionType>;
};

export type SearchPageInfo = {
  startCursor: Maybe<Scalars['Int']['output']>;
  hasPrevPage: Scalars['Boolean']['output'];
  endCursor: Maybe<Scalars['Int']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type SearchSalaryRange = {
  frequency: SalaryFrequency;
  range: Array<SearchSalaryRangeItem>;
};

export type SearchSalaryRangeItem = {
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


export type SearchSalaryRangeItemLabelArgs = {
  type: InputMaybe<SearchSalaryRangeLabelType>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export enum SearchSalaryRangeLabelType {
  Short = 'SHORT',
  Long = 'LONG'
}

export type SearchSavedJobPartial = {
  jobId: Scalars['String']['output'];
  zone: Maybe<Scalars['Zone']['output']>;
};

export type SearchSuggestionsMetadata = {
  flightId: Maybe<Scalars['String']['output']>;
  requestToken: Maybe<Scalars['UUID']['output']>;
};

export type SeekDateTime = {
  /** Contextual label for the date. E.g. for job posted, 15 mins ago, but for seekmax poll, 15 mins left */
  label: Scalars['String']['output'];
  /** Generic string representation of the date relative to now. E.g. 6 hours ago */
  shortLabel: Scalars['String']['output'];
  longLabel: Scalars['String']['output'];
  /** Generic string representation of the absolute date. E.g. 9 Nov 2021 */
  shortAbsoluteLabel: Scalars['String']['output'];
  longAbsoluteLabel: Scalars['String']['output'];
  shortMonthYearAbsoluteLabel: Scalars['String']['output'];
  dateTime: Scalars['String']['output'];
  dateTimeUtc: Scalars['DateTime']['output'];
  /** @deprecated Use label with context SEEKMAX_POLL_DURATION_LEFT */
  seekMaxPollLabel: Scalars['String']['output'];
};


export type SeekDateTimeLabelArgs = {
  context: DateTimeContext;
  length: DateTimeLength;
  timezone: Scalars['Timezone']['input'];
  locale: Scalars['Locale']['input'];
};


export type SeekDateTimeShortLabelArgs = {
  timezone: InputMaybe<Scalars['Timezone']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type SeekDateTimeLongLabelArgs = {
  timezone: InputMaybe<Scalars['Timezone']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type SeekDateTimeShortAbsoluteLabelArgs = {
  timezone: InputMaybe<Scalars['Timezone']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type SeekDateTimeLongAbsoluteLabelArgs = {
  timezone: InputMaybe<Scalars['Timezone']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type SeekDateTimeShortMonthYearAbsoluteLabelArgs = {
  timezone: InputMaybe<Scalars['Timezone']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type SeekDateTimeDateTimeArgs = {
  timezone: InputMaybe<Scalars['Timezone']['input']>;
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type SeekDateTimeSeekMaxPollLabelArgs = {
  timezone: Scalars['Timezone']['input'];
  locale: Scalars['Locale']['input'];
};

export type SeekDuration = {
  label: Maybe<Scalars['String']['output']>;
};


export type SeekDurationLabelArgs = {
  context: DurationContext;
  locale: Scalars['Locale']['input'];
};

export type SeekLocation = {
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
};


export type SeekLocationLabelArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
  context: SeekLocationContext;
};

export enum SeekLocationContext {
  ContextualName = 'CONTEXTUAL_NAME'
}

export type SeekMaxAttachment = {
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type SeekMaxAttachmentFailed = ISeekMaxAttachmentStatus & {
  id: Scalars['ID']['output'];
  failureReason: Scalars['String']['output'];
};

export type SeekMaxAttachmentPending = ISeekMaxAttachmentStatus & {
  id: Scalars['ID']['output'];
};

export type SeekMaxAttachmentPublished = ISeekMaxAttachmentStatus & {
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export enum SeekMaxAttachmentType {
  Image = 'IMAGE'
}

export type SeekMaxAttachmentUploadReady = ISeekMaxAttachmentStatus & {
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export enum SeekMaxCategory {
  SelfDevelopment = 'SELF_DEVELOPMENT',
  SalaryAdvice = 'SALARY_ADVICE',
  JobSearchAdvice = 'JOB_SEARCH_ADVICE',
  TechnologyAndDesign = 'TECHNOLOGY_AND_DESIGN',
  LanguageLearning = 'LANGUAGE_LEARNING',
  LeadershipAndManagement = 'LEADERSHIP_AND_MANAGEMENT',
  CareerAdvice = 'CAREER_ADVICE',
  BusinessAndFinance = 'BUSINESS_AND_FINANCE',
  SalesAndMarketing = 'SALES_AND_MARKETING',
  IndustryTrends = 'INDUSTRY_TRENDS'
}

export type SeekMaxCategoryGroupConnectionResults = {
  edges: Maybe<Array<Maybe<SeekMaxCategoryGroupEdge>>>;
  pageInfo: SeekMaxPageInfo;
};

export type SeekMaxCategoryGroupEdge = {
  node: ISeekMaxCategoryGroup;
  cursor: Scalars['Int']['output'];
};

export type SeekMaxCategoryGroupFollowInput = {
  groupId: Scalars['ID']['input'];
  followed: Scalars['Boolean']['input'];
};

export type SeekMaxCategoryGroupLocal = ISeekMaxCategoryGroup & {
  groupId: Scalars['ID']['output'];
  categoryId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  memberCount: SocialMetric;
  description: Scalars['String']['output'];
  personalisedDetails: Maybe<PersonalisedSeekMaxCategoryGroup>;
};

export type SeekMaxCategoryGroupTopic = ISeekMaxCategoryGroup & {
  groupId: Scalars['ID']['output'];
  categoryId: Scalars['ID']['output'];
  categoryCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  memberCount: SocialMetric;
  personalisedDetails: Maybe<PersonalisedSeekMaxCategoryGroup>;
};

export enum SeekMaxCertType {
  None = 'NONE',
  Certificate = 'CERTIFICATE',
  QuizzedCertificate = 'QUIZZED_CERTIFICATE'
}

export type SeekMaxCertificate = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  author: Scalars['String']['output'];
  achievedAt: SeekDateTime;
  badgeUrl: Scalars['String']['output'];
  seekPassStatus: Maybe<ISeekMaxCertificateSeekPassStatus>;
};

export type SeekMaxCertificateAttachmentFailed = ISeekMaxCertificateAttachmentStatus & {
  id: Scalars['ID']['output'];
  failureReason: Scalars['String']['output'];
};

export type SeekMaxCertificateAttachmentPending = ISeekMaxCertificateAttachmentStatus & {
  id: Scalars['ID']['output'];
};

export type SeekMaxCertificateAttachmentPublished = ISeekMaxCertificateAttachmentStatus & {
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type SeekMaxCertificateConnectionResults = {
  edges: Maybe<Array<Maybe<SeekMaxCertificateEdge>>>;
  pageInfo: PageInfo;
};

export type SeekMaxCertificateEdge = {
  node: SeekMaxCertificate;
};

export type SeekMaxCertificateSeekPassFail = ISeekMaxCertificateSeekPassStatus & {
  id: Scalars['ID']['output'];
};

export type SeekMaxCertificateSeekPassPending = ISeekMaxCertificateSeekPassStatus & {
  id: Scalars['ID']['output'];
};

export type SeekMaxCertificateSeekPassSuccess = ISeekMaxCertificateSeekPassStatus & {
  id: Scalars['ID']['output'];
};

export type SeekMaxCollection = {
  title: Scalars['String']['output'];
  modules: Array<SeekMaxModule>;
};

export type SeekMaxComment = {
  id: Scalars['ID']['output'];
  author: SeekMaxPublicUser;
  content: Scalars['String']['output'];
  creationDate: SeekDateTime;
  exactSocialData: ExactCommentSocialData;
  personalisedDetails: Maybe<PersonalisedSeekMaxComment>;
};

export type SeekMaxCommentConnectionResults = {
  edges: Maybe<Array<Maybe<SeekMaxCommentEdge>>>;
  pageInfo: SeekMaxPageInfo;
  /** @deprecated Use pageSize instead */
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxCommentEdge = {
  node: Maybe<ISeekMaxComment>;
  cursor: Scalars['Int']['output'];
};

export type SeekMaxCommentLikedStatusFailure = {
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxCommentLikedStatusSuccess = {
  id: Scalars['ID']['output'];
  likeCount: SocialMetric;
  liked: Scalars['Boolean']['output'];
};

export type SeekMaxCommentV2 = ISeekMaxComment & {
  id: Scalars['ID']['output'];
  author: SeekMaxPublicUser;
  content: Scalars['String']['output'];
  creationDate: SeekDateTime;
  exactSocialData: ExactCommentSocialData;
  personalisedDetails: Maybe<PersonalisedSeekMaxComment>;
};

export type SeekMaxContentSearchResults = {
  edges: Array<SeekMaxSearchContentEdge>;
  pageInfo: SearchPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxImageAttachment = SeekMaxAttachment & {
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type SeekMaxKolExpert = ISeekMaxKolGroup & {
  description: Scalars['String']['output'];
};

export type SeekMaxLandingInfo = {
  learningProfileId: Scalars['String']['output'];
};

export type SeekMaxLikeInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  id: Scalars['ID']['input'];
  liked: Scalars['Boolean']['input'];
};

export type SeekMaxLikedStatusError = {
  message: Scalars['String']['output'];
};


export type SeekMaxLikedStatusErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxModerationFlagImage = {
  attachmentId: Scalars['ID']['output'];
  flagCategory: Scalars['String']['output'];
  flagReason: Scalars['String']['output'];
};

export type SeekMaxModerationFlagText = {
  flagCategory: Scalars['String']['output'];
  flagReason: Scalars['String']['output'];
};

export type SeekMaxModerationFlags = {
  text: Maybe<Array<SeekMaxModerationFlagText>>;
  image: Maybe<Array<SeekMaxModerationFlagImage>>;
};

export type SeekMaxModerationStatusFail = ISeekMaxModerationStatus & {
  id: Scalars['ID']['output'];
  flags: SeekMaxModerationFlags;
};

export type SeekMaxModerationStatusPending = ISeekMaxModerationStatus & {
  id: Scalars['ID']['output'];
};

export type SeekMaxModerationStatusSuccess = ISeekMaxModerationStatus & {
  id: Scalars['ID']['output'];
  attachments: Maybe<Array<SeekMaxImageAttachment>>;
};

export type SeekMaxModule = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  author: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  totalDuration: Duration;
  previewImageSrc: Maybe<Scalars['String']['output']>;
  thumbnailImageSrc: Maybe<Scalars['String']['output']>;
  keywordTags: Maybe<Array<Scalars['String']['output']>>;
  tags: Maybe<Array<SeekMaxTags>>;
  videos: Maybe<Array<SeekMaxVideo>>;
  skillLevel: SeekMaxSkillLevel;
  /** @deprecated To be removed SeekMaxCategory enum */
  categories: Maybe<Array<SeekMaxCategory>>;
  personalisedDetails: Maybe<PersonalisedSeekMaxModule>;
  personalisedProgress: Maybe<PersonalisedSeekMaxModuleProgress>;
  threadId: Maybe<Scalars['ID']['output']>;
  exactSocialData: ExactModuleSocialData;
  /** UNSTABLE! */
  approxSocialData: ApproxModuleSocialData;
  shareLink: Scalars['String']['output'];
  metaData: Maybe<SeekMaxModuleMetaData>;
  certData: Maybe<SeekMaxModuleCertificateData>;
};


export type SeekMaxModulePersonalisedProgressArgs = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
};


export type SeekMaxModuleShareLinkArgs = {
  zone: Scalars['Zone']['input'];
  platform: Platform;
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type SeekMaxModuleBookmark = {
  bookmarkDate: SeekDateTime;
};

export type SeekMaxModuleBookmarkInput = {
  id: Scalars['ID']['input'];
  /** @deprecated Not in use */
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
};

export type SeekMaxModuleBookmarkResults = {
  modules: Array<SeekMaxModule>;
  resultCount: Scalars['Int']['output'];
  nextPageToken: Maybe<Scalars['String']['output']>;
};

export type SeekMaxModuleCertificateData = {
  certType: Maybe<SeekMaxCertType>;
  url: Maybe<Scalars['String']['output']>;
};

export type SeekMaxModuleClickedPersonalisationEventError = {
  message: Scalars['String']['output'];
};


export type SeekMaxModuleClickedPersonalisationEventErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxModuleClickedPersonalisationEventFailure = {
  errors: Array<SeekMaxModuleClickedPersonalisationEventError>;
};

export type SeekMaxModuleClickedPersonalisationEventInput = {
  zone: Scalars['Zone']['input'];
  session: Scalars['UUID']['input'];
  moduleId: Scalars['ID']['input'];
};

export type SeekMaxModuleClickedPersonalisationEventPayload = SeekMaxModuleClickedPersonalisationEventSuccess | SeekMaxModuleClickedPersonalisationEventFailure;

export type SeekMaxModuleClickedPersonalisationEventSuccess = {
  moduleId: Scalars['ID']['output'];
};

export type SeekMaxModuleConnectionResults = {
  edges: Array<SeekMaxModuleEdge>;
  pageInfo: SeekMaxPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxModuleEdge = {
  node: SeekMaxModule;
  cursor: Scalars['Int']['output'];
};

export type SeekMaxModuleFeed = {
  content: SeekMaxModule;
  metaData: Maybe<SeekMaxModuleMetaData>;
};

export type SeekMaxModuleFeedEdge = {
  node: SeekMaxModuleFeed;
};

export type SeekMaxModuleFeedResults = {
  edges: Maybe<Array<Maybe<SeekMaxModuleFeedEdge>>>;
};

export type SeekMaxModuleLikeInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  moduleThreadId: Scalars['ID']['input'];
  liked: Scalars['Boolean']['input'];
};

export type SeekMaxModuleLikedStatusFailure = {
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxModuleLikedStatusSuccess = {
  moduleThreadId: Scalars['ID']['output'];
  likeCount: SocialMetric;
  liked: Scalars['Boolean']['output'];
};

export type SeekMaxModuleMetaData = {
  source: Maybe<Scalars['String']['output']>;
};

export type SeekMaxModuleProgressError = {
  message: Scalars['String']['output'];
};


export type SeekMaxModuleProgressErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxModuleProgressFailure = {
  errors: Array<SeekMaxModuleProgressError>;
};

export type SeekMaxModuleProgressInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  /** @deprecated Use zone instead */
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  id: Scalars['ID']['input'];
  videoId: Scalars['ID']['input'];
  resumeFromSeconds: Scalars['Float']['input'];
};

export type SeekMaxModuleProgressPayload = SeekMaxModuleProgressSuccess | SeekMaxModuleProgressFailure;

export type SeekMaxModuleProgressSuccess = {
  id: Scalars['ID']['output'];
  videoId: Scalars['ID']['output'];
};

export type SeekMaxModuleSearchContent = ISeekMaxSearchContent & {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  author: Scalars['String']['output'];
  totalDuration: Duration;
  videoCount: Scalars['Int']['output'];
  previewImageSrc: Maybe<Scalars['String']['output']>;
  thumbnailImageSrc: Maybe<Scalars['String']['output']>;
  exactSocialData: ExactModuleSocialData;
};

export type SeekMaxModulesInProgressResults = {
  modules: Array<SeekMaxModule>;
  resultCount: Scalars['Int']['output'];
  nextPageToken: Maybe<Scalars['String']['output']>;
};

export type SeekMaxNextVideoProgress = {
  id: Scalars['ID']['output'];
  state: SeekMaxVideoState;
  percentageCompleted: Scalars['Float']['output'];
  resumeFromSeconds: Scalars['Float']['output'];
  durationLeft: Maybe<DurationLeft>;
  previewImageSrc: Maybe<Scalars['String']['output']>;
  thumbnailImageSrc: Maybe<Scalars['String']['output']>;
};

export type SeekMaxPageInfo = {
  startCursor: Maybe<Scalars['Int']['output']>;
  hasPrevPage: Scalars['Boolean']['output'];
  endCursor: Maybe<Scalars['Int']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type SeekMaxPoll = {
  id: Scalars['ID']['output'];
  ended: Scalars['Boolean']['output'];
  voteCount: SocialMetric;
  endDate: SeekDateTime;
  maxVotes: Scalars['Int']['output'];
  options: Array<SeekMaxPollOption>;
};

export type SeekMaxPollOption = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
  personalisedDetails: Maybe<PersonalisedSeekMaxPollOption>;
};

export type SeekMaxProfile = {
  learningProfileId: Scalars['ID']['output'];
  learningProfileHashCode: Scalars['Int']['output'];
  groups: Array<ISeekMaxKolGroup>;
};

export type SeekMaxPublicLearningProfile = {
  firstName: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
};

export type SeekMaxPublicUser = {
  id: Scalars['ID']['output'];
  learningProfile: Maybe<SeekMaxPublicLearningProfile>;
  learningProfileHashCode: Scalars['Int']['output'];
  groups: Array<ISeekMaxKolGroup>;
};

export type SeekMaxReply = {
  id: Scalars['ID']['output'];
  author: SeekMaxPublicUser;
  content: Scalars['String']['output'];
  creationDate: SeekDateTime;
};

export type SeekMaxReplyResults = {
  replies: Array<SeekMaxReply>;
  resultCount: Scalars['Int']['output'];
  lastCursor: Scalars['Int']['output'];
};

export type SeekMaxSearchContentEdge = {
  node: ISeekMaxSearchContent;
  cursor: Scalars['Int']['output'];
};

export enum SeekMaxSkillLevel {
  Basic = 'BASIC',
  Intermediate = 'INTERMEDIATE',
  Expert = 'EXPERT',
  Unknown = 'UNKNOWN'
}

export type SeekMaxTags = {
  tag: Scalars['String']['output'];
  color: Scalars['String']['output'];
};

export type SeekMaxThread = {
  id: Scalars['ID']['output'];
  author: SeekMaxPublicUser;
  description: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  creationDate: SeekDateTime;
  categoryGroup: Maybe<ISeekMaxCategoryGroup>;
  pollV3: Maybe<SeekMaxPoll>;
  commentsV3: Maybe<Array<Maybe<SeekMaxComment>>>;
  attachments: Maybe<Array<SeekMaxImageAttachment>>;
  isPinned: Scalars['Boolean']['output'];
  exactSocialData: ExactThreadSocialData;
  personalisedDetails: Maybe<PersonalisedSeekMaxThread>;
  shareLink: Scalars['String']['output'];
  hasUnreadPosts: Maybe<Scalars['Boolean']['output']>;
  keywordTags: Maybe<Array<Scalars['String']['output']>>;
};


export type SeekMaxThreadCategoryGroupArgs = {
  zone: Scalars['Zone']['input'];
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type SeekMaxThreadPollV3Args = {
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadCommentsV3Args = {
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadShareLinkArgs = {
  zone: Scalars['Zone']['input'];
  platform: Platform;
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type SeekMaxThreadConnectionResults = {
  edges: Array<SeekMaxThreadEdge>;
  pageInfo: SeekMaxPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxThreadEdge = {
  node: SeekMaxThread;
  cursor: Scalars['Int']['output'];
};

export type SeekMaxThreadFeed = {
  content: SeekMaxThread;
  metaData: Maybe<SeekMaxThreadMetaData>;
};

export type SeekMaxThreadFeedEdge = {
  node: SeekMaxThreadFeed;
};

export type SeekMaxThreadFeedResults = {
  edges: Maybe<Array<Maybe<SeekMaxThreadFeedEdge>>>;
};

export type SeekMaxThreadLikedStatusFailure = {
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxThreadLikedStatusSuccess = {
  id: Scalars['ID']['output'];
  likeCount: SocialMetric;
  liked: Scalars['Boolean']['output'];
};

export type SeekMaxThreadMetaData = {
  source: Maybe<Scalars['String']['output']>;
};

export type SeekMaxThreadPollInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  pollId: Scalars['ID']['input'];
  optionId: Scalars['ID']['input'];
  voted: Scalars['Boolean']['input'];
};

export type SeekMaxThreadPollStatusError = {
  message: Scalars['String']['output'];
};


export type SeekMaxThreadPollStatusErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxThreadPollStatusFailure = {
  errors: Array<SeekMaxThreadPollStatusError>;
};

export type SeekMaxThreadPollStatusSuccess = {
  pollId: Scalars['ID']['output'];
  optionId: Scalars['ID']['output'];
  voted: Scalars['Boolean']['output'];
};

export type SeekMaxThreadSearchContent = ISeekMaxSearchContent & {
  id: Scalars['ID']['output'];
  author: SeekMaxPublicUser;
  description: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  creationDate: SeekDateTime;
  categoryGroup: Maybe<ISeekMaxCategoryGroup>;
  commentsV3: Maybe<Array<Maybe<SeekMaxComment>>>;
  attachments: Maybe<Array<SeekMaxImageAttachment>>;
  isPinned: Scalars['Boolean']['output'];
  exactSocialData: ExactThreadSocialData;
  personalisedDetails: Maybe<PersonalisedSeekMaxThreadSearchContent>;
  keywordTags: Maybe<Array<Scalars['String']['output']>>;
};


export type SeekMaxThreadSearchContentCategoryGroupArgs = {
  zone: Scalars['Zone']['input'];
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type SeekMaxThreadSearchContentCommentsV3Args = {
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadV2 = ISeekMaxThread & {
  id: Scalars['ID']['output'];
  author: SeekMaxPublicUser;
  description: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  creationDate: SeekDateTime;
  categoryGroup: Maybe<ISeekMaxCategoryGroup>;
  pollV3: Maybe<SeekMaxPoll>;
  commentsV3: Maybe<Array<Maybe<SeekMaxComment>>>;
  attachments: Maybe<Array<SeekMaxImageAttachment>>;
  isPinned: Scalars['Boolean']['output'];
  exactSocialData: ExactThreadSocialData;
  personalisedDetails: Maybe<PersonalisedSeekMaxThread>;
  shareLink: Scalars['String']['output'];
  keywordTags: Maybe<Array<Scalars['String']['output']>>;
};


export type SeekMaxThreadV2CategoryGroupArgs = {
  zone: Scalars['Zone']['input'];
  locale: InputMaybe<Scalars['Locale']['input']>;
};


export type SeekMaxThreadV2PollV3Args = {
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadV2CommentsV3Args = {
  zone: Scalars['Zone']['input'];
};


export type SeekMaxThreadV2ShareLinkArgs = {
  zone: Scalars['Zone']['input'];
  platform: Platform;
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type SeekMaxThreadViewedPersonalisationEventError = {
  /** UNSTABLE! */
  message: Scalars['String']['output'];
};


export type SeekMaxThreadViewedPersonalisationEventErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxThreadViewedPersonalisationEventFailure = {
  /** UNSTABLE! */
  errors: Array<SeekMaxThreadViewedPersonalisationEventError>;
};

export type SeekMaxThreadViewedPersonalisationEventInput = {
  /** UNSTABLE! */
  zone: Scalars['Zone']['input'];
  /** UNSTABLE! */
  threadId: Scalars['ID']['input'];
};

export type SeekMaxThreadViewedPersonalisationEventPayload = SeekMaxThreadViewedPersonalisationEventSuccess | SeekMaxThreadViewedPersonalisationEventFailure;

export type SeekMaxThreadViewedPersonalisationEventSuccess = {
  /** UNSTABLE! */
  zone: Scalars['Zone']['output'];
  /** UNSTABLE! */
  threadId: Scalars['ID']['output'];
};

export type SeekMaxTrendingModuleConnectionResults = {
  edges: Maybe<Array<Maybe<SeekMaxTrendingModuleEdge>>>;
  pageInfo: PageInfo;
};

export type SeekMaxTrendingModuleEdge = {
  node: SeekMaxModule;
};

export type SeekMaxUnreadThreadsCountResponse = {
  count: Scalars['Int']['output'];
};

export type SeekMaxVideo = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  duration: Duration;
  previewImageSrc: Scalars['String']['output'];
  thumbnailImageSrc: Scalars['String']['output'];
  drmEnabled: Scalars['Boolean']['output'];
  personalisedDetails: Maybe<PersonalisedSeekMaxVideo>;
};

export type SeekMaxVideoProgress = {
  state: SeekMaxVideoState;
  percentageCompleted: Scalars['Float']['output'];
  resumeFromSeconds: Scalars['Float']['output'];
  durationLeft: Maybe<DurationLeft>;
};

export enum SeekMaxVideoState {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED'
}

export type SeekMaxVideoViewedEventError = {
  message: Scalars['String']['output'];
};


export type SeekMaxVideoViewedEventErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxVideoViewedEventFailure = {
  errors: Array<SeekMaxVideoViewedEventError>;
};

export type SeekMaxVideoViewedEventInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  /** @deprecated Use zone instead */
  locale: InputMaybe<Scalars['Locale']['input']>;
  session: Scalars['UUID']['input'];
  videoId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
};

export type SeekMaxVideoViewedEventPayload = SeekMaxVideoViewedEventSuccess | SeekMaxVideoViewedEventFailure;

export type SeekMaxVideoViewedEventSuccess = {
  moduleId: Scalars['ID']['output'];
  videoId: Scalars['ID']['output'];
};

export type SeekMaxVideoViewedPersonalisationEventError = {
  message: Scalars['String']['output'];
};


export type SeekMaxVideoViewedPersonalisationEventErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxVideoViewedPersonalisationEventFailure = {
  errors: Array<SeekMaxVideoViewedPersonalisationEventError>;
};

export type SeekMaxVideoViewedPersonalisationEventInput = {
  zone: Scalars['Zone']['input'];
  session: Scalars['UUID']['input'];
  moduleId: Scalars['ID']['input'];
  videoId: Scalars['ID']['input'];
};

export type SeekMaxVideoViewedPersonalisationEventPayload = SeekMaxVideoViewedPersonalisationEventSuccess | SeekMaxVideoViewedPersonalisationEventFailure;

export type SeekMaxVideoViewedPersonalisationEventSuccess = {
  moduleId: Scalars['ID']['output'];
  videoId: Scalars['ID']['output'];
};

export type SelectionCriteriaInput = {
  uri: Scalars['String']['input'];
  writtenText: InputMaybe<Scalars['String']['input']>;
};

export type SendLoginCallbackEventFailure = {
  error: I18nAccountError;
};

export type SendLoginCallbackEventPayload = SendLoginCallbackEventSuccess | SendLoginCallbackEventFailure;

export type SendLoginCallbackEventSuccess = {
  loginType: Scalars['String']['output'];
};

export type SendSeekMaxModuleClickedEventError = {
  message: Scalars['String']['output'];
};


export type SendSeekMaxModuleClickedEventErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SendSeekMaxModuleClickedEventFailure = {
  errors: Array<SendSeekMaxModuleClickedEventError>;
};

export type SendSeekMaxModuleClickedEventInput = {
  zone: InputMaybe<Scalars['Zone']['input']>;
  /** @deprecated Use zone instead */
  countryCode: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  session: Scalars['UUID']['input'];
  moduleId: Scalars['ID']['input'];
};

export type SendSeekMaxModuleClickedEventPayload = SendSeekMaxModuleClickedEventSuccess | SendSeekMaxModuleClickedEventFailure;

export type SendSeekMaxModuleClickedEventSuccess = {
  moduleId: Scalars['ID']['output'];
};

export type SensitiveDataInfo = {
  isDetected: Scalars['Boolean']['output'];
};

export type SetAppliedJobNotesError = {
  message: Scalars['String']['output'];
};


export type SetAppliedJobNotesErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SetAppliedJobNotesFailure = {
  errors: Array<SetAppliedJobNotesError>;
};

export type SetAppliedJobNotesInput = {
  id: Scalars['String']['input'];
  notes: InputMaybe<Scalars['String']['input']>;
};

export type SetAppliedJobNotesPayload = SetAppliedJobNotesSuccess | SetAppliedJobNotesFailure;

export type SetAppliedJobNotesSuccess = {
  id: Maybe<Scalars['String']['output']>;
};

export type SetAppliedJobNotesValidationError = SetAppliedJobNotesError & {
  message: Scalars['String']['output'];
};


export type SetAppliedJobNotesValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SetDefaultResumeInput = {
  id: Scalars['UUID']['input'];
};

export type SetDefaultResumePayload = {
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type SetSavedJobNotesError = {
  message: Scalars['String']['output'];
};


export type SetSavedJobNotesErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SetSavedJobNotesFailure = {
  errors: Array<SetSavedJobNotesError>;
};

export type SetSavedJobNotesInput = {
  id: Scalars['ID']['input'];
  notes: InputMaybe<Scalars['String']['input']>;
};

export type SetSavedJobNotesPayload = SetSavedJobNotesSuccess | SetSavedJobNotesFailure;

export type SetSavedJobNotesSuccess = {
  id: Scalars['ID']['output'];
};

export type SetSavedJobNotesValidationError = SetSavedJobNotesError & {
  message: Scalars['String']['output'];
};


export type SetSavedJobNotesValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SetSeekMaxCategoryGroupFollowedStatusError = {
  title: Scalars['String']['output'];
  message: Scalars['String']['output'];
};


export type SetSeekMaxCategoryGroupFollowedStatusErrorTitleArgs = {
  locale: Scalars['Locale']['input'];
};


export type SetSeekMaxCategoryGroupFollowedStatusErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SetSeekMaxCategoryGroupFollowedStatusFailure = {
  errors: Array<SetSeekMaxCategoryGroupFollowedStatusError>;
};

export type SetSeekMaxCategoryGroupFollowedStatusPayload = SetSeekMaxCategoryGroupFollowedStatusSuccess | SetSeekMaxCategoryGroupFollowedStatusFailure;

export type SetSeekMaxCategoryGroupFollowedStatusSuccess = {
  groupId: Scalars['ID']['output'];
  categoryId: Scalars['ID']['output'];
  followed: Scalars['Boolean']['output'];
};

export type SetSeekMaxCommentLikedStatusPayload = SeekMaxCommentLikedStatusSuccess | SeekMaxCommentLikedStatusFailure;

export type SetSeekMaxModuleLikedStatusPayload = SeekMaxModuleLikedStatusSuccess | SeekMaxModuleLikedStatusFailure;

export type SetSeekMaxThreadLikedStatusPayload = SeekMaxThreadLikedStatusSuccess | SeekMaxThreadLikedStatusFailure;

export type SetSeekMaxThreadPollStatusPayload = SeekMaxThreadPollStatusSuccess | SeekMaxThreadPollStatusFailure;

export type ShareableProfile = {
  id: Maybe<Scalars['ID']['output']>;
  active: Scalars['Boolean']['output'];
  summary: Maybe<Scalars['String']['output']>;
  personalDetails: PersonalDetails;
  roles: Array<Role>;
  qualifications: Array<Qualification>;
  licences: Array<Licence>;
  skills: Array<Skill>;
  languageProficiencies: Array<LanguageProficiency>;
  verifiedIdentity: Maybe<VerifiedIdentity>;
};

export type ShareableProfileSettings = {
  profileSlug: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  displayUrl: Maybe<Scalars['String']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  privacy: Maybe<Privacy>;
  views: Maybe<Scalars['Int']['output']>;
};

export type SingleChoiceQuestion = Question & {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  options: Array<QuestionOption>;
  lastAnswer: Maybe<LastAnswer>;
};

export type Skill = {
  keyword: OntologyStructuredData;
};

export type SkillInput = {
  keyword: OntologyStructuredDataInput;
};

export enum SmarterSearchInclude {
  Canonical = 'CANONICAL',
  Jobs = 'JOBS',
  RelatedSearches = 'RELATED_SEARCHES',
  JobHistory = 'JOB_HISTORY',
  SearchHistory = 'SEARCH_HISTORY',
  Pill = 'PILL',
  AsyncPills = 'ASYNC_PILLS'
}

export type SocialMetric = {
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SourceExperience {
  Apply = 'APPLY',
  Profile = 'PROFILE',
  Jas = 'JAS'
}

export type Sourcr = {
  searchFilters: Maybe<SourcrRecruiterDirectorySearchFilters>;
  searchRecruiter: Maybe<SourcrRecruiterDirectorySearchRecruiterResult>;
  searchAgency: Maybe<SourcrRecruiterDirectorySearchAgencyResult>;
  featuredRecruiters: Maybe<SourcrRecruiterDirectorySearchRecruiterResult>;
  featuredAgencies: Maybe<SourcrRecruiterDirectorySearchAgencyResult>;
  agencyProfileDetails: Maybe<SourcrRecruiterDirectoryAgencyDetails>;
  recruiterProfileDetails: Maybe<SourcrRecruiterDirectoryRecruiterDetails>;
  paginatedPlacements: Maybe<SourcrRecruiterDirectoryPaginatedPlacement>;
  agencyPaginatedReviews: Maybe<SourcrRecruiterDirectoryPaginatedReview>;
  recruiterPaginatedReviews: Maybe<SourcrRecruiterDirectoryPaginatedReview>;
  paginatedRecruiters: Maybe<SourcrRecruiterDirectoryPaginatedRecruiter>;
  paginatedJobs: Maybe<SourcrRecruiterDirectoryPaginatedJob>;
  awards: Maybe<SourcrRecruiterDirectoryAwards>;
};


export type SourcrSearchRecruiterArgs = {
  input: InputMaybe<SourcrRecruiterDirectorySearchInput>;
};


export type SourcrSearchAgencyArgs = {
  input: InputMaybe<SourcrRecruiterDirectorySearchInput>;
};


export type SourcrFeaturedRecruitersArgs = {
  country: Scalars['String']['input'];
};


export type SourcrFeaturedAgenciesArgs = {
  country: Scalars['String']['input'];
};


export type SourcrAgencyProfileDetailsArgs = {
  slug: Scalars['String']['input'];
  visitorId: InputMaybe<Scalars['String']['input']>;
};


export type SourcrRecruiterProfileDetailsArgs = {
  slug: Scalars['String']['input'];
  visitorId: InputMaybe<Scalars['String']['input']>;
};


export type SourcrPaginatedPlacementsArgs = {
  slug: Scalars['String']['input'];
  type: SourcrRecruiterDirectoryProfileTypeEnum;
  pagination: SourcrRecruiterDirectoryPaginationInput;
};


export type SourcrAgencyPaginatedReviewsArgs = {
  slug: Scalars['String']['input'];
  pagination: SourcrRecruiterDirectoryPaginationInput;
};


export type SourcrRecruiterPaginatedReviewsArgs = {
  slug: Scalars['String']['input'];
  pagination: SourcrRecruiterDirectoryPaginationInput;
};


export type SourcrPaginatedRecruitersArgs = {
  slug: Scalars['String']['input'];
  pagination: SourcrRecruiterDirectoryPaginationInput;
};


export type SourcrPaginatedJobsArgs = {
  slug: Scalars['String']['input'];
  type: SourcrRecruiterDirectoryProfileTypeEnum;
  pagination: SourcrRecruiterDirectoryPaginationInput;
};


export type SourcrAwardsArgs = {
  slug: Scalars['String']['input'];
  type: SourcrRecruiterDirectoryProfileTypeEnum;
  limit: Scalars['Int']['input'];
};

export type SourcrMessageInput = {
  serviceToken: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  type: SourcrRecruiterDirectoryProfileTypeEnum;
  name: Scalars['String']['input'];
  email: Scalars['Email']['input'];
  country: Scalars['String']['input'];
  number: InputMaybe<Scalars['String']['input']>;
};

export type SourcrPageAnalyticsEventInput = {
  page: Scalars['String']['input'];
  pageType: SourcrRecruiterDirectoryProfileTypeEnum;
  slug: Scalars['String']['input'];
  referrer: InputMaybe<Scalars['String']['input']>;
  ipAddress: InputMaybe<Scalars['String']['input']>;
  device: InputMaybe<Scalars['String']['input']>;
  operatingSystem: InputMaybe<Scalars['String']['input']>;
  browser: InputMaybe<Scalars['String']['input']>;
  timeSpent: InputMaybe<Scalars['Float']['input']>;
};

export type SourcrRecruiter = {
  name: Scalars['String']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  overallRating: Scalars['Float']['output'];
  reviewCount: Scalars['Int']['output'];
  avatarImageUrl: Maybe<Scalars['String']['output']>;
  agencyImageUrl: Maybe<Scalars['String']['output']>;
  contactUrl: Scalars['String']['output'];
  agencyName: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterAward = {
  name: Maybe<Scalars['String']['output']>;
  years: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
  result: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryAddress = {
  state: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  postcode: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryAgency = {
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rating: Maybe<Scalars['Float']['output']>;
  reviewCount: Scalars['Int']['output'];
  avatarImageUrl: Maybe<Scalars['String']['output']>;
  bannerImageUrl: Maybe<Scalars['String']['output']>;
  address: Maybe<SourcrRecruiterDirectoryAddress>;
};

export type SourcrRecruiterDirectoryAgencyDetails = {
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reviewCount: Scalars['Int']['output'];
  contactNumber: Maybe<Scalars['String']['output']>;
  rating: Maybe<Scalars['Float']['output']>;
  avatarImageUrl: Maybe<Scalars['String']['output']>;
  address: Maybe<SourcrRecruiterDirectoryAddress>;
  about: Maybe<Scalars['String']['output']>;
  bannerImageUrl: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
  specialisations: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reviewsInsight: Maybe<SourcrRecruiterDirectoryReviewsInsight>;
  showSeekDirectoryEmail: Maybe<Scalars['Boolean']['output']>;
  metadata: Maybe<SourcrRecruiterDirectoryMetadata>;
};

export type SourcrRecruiterDirectoryAwards = {
  totalItems: Maybe<Scalars['Int']['output']>;
  items: Maybe<Array<Maybe<SourcrRecruiterAward>>>;
};

export type SourcrRecruiterDirectoryFilterInput = {
  name: InputMaybe<SourcrRecruiterDirectoryFilterNameEnum>;
  values: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum SourcrRecruiterDirectoryFilterNameEnum {
  RoleTypes = 'ROLE_TYPES',
  Country = 'COUNTRY',
  Postcode = 'POSTCODE',
  Specialisations = 'SPECIALISATIONS',
  Claimed = 'CLAIMED',
  LastReviewDate = 'LAST_REVIEW_DATE',
  PlacementTitles = 'PLACEMENT_TITLES'
}

export type SourcrRecruiterDirectoryJob = {
  id: Scalars['ID']['output'];
  jobId: Maybe<Scalars['Int']['output']>;
  title: Maybe<Scalars['String']['output']>;
  location: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<SeekDateTime>;
};

export type SourcrRecruiterDirectoryJobCategory = {
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryLocationFilter = {
  country: Maybe<Scalars['String']['output']>;
  postcodes: Maybe<Array<Maybe<SourcrRecruiterDirectoryLocationFilterPostcodes>>>;
};

export type SourcrRecruiterDirectoryLocationFilterPostcodes = {
  value: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryMetadata = {
  serviceToken: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryPaginatedJob = {
  items: Array<Maybe<SourcrRecruiterDirectoryJob>>;
  pagination: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
};

export type SourcrRecruiterDirectoryPaginatedPlacement = {
  items: Maybe<Array<Maybe<SourcrRecruiterDirectoryPlacement>>>;
  pagination: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
};

export type SourcrRecruiterDirectoryPaginatedRecruiter = {
  items: Maybe<Array<Maybe<SourcrRecruiterDirectoryRecruiter>>>;
  pagination: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
};

export type SourcrRecruiterDirectoryPaginatedReview = {
  items: Maybe<Array<Maybe<SourcrRecruiterDirectoryReview>>>;
  pagination: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
};

export type SourcrRecruiterDirectoryPaginationInput = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type SourcrRecruiterDirectoryPlacement = {
  id: Scalars['ID']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  industry: Maybe<Scalars['String']['output']>;
  jobType: Maybe<Scalars['String']['output']>;
  salaryRange: Maybe<Scalars['String']['output']>;
  address: Maybe<SourcrRecruiterDirectoryAddress>;
  category: Maybe<SourcrRecruiterDirectoryJobCategory>;
};

export enum SourcrRecruiterDirectoryProfileTypeEnum {
  Recruiter = 'RECRUITER',
  Agency = 'AGENCY'
}

export type SourcrRecruiterDirectoryRecruiter = {
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  name: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  agencyName: Maybe<Scalars['String']['output']>;
  rating: Maybe<Scalars['Float']['output']>;
  reviewCount: Scalars['Int']['output'];
  placementCount: Scalars['Int']['output'];
  avatarImageUrl: Maybe<Scalars['String']['output']>;
  address: Maybe<SourcrRecruiterDirectoryAddress>;
  specialisations: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SourcrRecruiterDirectoryRecruiterDetails = {
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  name: Scalars['String']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  rating: Maybe<Scalars['Float']['output']>;
  reviewCount: Scalars['Int']['output'];
  contactNumber: Maybe<Scalars['String']['output']>;
  avatarImageUrl: Maybe<Scalars['String']['output']>;
  bannerImageUrl: Maybe<Scalars['String']['output']>;
  address: Maybe<SourcrRecruiterDirectoryAddress>;
  agencyName: Maybe<Scalars['String']['output']>;
  agency: Maybe<SourcrRecruiterDirectoryAgency>;
  about: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
  specialisations: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reviewsInsight: Maybe<SourcrRecruiterDirectoryReviewsInsight>;
  showSeekDirectoryEmail: Maybe<Scalars['Boolean']['output']>;
  metadata: Maybe<SourcrRecruiterDirectoryMetadata>;
};

export type SourcrRecruiterDirectoryReview = {
  id: Scalars['ID']['output'];
  title: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  review: Maybe<Scalars['String']['output']>;
  thumbnail: Maybe<Scalars['String']['output']>;
  replyMessage: Maybe<Scalars['String']['output']>;
  isRepliedBy: Maybe<Scalars['String']['output']>;
  isRepliedByAgencyAdmin: Maybe<Scalars['Boolean']['output']>;
  isThirdParty: Maybe<Scalars['Boolean']['output']>;
  repliedAgency: Maybe<SourcrRecruiterDirectoryAgency>;
  type: Scalars['String']['output'];
  companyName: Maybe<Scalars['String']['output']>;
  sourceType: Maybe<Scalars['String']['output']>;
  recruiter: Maybe<SourcrRecruiterDirectoryRecruiter>;
  secondaryRecruiter: Maybe<SourcrRecruiterDirectoryRecruiter>;
  agency: Maybe<SourcrRecruiterDirectoryAgency>;
  rating: Maybe<Scalars['Float']['output']>;
  responsiveness: Maybe<Scalars['Float']['output']>;
  communication: Maybe<Scalars['Float']['output']>;
  candidateQuality: Maybe<Scalars['Float']['output']>;
  industryKnowledge: Maybe<Scalars['Float']['output']>;
  candidateRating: Maybe<Scalars['Float']['output']>;
  googleRating: Maybe<Scalars['Float']['output']>;
  createdAt: Maybe<SeekDateTime>;
  isExternal: Maybe<Scalars['Boolean']['output']>;
};

export type SourcrRecruiterDirectoryReviewsInsight = {
  rating: Maybe<Scalars['Float']['output']>;
  last12MonthsReviewCount: Maybe<Scalars['Int']['output']>;
  placementCount: Maybe<Scalars['Int']['output']>;
};

export type SourcrRecruiterDirectorySearchAgencyResult = {
  items: Maybe<Array<Maybe<SourcrRecruiterDirectoryAgency>>>;
  pagination: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
  placementTitleMatchAccuracy: Maybe<Scalars['String']['output']>;
  metadata: Maybe<SourcrRecruiterDirectoryMetadata>;
};

export type SourcrRecruiterDirectorySearchFilters = {
  locations: Maybe<Array<Maybe<SourcrRecruiterDirectoryLocationFilter>>>;
  specialities: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roles: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SourcrRecruiterDirectorySearchInput = {
  pagination: InputMaybe<SourcrRecruiterDirectoryPaginationInput>;
  query: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<Array<InputMaybe<SourcrRecruiterDirectoryFilterInput>>>;
  withBoost: InputMaybe<Scalars['Boolean']['input']>;
  visitorId: InputMaybe<Scalars['String']['input']>;
};

export type SourcrRecruiterDirectorySearchRecruiterResult = {
  items: Maybe<Array<Maybe<SourcrRecruiterDirectoryRecruiter>>>;
  pagination: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
  placementTitleMatchAccuracy: Maybe<Scalars['String']['output']>;
  metadata: Maybe<SourcrRecruiterDirectoryMetadata>;
};

export type SourcrRecruiterDirectorySearchResultPagination = {
  cursor: Maybe<Scalars['Int']['output']>;
  pageSize: Maybe<Scalars['Int']['output']>;
  totalItems: Maybe<Scalars['Int']['output']>;
};

export enum SpecReqProfileField {
  LicencesCertifications = 'LicencesCertifications',
  Skills = 'Skills',
  PreferredLocation = 'PreferredLocation',
  RightToWork = 'RightToWork',
  PreferredWorkTypes = 'PreferredWorkTypes',
  LanguageProficiency = 'LanguageProficiency'
}

export type StandardChannel = ApplicationChannel & {
  label: Maybe<Scalars['String']['output']>;
};


export type StandardChannelLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type StandardVisibilityOption = ProfileVisibilityOption & {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
};


export type StandardVisibilityOptionNameArgs = {
  locale: Scalars['Locale']['input'];
};


export type StandardVisibilityOptionDescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type SubClassification = {
  id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export type SubClassificationInput = {
  id: Scalars['Int']['input'];
};

export type Subject = {
  /** The Auth0 user id of the subject, eg 'auth0|12eb841a02c489d1'. */
  id: Scalars['String']['output'];
  /**
   * The associated jobseeker id, derived from the "http://seek/claims/user_id" claim.
   * This is optional, as the user in Auth0 may not be associated with a jobseeker record.
   */
  userId: Maybe<Scalars['String']['output']>;
};

export type SubmitApplicationError = {
  message: Scalars['String']['output'];
};


export type SubmitApplicationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SubmitApplicationFailure = {
  errors: Array<SubmitApplicationError>;
};

export type SubmitApplicationInput = {
  jobId: Scalars['ID']['input'];
  correlationId: Scalars['ID']['input'];
  personalDetails: InputMaybe<SubmitApplicationPersonalDetailsInput>;
  profilePrivacyLevel: InputMaybe<Scalars['String']['input']>;
  mostRecentRole: InputMaybe<MostRecentRoleInput>;
  questionnaireAnswers: InputMaybe<Array<QuestionnaireAnswerInput>>;
  resume: InputMaybe<ResumeInput>;
  coverLetter: InputMaybe<CoverLetterInput>;
  selectionCriteria: InputMaybe<SelectionCriteriaInput>;
  zone: InputMaybe<Scalars['Zone']['input']>;
  referenceCheck: InputMaybe<ReferenceCheckInput>;
};

export type SubmitApplicationPayload = SubmitApplicationSuccess | SubmitApplicationFailure;

export type SubmitApplicationPersonalDetailsInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type SubmitApplicationSuccess = {
  /** @deprecated Use applicationId instead */
  viewer: Maybe<Candidate>;
  applicationId: Scalars['String']['output'];
};

export type SubmitApplicationValidationError = SubmitApplicationError & {
  message: Scalars['String']['output'];
};


export type SubmitApplicationValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SubmitSourcrMessagePayload = {
  message: Maybe<Scalars['String']['output']>;
};

export type SubmitSourcrPageAnalyticsEventPayload = {
  message: Maybe<Scalars['String']['output']>;
};

export type SubscribeApacSavedEmailAlertError = {
  message: Scalars['String']['output'];
};


export type SubscribeApacSavedEmailAlertErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SubscribeApacSavedEmailAlertFailedError = SubscribeApacSavedEmailAlertError & {
  message: Scalars['String']['output'];
};


export type SubscribeApacSavedEmailAlertFailedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type SubscribeApacSavedEmailAlertFailure = {
  errors: Maybe<Array<SubscribeApacSavedEmailAlertError>>;
};

export type SubscribeApacSavedEmailAlertInput = {
  id: Scalars['ID']['input'];
  subscribe: Scalars['Boolean']['input'];
};

export type SubscribeApacSavedEmailAlertPayload = SubscribeApacSavedEmailAlertSuccess | SubscribeApacSavedEmailAlertFailure;

export type SubscribeApacSavedEmailAlertSuccess = {
  savedSearch: ApacSavedSearch;
  subscribed: Scalars['Boolean']['output'];
};

export type SubscribeMobileNoti = {
  deviceToken: Scalars['String']['input'];
  platform: MobilePlatformNoti;
  appVersion: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type SubscribeMobileNotiPayload = SubscribeMobileNotiSuccess | MobileNotiFailure;

export type SubscribeMobileNotiSuccess = {
  deviceToken: Scalars['String']['output'];
  platformName: Scalars['String']['output'];
};

export enum SuggestionGroupType {
  Remote = 'Remote',
  Recent = 'Recent',
  Suggestions = 'Suggestions',
  International = 'International'
}

export type SuggestionHighlight = {
  start: Scalars['Int']['output'];
  end: Scalars['Int']['output'];
};

export type TestTagsInput = {
  testRecord: InputMaybe<Scalars['Boolean']['input']>;
  testScope: InputMaybe<Scalars['String']['input']>;
};

export type TopApplicantBadge = {
  label: Scalars['String']['output'];
  description: Scalars['String']['output'];
};


export type TopApplicantBadgeLabelArgs = {
  locale?: Scalars['Locale']['input'];
};


export type TopApplicantBadgeDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
  zone: InputMaybe<Scalars['Zone']['input']>;
};

export type TrackJobApplicationStartedInput = {
  applicationCorrelationId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  isProfileApply: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrackJobApplicationStartedPayload = {
  eventId: Maybe<Scalars['ID']['output']>;
};

export type TrackJobDetailsViewedError = {
  message: Scalars['String']['output'];
};


export type TrackJobDetailsViewedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type TrackJobDetailsViewedFailure = {
  error: TrackJobDetailsViewedError;
};

export type TrackJobDetailsViewedInput = {
  jobseekerSessionId: Scalars['String']['input'];
  jobId: Scalars['Int']['input'];
  omnitureTracking: InputMaybe<Scalars['String']['input']>;
  candidateId: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Deprecated in favour of a more descriptive field name. Use testTags instead. */
  jobDetailsViewedCorrelationId: InputMaybe<Scalars['String']['input']>;
  tags: InputMaybe<TestTagsInput>;
  testTags: InputMaybe<TestTagsInput>;
};

export type TrackJobDetailsViewedPayload = TrackJobDetailsViewedSuccess | TrackJobDetailsViewedFailure;

export type TrackJobDetailsViewedSuccess = {
  eventId: Maybe<Scalars['String']['output']>;
};

export type TrackSearchResultSelectedError = {
  message: Scalars['String']['output'];
};


export type TrackSearchResultSelectedErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type TrackSearchResultSelectedFailure = {
  error: TrackSearchResultSelectedError;
};

export type TrackSearchResultSelectedInput = {
  jobseekerSessionId: Scalars['String']['input'];
  jobId: Scalars['Int']['input'];
  adDisplayType: Scalars['String']['input'];
  isFeatured: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Deprecated in favour of a more descriptive field name. Use testTags instead. */
  userQueryId: InputMaybe<Scalars['String']['input']>;
  tags: InputMaybe<TestTagsInput>;
  testTags: InputMaybe<TestTagsInput>;
};

export type TrackSearchResultSelectedPayload = TrackSearchResultSelectedSuccess | TrackSearchResultSelectedFailure;

export type TrackSearchResultSelectedSuccess = {
  eventId: Maybe<Scalars['String']['output']>;
};

export type TrackingInfo = {
  events: Maybe<Array<KeyValue>>;
};

export type TrackingInfoInput = {
  events: InputMaybe<Array<KeyValueInput>>;
};

export enum UnconfirmedContextType {
  Application = 'Application',
  PrimaryResume = 'PrimaryResume'
}

export type UnconfirmedData = UnconfirmedDataCompleted | UnconfirmedDataPending;

export type UnconfirmedDataCompleted = {
  completed: Scalars['Boolean']['output'];
  roles: Array<Role>;
  qualifications: Array<Qualification>;
};

export type UnconfirmedDataPending = {
  completed: Scalars['Boolean']['output'];
};

export enum UnconfirmedDataType {
  CareerHistory = 'CareerHistory',
  Education = 'Education'
}

export type UnknownCreateShareableProfileSettingsError = CreateShareableProfileSettingsError & {
  message: Scalars['String']['output'];
};


export type UnknownCreateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownDeleteJobPreferencesError = DeleteJobPreferencesError & {
  message: Scalars['String']['output'];
};


export type UnknownDeleteJobPreferencesErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type UnknownReportProfileError = ReportProfileError & {
  message: Scalars['String']['output'];
};


export type UnknownReportProfileErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownSaveJobPreferencesError = SaveJobPreferencesError & {
  message: Scalars['String']['output'];
};


export type UnknownSaveJobPreferencesErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type UnknownUpdateCurrentLocation2Error = UpdateCurrentLocation2Error & {
  message: Scalars['String']['output'];
};


export type UnknownUpdateCurrentLocation2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownUpdatePreferredLocations2Error = UpdatePreferredLocations2Error & {
  message: Scalars['String']['output'];
};


export type UnknownUpdatePreferredLocations2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownUpdateShareableProfileSettingsError = UpdateShareableProfileSettingsError & {
  message: Scalars['String']['output'];
};


export type UnknownUpdateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownUpdateShareableProfileViewsError = UpdateShareableProfileViewsError & {
  message: Scalars['String']['output'];
};


export type UnknownUpdateShareableProfileViewsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnrestrictedPublicProfileDigitalIdentity = {
  /** Verified Name */
  verifiedName: Maybe<Scalars['String']['output']>;
  /** Whether the candidate has verified identity */
  isVerified: Scalars['Boolean']['output'];
};

export type UnrestrictedPublicProfileSearchResult = PublicProfileSearchResult & {
  /** The candidate profile id */
  slug: Scalars['ID']['output'];
  /** The candidate profile first name */
  firstName: Scalars['String']['output'];
  /** The candidate profile last name */
  lastName: Scalars['String']['output'];
  /** The candidate profile home location */
  homeLocation: PublicProfileLocation;
  /** The candidate's work history, */
  workHistories: Array<UnrestrictedPublicProfileWorkHistory>;
  /** Whether the candidate has verified credentials */
  hasVerifiedCredentials: Scalars['Boolean']['output'];
  /** The candidate's verified identity details */
  digitalIdentity: Maybe<UnrestrictedPublicProfileDigitalIdentity>;
  /** True if the profile is owned by the logged in user */
  isOwnedByLoggedInUser: Scalars['Boolean']['output'];
};

export type UnrestrictedPublicProfileView = PublicProfileView & {
  /** The candidate profile id */
  slug: Scalars['ID']['output'];
  /** The candidate profile first name */
  firstName: Scalars['String']['output'];
  /** The candidate profile last name */
  lastName: Scalars['String']['output'];
  /** The candidate profile home location */
  homeLocation: PublicProfileLocation;
  /** The candidate's work history, */
  workHistories: Array<UnrestrictedPublicProfileWorkHistory>;
  /** Whether the candidate has verified credentials */
  hasVerifiedCredentials: Scalars['Boolean']['output'];
  /** The candidate's verified identity details */
  digitalIdentity: Maybe<UnrestrictedPublicProfileDigitalIdentity>;
  /** The candidate's personal summary */
  personalSummary: Maybe<Scalars['String']['output']>;
  /** The candidate's educational qualifications */
  education: Array<PublicProfileEducation>;
  /** The candidate's licences */
  licences: Array<PublicProfileLicence>;
  /** The candidate's skills */
  skills: Array<Scalars['String']['output']>;
  /** The candidate's languages */
  languages: Array<Scalars['String']['output']>;
  /** The candidate's rights to work information */
  rightsToWork: Array<PublicProfileRightToWork>;
  /** True if the profile is owned by the logged in user */
  isOwnedByLoggedInUser: Scalars['Boolean']['output'];
  /** The candidate's profile GUID, used for tracking and analytics. */
  profileGuid: Scalars['UUID']['output'];
};

export type UnrestrictedPublicProfileWorkHistory = {
  /** The candidate profile company name */
  companyName: Scalars['String']['output'];
  /** The candidate profile job title */
  roleTitle: Scalars['String']['output'];
  /** The candidate's work duration counted in months and years using inclusive calculation where both start and end months are included (e.g., Jan 2025 to Mar 2025 = 3 months). */
  duration: PublicProfileInclusiveWorkDuration;
  /** The candidate profile achievements */
  achievements: Maybe<Scalars['String']['output']>;
};

export type UnsubscribeApacSavedSearchByCodeError = {
  message: Scalars['String']['output'];
};


export type UnsubscribeApacSavedSearchByCodeErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UnsubscribeApacSavedSearchByCodeFailure = {
  error: UnsubscribeApacSavedSearchByCodeError;
};

export type UnsubscribeApacSavedSearchByCodeInput = {
  code: Scalars['String']['input'];
};

export type UnsubscribeApacSavedSearchByCodePayload = UnsubscribeApacSavedSearchByCodeSuccess | UnsubscribeApacSavedSearchByCodeFailure;

export type UnsubscribeApacSavedSearchByCodeSuccess = {
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type UnsubscribeMobileNoti = {
  deviceToken: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type UnsubscribeMobileNotiPayload = UnsubscribeMobileNotiSuccess | MobileNotiFailure;

export type UnsubscribeMobileNotiSuccess = {
  deviceToken: Scalars['String']['output'];
};

export type UnverifiedPublicProfileEducation = PublicProfileEducation & {
  /** The name of the educational qualification */
  name: Scalars['String']['output'];
  /** The name of the educational institution */
  institute: Scalars['String']['output'];
  /** The completion status of the education. */
  completion: PublicProfileEducationCompletion;
  /** The highlights of the educational qualification */
  highlights: Maybe<Scalars['String']['output']>;
};

export type UnverifiedPublicProfileLicence = PublicProfileLicence & {
  /** The name of the licence */
  name: Scalars['String']['output'];
  /** The name of the organization that issued the licence */
  issuingOrganisation: Maybe<Scalars['String']['output']>;
};

export type UpdateApproachabilityInput = {
  approachable: Scalars['Boolean']['input'];
};

export type UpdateApproachabilityPayload = {
  /** @deprecated Please use viewer.approachability */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type UpdateAvailabilityInput = {
  id: Scalars['Int']['input'];
};

export type UpdateCareerObjectivesInput = {
  personalStatement: Scalars['String']['input'];
};

export type UpdateCareerObjectivesPayload = {
  /** @deprecated Please use `viewer.careerObjectives.personalStatement` instead */
  personalStatement: Scalars['String']['output'];
  viewer: Maybe<Candidate>;
};

export type UpdateClassificationInput = {
  classification: ClassificationInput;
};

export type UpdateCurrentLocation2Error = {
  message: Scalars['String']['output'];
};


export type UpdateCurrentLocation2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateCurrentLocation2Failure = {
  error: UpdateCurrentLocation2Error;
};

export type UpdateCurrentLocation2Input = {
  currentLocation: CurrentLocation2Input;
};

export type UpdateCurrentLocation2Payload = UpdateCurrentLocation2Success | UpdateCurrentLocation2Failure;

export type UpdateCurrentLocation2Success = {
  viewer: Maybe<Candidate>;
};

export type UpdateLanguageProficiencyInput = {
  id: Scalars['UUID']['input'];
  name: OntologyStructuredDataInput;
};

export type UpdateLanguageProficiencyPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateLicenceInput = {
  id: Scalars['UUID']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  expiryDate: InputMaybe<MonthYearInput>;
  issueDate: InputMaybe<MonthYearInput>;
  issuingOrganisation: InputMaybe<Scalars['String']['input']>;
  name: OntologyStructuredDataInput;
  noExpiryDate: Scalars['Boolean']['input'];
};

export type UpdateLicencePayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateMarketInsightsPreferencesConflictError = UpdateMarketInsightsPreferencesError & {
  message: Scalars['String']['output'];
};


export type UpdateMarketInsightsPreferencesConflictErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateMarketInsightsPreferencesError = {
  message: Scalars['String']['output'];
};


export type UpdateMarketInsightsPreferencesErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateMarketInsightsPreferencesFailure = {
  error: UpdateMarketInsightsPreferencesError;
};

export type UpdateMarketInsightsPreferencesInput = {
  role: CareerFeedInsightsRoleInput;
  location: CareerFeedInsightsLocationInput;
};

export type UpdateMarketInsightsPreferencesPayload = UpdateMarketInsightsPreferencesSuccess | UpdateMarketInsightsPreferencesFailure;

export type UpdateMarketInsightsPreferencesSuccess = {
  message: Scalars['String']['output'];
};

export type UpdateMarketInsightsPreferencesValidationError = UpdateMarketInsightsPreferencesError & {
  message: Scalars['String']['output'];
};


export type UpdateMarketInsightsPreferencesValidationErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateNoticePeriodInput = {
  weeks: Scalars['Int']['input'];
};

export type UpdateNoticePeriodPayload = {
  /** @deprecated Use viewer.noticePeriod */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type UpdateNotificationCtpPreferenceError = NotificationCtpPreferenceError & {
  message: Scalars['String']['output'];
  errorCode: Maybe<Scalars['Int']['output']>;
};


export type UpdateNotificationCtpPreferenceErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateNotificationCtpPreferenceFailure = {
  error: NotificationCtpPreferenceError;
};

export type UpdateNotificationCtpPreferenceInput = {
  onlyProductionOption: Scalars['Boolean']['input'];
  preferences: Array<NotificationCtpPreferencesInput>;
  zone: Scalars['Zone']['input'];
};

export type UpdateNotificationCtpPreferencesPayload = UpdateNotificationCtpPreferencesSuccess | UpdateNotificationCtpPreferenceFailure;

export type UpdateNotificationCtpPreferencesSuccess = {
  success: Array<NotificationCtpPreferenceGroup>;
};

export type UpdateNotificationCtpSubscriptionWithTokenPayload = UpdateNotificationCtpSubscriptionWithTokenSuccess | UpdateNotificationCtpPreferenceFailure;

export type UpdateNotificationCtpSubscriptionWithTokenSuccess = {
  product: NotificationCtpProduct;
  subscriptionChannel: NotificationCtpChannel;
  subscribed: Scalars['Boolean']['output'];
};

export type UpdatePersonalDetailsInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  /** *Note*: Nationality will be phased out as part of unification. Currently kept to support functionalies in SEEK Asia platforms. */
  nationality: InputMaybe<NationalityInput>;
  countryCallingCode: InputMaybe<CountryCallingCodeInput>;
};

export type UpdatePersonalDetailsPayload = {
  /** @deprecated use viewer.personalDetails instead */
  personalDetails: PersonalDetails;
  viewer: Maybe<Candidate>;
};

export type UpdatePreferredClassificationPayload = {
  /** @deprecated Use viewer.preferredClassification */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type UpdatePreferredLocations2Error = {
  message: Scalars['String']['output'];
};


export type UpdatePreferredLocations2ErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdatePreferredLocations2Failure = {
  error: UpdatePreferredLocations2Error;
};

export type UpdatePreferredLocations2Input = {
  preferredLocations: Array<PreferredLocation2Input>;
};

export type UpdatePreferredLocations2Payload = UpdatePreferredLocations2Success | UpdatePreferredLocations2Failure;

export type UpdatePreferredLocations2Success = {
  viewer: Maybe<Candidate>;
};

export type UpdatePreferredRoleTitlesError = {
  message: Scalars['String']['output'];
};


export type UpdatePreferredRoleTitlesErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type UpdatePreferredRoleTitlesFailure = {
  errors: Array<UpdatePreferredRoleTitlesError>;
};

export type UpdatePreferredRoleTitlesInput = {
  preferredRoleTitles: Array<OntologyStructuredDataInput>;
};

export type UpdatePreferredRoleTitlesPayload = UpdatePreferredRoleTitlesSuccess | UpdatePreferredRoleTitlesFailure;

export type UpdatePreferredRoleTitlesSuccess = {
  preferredRoleTitles: Array<OntologyStructuredData>;
};

export type UpdatePreferredWorkTypesInput = {
  ids: Array<Scalars['Int']['input']>;
};

export type UpdateProfileVisibility2Failure = {
  error: UpdateProfileVisibilityError;
};

export type UpdateProfileVisibility2Input = {
  id: Scalars['ProfileVisibilityLevel']['input'];
};

export type UpdateProfileVisibility2Payload = UpdateProfileVisibility2Success | UpdateProfileVisibility2Failure;

export type UpdateProfileVisibility2Success = {
  viewer: Maybe<Candidate>;
};

export type UpdateProfileVisibilityError = {
  message: Scalars['String']['output'];
};


export type UpdateProfileVisibilityErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type UpdateProfileVisibilityInput = {
  level: VisibilityLevel;
};

export type UpdateProfileVisibilityPayload = {
  /** @deprecated Use viewer.profileVisibility */
  ref: Maybe<Scalars['String']['output']>;
  viewer: Maybe<Candidate>;
};

export type UpdateQualificationInput = {
  id: Scalars['UUID']['input'];
  name: OntologyStructuredDataInput;
  institute: OntologyStructuredDataInput;
  completed: Scalars['Boolean']['input'];
  completionYear: InputMaybe<Scalars['Int']['input']>;
  expectedCompletionDate: InputMaybe<MonthYearInput>;
  highlights: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQualificationPayload = {
  /**
   * qualification does not have translation support due to it being deprecated
   * @deprecated Use `viewer.qualification`
   */
  qualification: Maybe<Qualification>;
  viewer: Maybe<Candidate>;
};

export type UpdateRightToWorkInput = {
  /** Unique ID that identifies a specific right to work */
  id: Scalars['UUID']['input'];
  /** Country associated with the right to work */
  countryCode: Scalars['CountryCodeIso2']['input'];
  /** Candidate's right to work for a specific country */
  type2: InputMaybe<RightToWorkType2Input>;
};

export type UpdateRightsToWorkInput = {
  /** List of rights to work to update */
  rightsToWork: Array<UpdateRightToWorkInput>;
};

export type UpdateRightsToWorkPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateRoleInput = {
  id: Scalars['UUID']['input'];
  title: OntologyStructuredDataInput;
  seniority: InputMaybe<OntologyStructuredDataInput>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  to: InputMaybe<MonthYearInput>;
  /** Required for JobsDB only */
  function: InputMaybe<RoleFunctionInput>;
  /** Required for JobsDB only */
  industry: InputMaybe<RoleIndustryInput>;
  achievements: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRolePayload = {
  /** @deprecated Use viewer.roles */
  role: Maybe<Role>;
  viewer: Maybe<Candidate>;
};

export type UpdateSalaryPreferencesInput = {
  /** List of salary preferences to update */
  salaryPreferences: Array<SalaryPreference2Input>;
};

export type UpdateSalaryPreferencesPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateSeekMaxMyThreadsLastViewedError = {
  message: Scalars['String']['output'];
};


export type UpdateSeekMaxMyThreadsLastViewedErrorMessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type UpdateSeekMaxMyThreadsLastViewedFailure = {
  errors: Array<UpdateSeekMaxMyThreadsLastViewedError>;
};

export type UpdateSeekMaxMyThreadsLastViewedInput = {
  zone: Scalars['Zone']['input'];
};

export type UpdateSeekMaxMyThreadsLastViewedPayload = UpdateSeekMaxMyThreadsLastViewedSuccess | UpdateSeekMaxMyThreadsLastViewedFailure;

export type UpdateSeekMaxMyThreadsLastViewedSuccess = {
  success: Scalars['Boolean']['output'];
};

export type UpdateShareableProfileSettingsError = {
  message: Scalars['String']['output'];
};


export type UpdateShareableProfileSettingsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateShareableProfileSettingsFailure = {
  error: UpdateShareableProfileSettingsError;
};

export type UpdateShareableProfileSettingsInput = {
  active: Scalars['Boolean']['input'];
  privacy: InputMaybe<PrivacyInput>;
};

export type UpdateShareableProfileSettingsPayload = UpdateShareableProfileSettingsSuccess | UpdateShareableProfileSettingsFailure;

export type UpdateShareableProfileSettingsSuccess = {
  viewer: Maybe<Candidate>;
};

export type UpdateShareableProfileViewsError = {
  message: Scalars['String']['output'];
};


export type UpdateShareableProfileViewsErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateShareableProfileViewsFailure = {
  error: UpdateShareableProfileViewsError;
};

export type UpdateShareableProfileViewsInput = {
  profileSlug: Scalars['String']['input'];
};

export type UpdateShareableProfileViewsPayload = UpdateShareableProfileViewsSuccess | UpdateShareableProfileViewsFailure;

export type UpdateShareableProfileViewsSuccess = {
  ref: Scalars['UUID']['output'];
};

export type UpdateSkillsInput = {
  skills: Array<SkillInput>;
};

export type UpdateSkillsPayload = {
  /** @deprecated Use `viewer.skills` instead */
  skills: Maybe<Array<Skill>>;
  viewer: Maybe<Candidate>;
};

export type UpdateVerifiedLicenceInput = {
  id: Scalars['UUID']['input'];
  description: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVerifiedLicencePayload = {
  id: Scalars['UUID']['output'];
  description: Maybe<Scalars['String']['output']>;
};

export type UpdateVerifiedQualificationInput = {
  id: Scalars['UUID']['input'];
  highlights: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVerifiedQualificationPayload = {
  viewer: Maybe<Candidate>;
};

export type UpdateWorkTypesPayload = {
  /** @deprecated Use viewer.workTypes */
  ref: Maybe<Scalars['UUID']['output']>;
  viewer: Maybe<Candidate>;
};

export type UpdateYearsOfExperienceInput = {
  id: InputMaybe<Scalars['ID']['input']>;
  newToWorkforce: Scalars['Boolean']['input'];
};

export type UpdateYearsOfExperiencePayload = {
  viewer: Maybe<Candidate>;
};

export type Upvotes = {
  count: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  userIds: Maybe<Array<Scalars['String']['output']>>;
};


export type UpvotesDescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type UrgentJobDisplayTag = JobDisplayTag & {
  label: Scalars['String']['output'];
};


export type UrgentJobDisplayTagLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type UserCookie = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VerifiableCredential = {
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type VerifiableCredentialCategory = {
  label: Scalars['String']['output'];
  credentials: Maybe<Array<BaseVerifiableCredential>>;
  pendingCount: Maybe<Scalars['Int']['output']>;
};

export type VerifiableCredentialGroup = {
  label: Scalars['String']['output'];
  credentials: Array<VerifiableCredential>;
};

export type VerifiableCredentialNudge = {
  credential: VerifiableCredential;
};

export type VerifiableCredentialNudge2 = {
  credential: BaseVerifiableCredential;
};

export type VerificationNudge = {
  /** uri may be an empty string as Digital ID nudges do not have a uri. */
  uri: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  verificationType: Array<Scalars['String']['output']>;
};

export type Verifications = {
  nudge: Maybe<VerificationsNudge>;
  verified: Array<VerifiedCredentialGroup>;
  verifiable: Array<VerifiableCredentialGroup>;
  pending: Maybe<Array<PendingCredentialGroup>>;
};

export type VerificationsNudge = VerificationsOpenDetailsNudge | VerifiableCredentialNudge;

export type VerificationsNudge2 = VerificationsOpenDetailsNudge | VerifiableCredentialNudge2;

export type VerificationsOpenDetailsNudge = {
  ref: Scalars['UUID']['output'];
};

export enum VerificationsTestVariant {
  Verifiedworkemail = 'VERIFIEDWORKEMAIL',
  Identity = 'IDENTITY',
  Opendetails = 'OPENDETAILS'
}

export type VerifiedCredential = {
  label: Scalars['String']['output'];
  credentialInfo: Array<CredentialInfo>;
};

export type VerifiedCredential2 = {
  label: Scalars['String']['output'];
  /** String to indicate the type of credential used for frontend tracking, e.g. identity, workplace */
  credentialType: Scalars['String']['output'];
  credentialInfo: Array<CredentialInfo>;
  expiryStatus: Maybe<CredentialExpiryStatus>;
};

export type VerifiedCredentialCategory = {
  label: Scalars['String']['output'];
  credentials: Maybe<Array<VerifiedCredential2>>;
};

export type VerifiedCredentialGroup = {
  label: Scalars['String']['output'];
  credentials: Array<VerifiedCredential>;
};

export type VerifiedIdentity = {
  name: Maybe<Scalars['String']['output']>;
  /** @deprecated use name */
  label: Maybe<Scalars['String']['output']>;
  verificationUrl: Maybe<Scalars['String']['output']>;
  manageVerificationUrl: Maybe<Scalars['String']['output']>;
  isMatchingProfileName: Maybe<Scalars['Boolean']['output']>;
};

export type VerifiedPublicProfileEducation = PublicProfileEducation & {
  /** The name of the educational qualification */
  name: Scalars['String']['output'];
};

export type VerifiedPublicProfileLicence = PublicProfileLicence & {
  /** The name of the licence */
  name: Scalars['String']['output'];
};

export type VideoProduct = {
  url: Scalars['String']['output'];
  position: VideoProductPosition;
};

export enum VideoProductPosition {
  Top = 'TOP',
  Bottom = 'BOTTOM'
}

export enum VirusScanStatus {
  Pending = 'Pending',
  Ok = 'OK',
  HasVirus = 'HasVirus',
  Unknown = 'Unknown'
}

export enum VisibilityLevel {
  Hidden = 'Hidden',
  Standard = 'Standard',
  Limited = 'Limited'
}

export type VisitorContextInput = {
  /** visitorId from client */
  key: Scalars['UUID']['input'];
};

export type Website = {
  url: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

export type WorkArrangementOption = {
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};


export type WorkArrangementOptionLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type WorkType = {
  id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export type WorkTypeTaxonomyOption = {
  /** Unique ID used to identify a specific work type option */
  id: Scalars['Int']['output'];
  /** Human readable string used when the user is selecting a work type option. */
  description: Scalars['String']['output'];
};

export type WorkplaceVerifiableCredential = BaseVerifiableCredential & {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WrongPasswordError = I18nAccountError & {
  message: Scalars['String']['output'];
  code: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};


export type WrongPasswordErrorMessageArgs = {
  locale: InputMaybe<Scalars['Locale']['input']>;
};

export type Year = {
  year: Scalars['Int']['output'];
};

/**
 * DEPRECATED: This entire years-of-experience module is deprecated and will be removed in future releases.
 * It is no longer used in production after unification.
 */
export type YearsOfExperience = {
  /**
   * The years of experience option chosen by the candidate
   * @deprecated No longer used in production after unification.
   */
  option: Maybe<YearsOfExperienceOption>;
  /**
   * Whether or not the candidate is new to the workforce
   * @deprecated No longer used in production after unification.
   */
  newToWorkforce: Scalars['Boolean']['output'];
};

export type YearsOfExperienceOption = {
  /** @deprecated No longer used in production after unification. */
  id: Scalars['ID']['output'];
  /** @deprecated No longer used in production after unification. */
  description: Scalars['String']['output'];
};
